var Rd = Object.defineProperty;
var Od = (e, n, t) => n in e ? Rd(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var te = (e, n, t) => Od(e, typeof n != "symbol" ? n + "" : n, t);
import { QueryClient as Ed, setupBankExtension as Fr, setupStakingExtension as Lr, setupDistributionExtension as Gr, createProtobufRpcClient as Jd, AminoTypes as Id } from "@cosmjs/stargate";
import { Tendermint34Client as Cd } from "@cosmjs/tendermint-rpc";
import { Registry as Ud } from "@cosmjs/proto-signing";
function Hd() {
  let e = 0, n = 0;
  for (let i = 0; i < 28; i += 7) {
    let s = this.buf[this.pos++];
    if (e |= (s & 127) << i, (s & 128) == 0)
      return this.assertBounds(), [e, n];
  }
  let t = this.buf[this.pos++];
  if (e |= (t & 15) << 28, n = (t & 112) >> 4, (t & 128) == 0)
    return this.assertBounds(), [e, n];
  for (let i = 3; i <= 31; i += 7) {
    let s = this.buf[this.pos++];
    if (n |= (s & 127) << i, (s & 128) == 0)
      return this.assertBounds(), [e, n];
  }
  throw new Error("invalid varint");
}
function Gn(e, n, t) {
  for (let o = 0; o < 28; o = o + 7) {
    const r = e >>> o, p = !(!(r >>> 7) && n == 0), y = (p ? r | 128 : r) & 255;
    if (t.push(y), !p)
      return;
  }
  const i = e >>> 28 & 15 | (n & 7) << 4, s = n >> 3 != 0;
  if (t.push((s ? i | 128 : i) & 255), !!s) {
    for (let o = 3; o < 31; o = o + 7) {
      const r = n >>> o, p = !!(r >>> 7), y = (p ? r | 128 : r) & 255;
      if (t.push(y), !p)
        return;
    }
    t.push(n >>> 31 & 1);
  }
}
const On = 4294967296;
function Wr(e) {
  const n = e[0] === "-";
  n && (e = e.slice(1));
  const t = 1e6;
  let i = 0, s = 0;
  function o(r, p) {
    const y = Number(e.slice(r, p));
    s *= t, i = i * t + y, i >= On && (s = s + (i / On | 0), i = i % On);
  }
  return o(-24, -18), o(-18, -12), o(-12, -6), o(-6), n ? Ra(i, s) : rt(i, s);
}
function Md(e, n) {
  let t = rt(e, n);
  const i = t.hi & 2147483648;
  i && (t = Ra(t.lo, t.hi));
  const s = Ba(t.lo, t.hi);
  return i ? "-" + s : s;
}
function Ba(e, n) {
  if ({ lo: e, hi: n } = Vd(e, n), n <= 2097151)
    return String(On * n + e);
  const t = e & 16777215, i = (e >>> 24 | n << 8) & 16777215, s = n >> 16 & 65535;
  let o = t + i * 6777216 + s * 6710656, r = i + s * 8147497, p = s * 2;
  const y = 1e7;
  return o >= y && (r += Math.floor(o / y), o %= y), r >= y && (p += Math.floor(r / y), r %= y), p.toString() + $r(r) + $r(o);
}
function Vd(e, n) {
  return { lo: e >>> 0, hi: n >>> 0 };
}
function rt(e, n) {
  return { lo: e | 0, hi: n | 0 };
}
function Ra(e, n) {
  return n = ~n, e ? e = ~e + 1 : n += 1, rt(e, n);
}
const $r = (e) => {
  const n = String(e);
  return "0000000".slice(n.length) + n;
};
function Qr(e, n) {
  if (e >= 0) {
    for (; e > 127; )
      n.push(e & 127 | 128), e = e >>> 7;
    n.push(e);
  } else {
    for (let t = 0; t < 9; t++)
      n.push(e & 127 | 128), e = e >> 7;
    n.push(1);
  }
}
function Fd() {
  let e = this.buf[this.pos++], n = e & 127;
  if ((e & 128) == 0)
    return this.assertBounds(), n;
  if (e = this.buf[this.pos++], n |= (e & 127) << 7, (e & 128) == 0)
    return this.assertBounds(), n;
  if (e = this.buf[this.pos++], n |= (e & 127) << 14, (e & 128) == 0)
    return this.assertBounds(), n;
  if (e = this.buf[this.pos++], n |= (e & 127) << 21, (e & 128) == 0)
    return this.assertBounds(), n;
  e = this.buf[this.pos++], n |= (e & 15) << 28;
  for (let t = 5; (e & 128) !== 0 && t < 10; t++)
    e = this.buf[this.pos++];
  if ((e & 128) != 0)
    throw new Error("invalid varint");
  return this.assertBounds(), n >>> 0;
}
const we = /* @__PURE__ */ Ld();
function Ld() {
  const e = new DataView(new ArrayBuffer(8));
  if (typeof BigInt == "function" && typeof e.getBigInt64 == "function" && typeof e.getBigUint64 == "function" && typeof e.setBigInt64 == "function" && typeof e.setBigUint64 == "function" && (typeof process != "object" || typeof process.env != "object" || process.env.BUF_BIGINT_DISABLE !== "1")) {
    const t = BigInt("-9223372036854775808"), i = BigInt("9223372036854775807"), s = BigInt("0"), o = BigInt("18446744073709551615");
    return {
      zero: BigInt(0),
      supported: !0,
      parse(r) {
        const p = typeof r == "bigint" ? r : BigInt(r);
        if (p > i || p < t)
          throw new Error(`invalid int64: ${r}`);
        return p;
      },
      uParse(r) {
        const p = typeof r == "bigint" ? r : BigInt(r);
        if (p > o || p < s)
          throw new Error(`invalid uint64: ${r}`);
        return p;
      },
      enc(r) {
        return e.setBigInt64(0, this.parse(r), !0), {
          lo: e.getInt32(0, !0),
          hi: e.getInt32(4, !0)
        };
      },
      uEnc(r) {
        return e.setBigInt64(0, this.uParse(r), !0), {
          lo: e.getInt32(0, !0),
          hi: e.getInt32(4, !0)
        };
      },
      dec(r, p) {
        return e.setInt32(0, r, !0), e.setInt32(4, p, !0), e.getBigInt64(0, !0);
      },
      uDec(r, p) {
        return e.setInt32(0, r, !0), e.setInt32(4, p, !0), e.getBigUint64(0, !0);
      }
    };
  }
  return {
    zero: "0",
    supported: !1,
    parse(t) {
      return typeof t != "string" && (t = t.toString()), qr(t), t;
    },
    uParse(t) {
      return typeof t != "string" && (t = t.toString()), Xr(t), t;
    },
    enc(t) {
      return typeof t != "string" && (t = t.toString()), qr(t), Wr(t);
    },
    uEnc(t) {
      return typeof t != "string" && (t = t.toString()), Xr(t), Wr(t);
    },
    dec(t, i) {
      return Md(t, i);
    },
    uDec(t, i) {
      return Ba(t, i);
    }
  };
}
function qr(e) {
  if (!/^-?[0-9]+$/.test(e))
    throw new Error("invalid int64: " + e);
}
function Xr(e) {
  if (!/^[0-9]+$/.test(e))
    throw new Error("invalid uint64: " + e);
}
const Wn = Symbol.for("@bufbuild/protobuf/text-encoding");
function Oa() {
  if (globalThis[Wn] == null) {
    const e = new globalThis.TextEncoder(), n = new globalThis.TextDecoder();
    globalThis[Wn] = {
      encodeUtf8(t) {
        return e.encode(t);
      },
      decodeUtf8(t) {
        return n.decode(t);
      },
      checkUtf8(t) {
        try {
          return encodeURIComponent(t), !0;
        } catch {
          return !1;
        }
      }
    };
  }
  return globalThis[Wn];
}
var Be;
(function(e) {
  e[e.Varint = 0] = "Varint", e[e.Bit64 = 1] = "Bit64", e[e.LengthDelimited = 2] = "LengthDelimited", e[e.StartGroup = 3] = "StartGroup", e[e.EndGroup = 4] = "EndGroup", e[e.Bit32 = 5] = "Bit32";
})(Be || (Be = {}));
const Gd = 34028234663852886e22, Wd = -34028234663852886e22, $d = 4294967295, Qd = 2147483647, qd = -2147483648;
class g {
  constructor(n = Oa().encodeUtf8) {
    this.encodeUtf8 = n, this.stack = [], this.chunks = [], this.buf = [];
  }
  /**
   * Return all bytes written and reset this writer.
   */
  finish() {
    this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []);
    let n = 0;
    for (let s = 0; s < this.chunks.length; s++)
      n += this.chunks[s].length;
    let t = new Uint8Array(n), i = 0;
    for (let s = 0; s < this.chunks.length; s++)
      t.set(this.chunks[s], i), i += this.chunks[s].length;
    return this.chunks = [], t;
  }
  /**
   * Start a new fork for length-delimited data like a message
   * or a packed repeated field.
   *
   * Must be joined later with `join()`.
   */
  fork() {
    return this.stack.push({ chunks: this.chunks, buf: this.buf }), this.chunks = [], this.buf = [], this;
  }
  /**
   * Join the last fork. Write its length and bytes, then
   * return to the previous state.
   */
  join() {
    let n = this.finish(), t = this.stack.pop();
    if (!t)
      throw new Error("invalid state, fork stack empty");
    return this.chunks = t.chunks, this.buf = t.buf, this.uint32(n.byteLength), this.raw(n);
  }
  /**
   * Writes a tag (field number and wire type).
   *
   * Equivalent to `uint32( (fieldNo << 3 | type) >>> 0 )`.
   *
   * Generated code should compute the tag ahead of time and call `uint32()`.
   */
  tag(n, t) {
    return this.uint32((n << 3 | t) >>> 0);
  }
  /**
   * Write a chunk of raw bytes.
   */
  raw(n) {
    return this.buf.length && (this.chunks.push(new Uint8Array(this.buf)), this.buf = []), this.chunks.push(n), this;
  }
  /**
   * Write a `uint32` value, an unsigned 32 bit varint.
   */
  uint32(n) {
    for (Kr(n); n > 127; )
      this.buf.push(n & 127 | 128), n = n >>> 7;
    return this.buf.push(n), this;
  }
  /**
   * Write a `int32` value, a signed 32 bit varint.
   */
  int32(n) {
    return $n(n), Qr(n, this.buf), this;
  }
  /**
   * Write a `bool` value, a variant.
   */
  bool(n) {
    return this.buf.push(n ? 1 : 0), this;
  }
  /**
   * Write a `bytes` value, length-delimited arbitrary data.
   */
  bytes(n) {
    return this.uint32(n.byteLength), this.raw(n);
  }
  /**
   * Write a `string` value, length-delimited data converted to UTF-8 text.
   */
  string(n) {
    let t = this.encodeUtf8(n);
    return this.uint32(t.byteLength), this.raw(t);
  }
  /**
   * Write a `float` value, 32-bit floating point number.
   */
  float(n) {
    Xd(n);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setFloat32(0, n, !0), this.raw(t);
  }
  /**
   * Write a `double` value, a 64-bit floating point number.
   */
  double(n) {
    let t = new Uint8Array(8);
    return new DataView(t.buffer).setFloat64(0, n, !0), this.raw(t);
  }
  /**
   * Write a `fixed32` value, an unsigned, fixed-length 32-bit integer.
   */
  fixed32(n) {
    Kr(n);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setUint32(0, n, !0), this.raw(t);
  }
  /**
   * Write a `sfixed32` value, a signed, fixed-length 32-bit integer.
   */
  sfixed32(n) {
    $n(n);
    let t = new Uint8Array(4);
    return new DataView(t.buffer).setInt32(0, n, !0), this.raw(t);
  }
  /**
   * Write a `sint32` value, a signed, zigzag-encoded 32-bit varint.
   */
  sint32(n) {
    return $n(n), n = (n << 1 ^ n >> 31) >>> 0, Qr(n, this.buf), this;
  }
  /**
   * Write a `fixed64` value, a signed, fixed-length 64-bit integer.
   */
  sfixed64(n) {
    let t = new Uint8Array(8), i = new DataView(t.buffer), s = we.enc(n);
    return i.setInt32(0, s.lo, !0), i.setInt32(4, s.hi, !0), this.raw(t);
  }
  /**
   * Write a `fixed64` value, an unsigned, fixed-length 64 bit integer.
   */
  fixed64(n) {
    let t = new Uint8Array(8), i = new DataView(t.buffer), s = we.uEnc(n);
    return i.setInt32(0, s.lo, !0), i.setInt32(4, s.hi, !0), this.raw(t);
  }
  /**
   * Write a `int64` value, a signed 64-bit varint.
   */
  int64(n) {
    let t = we.enc(n);
    return Gn(t.lo, t.hi, this.buf), this;
  }
  /**
   * Write a `sint64` value, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64(n) {
    let t = we.enc(n), i = t.hi >> 31, s = t.lo << 1 ^ i, o = (t.hi << 1 | t.lo >>> 31) ^ i;
    return Gn(s, o, this.buf), this;
  }
  /**
   * Write a `uint64` value, an unsigned 64-bit varint.
   */
  uint64(n) {
    let t = we.uEnc(n);
    return Gn(t.lo, t.hi, this.buf), this;
  }
}
class a {
  constructor(n, t = Oa().decodeUtf8) {
    this.decodeUtf8 = t, this.varint64 = Hd, this.uint32 = Fd, this.buf = n, this.len = n.length, this.pos = 0, this.view = new DataView(n.buffer, n.byteOffset, n.byteLength);
  }
  /**
   * Reads a tag - field number and wire type.
   */
  tag() {
    let n = this.uint32(), t = n >>> 3, i = n & 7;
    if (t <= 0 || i < 0 || i > 5)
      throw new Error("illegal tag: field no " + t + " wire type " + i);
    return [t, i];
  }
  /**
   * Skip one element and return the skipped data.
   *
   * When skipping StartGroup, provide the tags field number to check for
   * matching field number in the EndGroup tag.
   */
  skip(n, t) {
    let i = this.pos;
    switch (n) {
      case Be.Varint:
        for (; this.buf[this.pos++] & 128; )
          ;
        break;
      // eslint-disable-next-line
      // @ts-expect-error TS7029: Fallthrough case in switch
      case Be.Bit64:
        this.pos += 4;
      // eslint-disable-next-line no-fallthrough
      case Be.Bit32:
        this.pos += 4;
        break;
      case Be.LengthDelimited:
        let s = this.uint32();
        this.pos += s;
        break;
      case Be.StartGroup:
        for (; ; ) {
          const [o, r] = this.tag();
          if (r === Be.EndGroup) {
            if (t !== void 0 && o !== t)
              throw new Error("invalid end group tag");
            break;
          }
          this.skip(r, o);
        }
        break;
      default:
        throw new Error("cant skip wire type " + n);
    }
    return this.assertBounds(), this.buf.subarray(i, this.pos);
  }
  /**
   * Throws error if position in byte array is out of range.
   */
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  /**
   * Read a `int32` field, a signed 32 bit varint.
   */
  int32() {
    return this.uint32() | 0;
  }
  /**
   * Read a `sint32` field, a signed, zigzag-encoded 32-bit varint.
   */
  sint32() {
    let n = this.uint32();
    return n >>> 1 ^ -(n & 1);
  }
  /**
   * Read a `int64` field, a signed 64-bit varint.
   */
  int64() {
    return we.dec(...this.varint64());
  }
  /**
   * Read a `uint64` field, an unsigned 64-bit varint.
   */
  uint64() {
    return we.uDec(...this.varint64());
  }
  /**
   * Read a `sint64` field, a signed, zig-zag-encoded 64-bit varint.
   */
  sint64() {
    let [n, t] = this.varint64(), i = -(n & 1);
    return n = (n >>> 1 | (t & 1) << 31) ^ i, t = t >>> 1 ^ i, we.dec(n, t);
  }
  /**
   * Read a `bool` field, a variant.
   */
  bool() {
    let [n, t] = this.varint64();
    return n !== 0 || t !== 0;
  }
  /**
   * Read a `fixed32` field, an unsigned, fixed-length 32-bit integer.
   */
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `sfixed32` field, a signed, fixed-length 32-bit integer.
   */
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `fixed64` field, an unsigned, fixed-length 64 bit integer.
   */
  fixed64() {
    return we.uDec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `fixed64` field, a signed, fixed-length 64-bit integer.
   */
  sfixed64() {
    return we.dec(this.sfixed32(), this.sfixed32());
  }
  /**
   * Read a `float` field, 32-bit floating point number.
   */
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, !0);
  }
  /**
   * Read a `double` field, a 64-bit floating point number.
   */
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, !0);
  }
  /**
   * Read a `bytes` field, length-delimited arbitrary data.
   */
  bytes() {
    let n = this.uint32(), t = this.pos;
    return this.pos += n, this.assertBounds(), this.buf.subarray(t, t + n);
  }
  /**
   * Read a `string` field, length-delimited data converted to UTF-8 text.
   */
  string() {
    return this.decodeUtf8(this.bytes());
  }
}
function $n(e) {
  if (typeof e == "string")
    e = Number(e);
  else if (typeof e != "number")
    throw new Error("invalid int32: " + typeof e);
  if (!Number.isInteger(e) || e > Qd || e < qd)
    throw new Error("invalid int32: " + e);
}
function Kr(e) {
  if (typeof e == "string")
    e = Number(e);
  else if (typeof e != "number")
    throw new Error("invalid uint32: " + typeof e);
  if (!Number.isInteger(e) || e > $d || e < 0)
    throw new Error("invalid uint32: " + e);
}
function Xd(e) {
  if (typeof e == "string") {
    const n = e;
    if (e = Number(e), isNaN(e) && n !== "NaN")
      throw new Error("invalid float32: " + n);
  } else if (typeof e != "number")
    throw new Error("invalid float32: " + typeof e);
  if (Number.isFinite(e) && (e > Gd || e < Wd))
    throw new Error("invalid float32: " + e);
}
const Kd = "babylon.btccheckpoint.v1";
var Ea = /* @__PURE__ */ ((e) => (e[e.EPOCH_STATUS_SUBMITTED = 0] = "EPOCH_STATUS_SUBMITTED", e[e.EPOCH_STATUS_CONFIRMED = 1] = "EPOCH_STATUS_CONFIRMED", e[e.EPOCH_STATUS_FINALIZED = 2] = "EPOCH_STATUS_FINALIZED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED", e))(Ea || {});
function Ja(e) {
  switch (e) {
    case 0:
    case "EPOCH_STATUS_SUBMITTED":
      return 0;
    case 1:
    case "EPOCH_STATUS_CONFIRMED":
      return 1;
    case 2:
    case "EPOCH_STATUS_FINALIZED":
      return 2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function Ia(e) {
  switch (e) {
    case 0:
      return "EPOCH_STATUS_SUBMITTED";
    case 1:
      return "EPOCH_STATUS_CONFIRMED";
    case 2:
      return "EPOCH_STATUS_FINALIZED";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function Zr() {
  return {
    btcTransaction: new Uint8Array(0),
    btcTransactionIndex: 0,
    merkleNodes: new Uint8Array(0),
    confirmingBtcHeader: new Uint8Array(0)
  };
}
const Ca = {
  encode(e, n = new g()) {
    return e.btcTransaction.length !== 0 && n.uint32(10).bytes(e.btcTransaction), e.btcTransactionIndex !== 0 && n.uint32(16).uint32(e.btcTransactionIndex), e.merkleNodes.length !== 0 && n.uint32(26).bytes(e.merkleNodes), e.confirmingBtcHeader.length !== 0 && n.uint32(34).bytes(e.confirmingBtcHeader), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Zr();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.btcTransaction = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.btcTransactionIndex = t.uint32();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.merkleNodes = t.bytes();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.confirmingBtcHeader = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      btcTransaction: W(e.btcTransaction) ? ue(e.btcTransaction) : W(e.btc_transaction) ? ue(e.btc_transaction) : new Uint8Array(0),
      btcTransactionIndex: W(e.btcTransactionIndex) ? globalThis.Number(e.btcTransactionIndex) : W(e.btc_transaction_index) ? globalThis.Number(e.btc_transaction_index) : 0,
      merkleNodes: W(e.merkleNodes) ? ue(e.merkleNodes) : W(e.merkle_nodes) ? ue(e.merkle_nodes) : new Uint8Array(0),
      confirmingBtcHeader: W(e.confirmingBtcHeader) ? ue(e.confirmingBtcHeader) : W(e.confirming_btc_header) ? ue(e.confirming_btc_header) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.btcTransaction.length !== 0 && (n.btcTransaction = xe(e.btcTransaction)), e.btcTransactionIndex !== 0 && (n.btcTransactionIndex = Math.round(e.btcTransactionIndex)), e.merkleNodes.length !== 0 && (n.merkleNodes = xe(e.merkleNodes)), e.confirmingBtcHeader.length !== 0 && (n.confirmingBtcHeader = xe(e.confirmingBtcHeader)), n;
  },
  create(e) {
    return Ca.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Zr();
    return n.btcTransaction = e.btcTransaction ?? new Uint8Array(0), n.btcTransactionIndex = e.btcTransactionIndex ?? 0, n.merkleNodes = e.merkleNodes ?? new Uint8Array(0), n.confirmingBtcHeader = e.confirmingBtcHeader ?? new Uint8Array(0), n;
  }
};
function zr() {
  return { index: 0, hash: new Uint8Array(0) };
}
const z = {
  encode(e, n = new g()) {
    return e.index !== 0 && n.uint32(8).uint32(e.index), e.hash.length !== 0 && n.uint32(18).bytes(e.hash), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = zr();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.index = t.uint32();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.hash = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      index: W(e.index) ? globalThis.Number(e.index) : 0,
      hash: W(e.hash) ? ue(e.hash) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.index !== 0 && (n.index = Math.round(e.index)), e.hash.length !== 0 && (n.hash = xe(e.hash)), n;
  },
  create(e) {
    return z.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = zr();
    return n.index = e.index ?? 0, n.hash = e.hash ?? new Uint8Array(0), n;
  }
};
function Yr() {
  return { key: [] };
}
const en = {
  encode(e, n = new g()) {
    for (const t of e.key)
      z.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Yr();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.key.push(z.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { key: globalThis.Array.isArray(e == null ? void 0 : e.key) ? e.key.map((n) => z.fromJSON(n)) : [] };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.key) != null && t.length && (n.key = e.key.map((i) => z.toJSON(i))), n;
  },
  create(e) {
    return en.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Yr();
    return n.key = ((t = e.key) == null ? void 0 : t.map((i) => z.fromPartial(i))) || [], n;
  }
};
function jr() {
  return { key: void 0, transaction: new Uint8Array(0), proof: new Uint8Array(0) };
}
const ie = {
  encode(e, n = new g()) {
    return e.key !== void 0 && z.encode(e.key, n.uint32(10).fork()).join(), e.transaction.length !== 0 && n.uint32(18).bytes(e.transaction), e.proof.length !== 0 && n.uint32(26).bytes(e.proof), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = jr();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.key = z.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.transaction = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.proof = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      key: W(e.key) ? z.fromJSON(e.key) : void 0,
      transaction: W(e.transaction) ? ue(e.transaction) : new Uint8Array(0),
      proof: W(e.proof) ? ue(e.proof) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = z.toJSON(e.key)), e.transaction.length !== 0 && (n.transaction = xe(e.transaction)), e.proof.length !== 0 && (n.proof = xe(e.proof)), n;
  },
  create(e) {
    return ie.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = jr();
    return n.key = e.key !== void 0 && e.key !== null ? z.fromPartial(e.key) : void 0, n.transaction = e.transaction ?? new Uint8Array(0), n.proof = e.proof ?? new Uint8Array(0), n;
  }
};
function ei() {
  return { vigilanteAddresses: void 0, txsInfo: [], epoch: 0 };
}
const Ua = {
  encode(e, n = new g()) {
    e.vigilanteAddresses !== void 0 && oe.encode(e.vigilanteAddresses, n.uint32(10).fork()).join();
    for (const t of e.txsInfo)
      ie.encode(t, n.uint32(18).fork()).join();
    return e.epoch !== 0 && n.uint32(24).uint64(e.epoch), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ei();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.vigilanteAddresses = oe.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.txsInfo.push(ie.decode(t, t.uint32()));
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.epoch = Va(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      vigilanteAddresses: W(e.vigilanteAddresses) ? oe.fromJSON(e.vigilanteAddresses) : W(e.vigilante_addresses) ? oe.fromJSON(e.vigilante_addresses) : void 0,
      txsInfo: globalThis.Array.isArray(e == null ? void 0 : e.txsInfo) ? e.txsInfo.map((n) => ie.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.txs_info) ? e.txs_info.map((n) => ie.fromJSON(n)) : [],
      epoch: W(e.epoch) ? globalThis.Number(e.epoch) : 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.vigilanteAddresses !== void 0 && (n.vigilanteAddresses = oe.toJSON(e.vigilanteAddresses)), (t = e.txsInfo) != null && t.length && (n.txsInfo = e.txsInfo.map((i) => ie.toJSON(i))), e.epoch !== 0 && (n.epoch = Math.round(e.epoch)), n;
  },
  create(e) {
    return Ua.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ei();
    return n.vigilanteAddresses = e.vigilanteAddresses !== void 0 && e.vigilanteAddresses !== null ? oe.fromPartial(e.vigilanteAddresses) : void 0, n.txsInfo = ((t = e.txsInfo) == null ? void 0 : t.map((i) => ie.fromPartial(i))) || [], n.epoch = e.epoch ?? 0, n;
  }
};
function ni() {
  return { keys: [], status: 0 };
}
const Ha = {
  encode(e, n = new g()) {
    for (const t of e.keys)
      en.encode(t, n.uint32(10).fork()).join();
    return e.status !== 0 && n.uint32(16).int32(e.status), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ni();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.keys.push(en.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.status = t.int32();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      keys: globalThis.Array.isArray(e == null ? void 0 : e.keys) ? e.keys.map((n) => en.fromJSON(n)) : [],
      status: W(e.status) ? Ja(e.status) : 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.keys) != null && t.length && (n.keys = e.keys.map((i) => en.toJSON(i))), e.status !== 0 && (n.status = Ia(e.status)), n;
  },
  create(e) {
    return Ha.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ni();
    return n.keys = ((t = e.keys) == null ? void 0 : t.map((i) => en.fromPartial(i))) || [], n.status = e.status ?? 0, n;
  }
};
function ti() {
  return { submitter: new Uint8Array(0), reporter: new Uint8Array(0) };
}
const oe = {
  encode(e, n = new g()) {
    return e.submitter.length !== 0 && n.uint32(10).bytes(e.submitter), e.reporter.length !== 0 && n.uint32(18).bytes(e.reporter), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ti();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.submitter = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.reporter = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      submitter: W(e.submitter) ? ue(e.submitter) : new Uint8Array(0),
      reporter: W(e.reporter) ? ue(e.reporter) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.submitter.length !== 0 && (n.submitter = xe(e.submitter)), e.reporter.length !== 0 && (n.reporter = xe(e.reporter)), n;
  },
  create(e) {
    return oe.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ti();
    return n.submitter = e.submitter ?? new Uint8Array(0), n.reporter = e.reporter ?? new Uint8Array(0), n;
  }
};
function ri() {
  return {
    epochNumber: 0,
    bestSubmissionBtcBlockHeight: 0,
    bestSubmissionBtcBlockHash: new Uint8Array(0),
    bestSubmissionTransactions: [],
    bestSubmissionVigilanteAddressList: []
  };
}
const Ma = {
  encode(e, n = new g()) {
    e.epochNumber !== 0 && n.uint32(8).uint64(e.epochNumber), e.bestSubmissionBtcBlockHeight !== 0 && n.uint32(16).uint32(e.bestSubmissionBtcBlockHeight), e.bestSubmissionBtcBlockHash.length !== 0 && n.uint32(26).bytes(e.bestSubmissionBtcBlockHash);
    for (const t of e.bestSubmissionTransactions)
      ie.encode(t, n.uint32(34).fork()).join();
    for (const t of e.bestSubmissionVigilanteAddressList)
      oe.encode(t, n.uint32(42).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ri();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochNumber = Va(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.bestSubmissionBtcBlockHeight = t.uint32();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.bestSubmissionBtcBlockHash = t.bytes();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.bestSubmissionTransactions.push(ie.decode(t, t.uint32()));
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.bestSubmissionVigilanteAddressList.push(oe.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochNumber: W(e.epochNumber) ? globalThis.Number(e.epochNumber) : W(e.epoch_number) ? globalThis.Number(e.epoch_number) : 0,
      bestSubmissionBtcBlockHeight: W(e.bestSubmissionBtcBlockHeight) ? globalThis.Number(e.bestSubmissionBtcBlockHeight) : W(e.best_submission_btc_block_height) ? globalThis.Number(e.best_submission_btc_block_height) : 0,
      bestSubmissionBtcBlockHash: W(e.bestSubmissionBtcBlockHash) ? ue(e.bestSubmissionBtcBlockHash) : W(e.best_submission_btc_block_hash) ? ue(e.best_submission_btc_block_hash) : new Uint8Array(0),
      bestSubmissionTransactions: globalThis.Array.isArray(e == null ? void 0 : e.bestSubmissionTransactions) ? e.bestSubmissionTransactions.map((n) => ie.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.best_submission_transactions) ? e.best_submission_transactions.map((n) => ie.fromJSON(n)) : [],
      bestSubmissionVigilanteAddressList: globalThis.Array.isArray(e == null ? void 0 : e.bestSubmissionVigilanteAddressList) ? e.bestSubmissionVigilanteAddressList.map((n) => oe.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.best_submission_vigilante_address_list) ? e.best_submission_vigilante_address_list.map((n) => oe.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t, i;
    const n = {};
    return e.epochNumber !== 0 && (n.epochNumber = Math.round(e.epochNumber)), e.bestSubmissionBtcBlockHeight !== 0 && (n.bestSubmissionBtcBlockHeight = Math.round(e.bestSubmissionBtcBlockHeight)), e.bestSubmissionBtcBlockHash.length !== 0 && (n.bestSubmissionBtcBlockHash = xe(e.bestSubmissionBtcBlockHash)), (t = e.bestSubmissionTransactions) != null && t.length && (n.bestSubmissionTransactions = e.bestSubmissionTransactions.map((s) => ie.toJSON(s))), (i = e.bestSubmissionVigilanteAddressList) != null && i.length && (n.bestSubmissionVigilanteAddressList = e.bestSubmissionVigilanteAddressList.map(
      (s) => oe.toJSON(s)
    )), n;
  },
  create(e) {
    return Ma.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t, i;
    const n = ri();
    return n.epochNumber = e.epochNumber ?? 0, n.bestSubmissionBtcBlockHeight = e.bestSubmissionBtcBlockHeight ?? 0, n.bestSubmissionBtcBlockHash = e.bestSubmissionBtcBlockHash ?? new Uint8Array(0), n.bestSubmissionTransactions = ((t = e.bestSubmissionTransactions) == null ? void 0 : t.map((s) => ie.fromPartial(s))) || [], n.bestSubmissionVigilanteAddressList = ((i = e.bestSubmissionVigilanteAddressList) == null ? void 0 : i.map((s) => oe.fromPartial(s))) || [], n;
  }
};
function ue(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function xe(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function Va(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function W(e) {
  return e != null;
}
const _c = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCCheckpointInfo: Ma,
  BTCSpvProof: Ca,
  BtcStatus: Ea,
  CheckpointAddresses: oe,
  EpochData: Ha,
  SubmissionData: Ua,
  SubmissionKey: en,
  TransactionInfo: ie,
  TransactionKey: z,
  btcStatusFromJSON: Ja,
  btcStatusToJSON: Ia,
  protobufPackage: Kd
}, Symbol.toStringTag, { value: "Module" })), Zd = "babylon.btclightclient.v1";
function ii() {
  return { header: new Uint8Array(0), hash: new Uint8Array(0), height: 0, work: new Uint8Array(0) };
}
const re = {
  encode(e, n = new g()) {
    return e.header.length !== 0 && n.uint32(10).bytes(e.header), e.hash.length !== 0 && n.uint32(18).bytes(e.hash), e.height !== 0 && n.uint32(24).uint32(e.height), e.work.length !== 0 && n.uint32(34).bytes(e.work), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ii();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.header = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.hash = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.height = t.uint32();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.work = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      header: Bn(e.header) ? Qn(e.header) : new Uint8Array(0),
      hash: Bn(e.hash) ? Qn(e.hash) : new Uint8Array(0),
      height: Bn(e.height) ? globalThis.Number(e.height) : 0,
      work: Bn(e.work) ? Qn(e.work) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.header.length !== 0 && (n.header = qn(e.header)), e.hash.length !== 0 && (n.hash = qn(e.hash)), e.height !== 0 && (n.height = Math.round(e.height)), e.work.length !== 0 && (n.work = qn(e.work)), n;
  },
  create(e) {
    return re.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ii();
    return n.header = e.header ?? new Uint8Array(0), n.hash = e.hash ?? new Uint8Array(0), n.height = e.height ?? 0, n.work = e.work ?? new Uint8Array(0), n;
  }
};
function Qn(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function qn(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function Bn(e) {
  return e != null;
}
const bc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCHeaderInfo: re,
  protobufPackage: Zd
}, Symbol.toStringTag, { value: "Module" }));
function oi() {
  return { key: new Uint8Array(0), offset: 0, limit: 0, countTotal: !1, reverse: !1 };
}
const C = {
  encode(e, n = new g()) {
    return e.key.length !== 0 && n.uint32(10).bytes(e.key), e.offset !== 0 && n.uint32(16).uint64(e.offset), e.limit !== 0 && n.uint32(24).uint64(e.limit), e.countTotal !== !1 && n.uint32(32).bool(e.countTotal), e.reverse !== !1 && n.uint32(40).bool(e.reverse), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = oi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.key = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.offset = jn(t.uint64());
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.limit = jn(t.uint64());
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.countTotal = t.bool();
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.reverse = t.bool();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      key: Ne(e.key) ? Yn(e.key) : new Uint8Array(0),
      offset: Ne(e.offset) ? globalThis.Number(e.offset) : 0,
      limit: Ne(e.limit) ? globalThis.Number(e.limit) : 0,
      countTotal: Ne(e.countTotal) ? globalThis.Boolean(e.countTotal) : Ne(e.count_total) ? globalThis.Boolean(e.count_total) : !1,
      reverse: Ne(e.reverse) ? globalThis.Boolean(e.reverse) : !1
    };
  },
  toJSON(e) {
    const n = {};
    return e.key.length !== 0 && (n.key = Fa(e.key)), e.offset !== 0 && (n.offset = Math.round(e.offset)), e.limit !== 0 && (n.limit = Math.round(e.limit)), e.countTotal !== !1 && (n.countTotal = e.countTotal), e.reverse !== !1 && (n.reverse = e.reverse), n;
  },
  create(e) {
    return C.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = oi();
    return n.key = e.key ?? new Uint8Array(0), n.offset = e.offset ?? 0, n.limit = e.limit ?? 0, n.countTotal = e.countTotal ?? !1, n.reverse = e.reverse ?? !1, n;
  }
};
function si() {
  return { nextKey: new Uint8Array(0), total: 0 };
}
const U = {
  encode(e, n = new g()) {
    return e.nextKey.length !== 0 && n.uint32(10).bytes(e.nextKey), e.total !== 0 && n.uint32(16).uint64(e.total), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = si();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.nextKey = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.total = jn(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      nextKey: Ne(e.nextKey) ? Yn(e.nextKey) : Ne(e.next_key) ? Yn(e.next_key) : new Uint8Array(0),
      total: Ne(e.total) ? globalThis.Number(e.total) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.nextKey.length !== 0 && (n.nextKey = Fa(e.nextKey)), e.total !== 0 && (n.total = Math.round(e.total)), n;
  },
  create(e) {
    return U.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = si();
    return n.nextKey = e.nextKey ?? new Uint8Array(0), n.total = e.total ?? 0, n;
  }
};
function Yn(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function Fa(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function jn(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function Ne(e) {
  return e != null;
}
function ai() {
  return { insertHeadersAllowList: [] };
}
const pn = {
  encode(e, n = new g()) {
    for (const t of e.insertHeadersAllowList)
      n.uint32(10).string(t);
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ai();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.insertHeadersAllowList.push(t.string());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      insertHeadersAllowList: globalThis.Array.isArray(e == null ? void 0 : e.insertHeadersAllowList) ? e.insertHeadersAllowList.map((n) => globalThis.String(n)) : globalThis.Array.isArray(e == null ? void 0 : e.insert_headers_allow_list) ? e.insert_headers_allow_list.map((n) => globalThis.String(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.insertHeadersAllowList) != null && t.length && (n.insertHeadersAllowList = e.insertHeadersAllowList), n;
  },
  create(e) {
    return pn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ai();
    return n.insertHeadersAllowList = ((t = e.insertHeadersAllowList) == null ? void 0 : t.map((i) => i)) || [], n;
  }
}, zd = "babylon.btclightclient.v1";
function di() {
  return {};
}
const it = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = di();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return it.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return di();
  }
};
function li() {
  return { params: void 0 };
}
const ot = {
  encode(e, n = new g()) {
    return e.params !== void 0 && pn.encode(e.params, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = li();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.params = pn.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { params: Z(e.params) ? pn.fromJSON(e.params) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.params !== void 0 && (n.params = pn.toJSON(e.params)), n;
  },
  create(e) {
    return ot.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = li();
    return n.params = e.params !== void 0 && e.params !== null ? pn.fromPartial(e.params) : void 0, n;
  }
};
function ci() {
  return { pagination: void 0 };
}
const st = {
  encode(e, n = new g()) {
    return e.pagination !== void 0 && C.encode(e.pagination, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ci();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.pagination = C.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { pagination: Z(e.pagination) ? C.fromJSON(e.pagination) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.pagination !== void 0 && (n.pagination = C.toJSON(e.pagination)), n;
  },
  create(e) {
    return st.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ci();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? C.fromPartial(e.pagination) : void 0, n;
  }
};
function ui() {
  return { hashes: [], pagination: void 0 };
}
const at = {
  encode(e, n = new g()) {
    for (const t of e.hashes)
      n.uint32(10).bytes(t);
    return e.pagination !== void 0 && U.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ui();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.hashes.push(t.bytes());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = U.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      hashes: globalThis.Array.isArray(e == null ? void 0 : e.hashes) ? e.hashes.map((n) => bt(n)) : [],
      pagination: Z(e.pagination) ? U.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.hashes) != null && t.length && (n.hashes = e.hashes.map((i) => St(i))), e.pagination !== void 0 && (n.pagination = U.toJSON(e.pagination)), n;
  },
  create(e) {
    return at.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ui();
    return n.hashes = ((t = e.hashes) == null ? void 0 : t.map((i) => i)) || [], n.pagination = e.pagination !== void 0 && e.pagination !== null ? U.fromPartial(e.pagination) : void 0, n;
  }
};
function hi() {
  return { hash: new Uint8Array(0) };
}
const dt = {
  encode(e, n = new g()) {
    return e.hash.length !== 0 && n.uint32(10).bytes(e.hash), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = hi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.hash = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { hash: Z(e.hash) ? bt(e.hash) : new Uint8Array(0) };
  },
  toJSON(e) {
    const n = {};
    return e.hash.length !== 0 && (n.hash = St(e.hash)), n;
  },
  create(e) {
    return dt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = hi();
    return n.hash = e.hash ?? new Uint8Array(0), n;
  }
};
function fi() {
  return { contains: !1 };
}
const lt = {
  encode(e, n = new g()) {
    return e.contains !== !1 && n.uint32(8).bool(e.contains), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = fi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.contains = t.bool();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { contains: Z(e.contains) ? globalThis.Boolean(e.contains) : !1 };
  },
  toJSON(e) {
    const n = {};
    return e.contains !== !1 && (n.contains = e.contains), n;
  },
  create(e) {
    return lt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = fi();
    return n.contains = e.contains ?? !1, n;
  }
};
function gi() {
  return { hash: new Uint8Array(0) };
}
const ct = {
  encode(e, n = new g()) {
    return e.hash.length !== 0 && n.uint32(10).bytes(e.hash), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = gi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.hash = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { hash: Z(e.hash) ? bt(e.hash) : new Uint8Array(0) };
  },
  toJSON(e) {
    const n = {};
    return e.hash.length !== 0 && (n.hash = St(e.hash)), n;
  },
  create(e) {
    return ct.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = gi();
    return n.hash = e.hash ?? new Uint8Array(0), n;
  }
};
function pi() {
  return { contains: !1 };
}
const ut = {
  encode(e, n = new g()) {
    return e.contains !== !1 && n.uint32(8).bool(e.contains), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = pi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.contains = t.bool();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { contains: Z(e.contains) ? globalThis.Boolean(e.contains) : !1 };
  },
  toJSON(e) {
    const n = {};
    return e.contains !== !1 && (n.contains = e.contains), n;
  },
  create(e) {
    return ut.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = pi();
    return n.contains = e.contains ?? !1, n;
  }
};
function mi() {
  return { pagination: void 0 };
}
const ht = {
  encode(e, n = new g()) {
    return e.pagination !== void 0 && C.encode(e.pagination, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = mi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.pagination = C.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { pagination: Z(e.pagination) ? C.fromJSON(e.pagination) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.pagination !== void 0 && (n.pagination = C.toJSON(e.pagination)), n;
  },
  create(e) {
    return ht.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = mi();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? C.fromPartial(e.pagination) : void 0, n;
  }
};
function ki() {
  return { headers: [], pagination: void 0 };
}
const ft = {
  encode(e, n = new g()) {
    for (const t of e.headers)
      Y.encode(t, n.uint32(10).fork()).join();
    return e.pagination !== void 0 && U.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ki();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.headers.push(Y.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = U.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      headers: globalThis.Array.isArray(e == null ? void 0 : e.headers) ? e.headers.map((n) => Y.fromJSON(n)) : [],
      pagination: Z(e.pagination) ? U.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.headers) != null && t.length && (n.headers = e.headers.map((i) => Y.toJSON(i))), e.pagination !== void 0 && (n.pagination = U.toJSON(e.pagination)), n;
  },
  create(e) {
    return ft.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ki();
    return n.headers = ((t = e.headers) == null ? void 0 : t.map((i) => Y.fromPartial(i))) || [], n.pagination = e.pagination !== void 0 && e.pagination !== null ? U.fromPartial(e.pagination) : void 0, n;
  }
};
function _i() {
  return {};
}
const Hn = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = _i();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Hn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return _i();
  }
};
function bi() {
  return { header: void 0 };
}
const gt = {
  encode(e, n = new g()) {
    return e.header !== void 0 && Y.encode(e.header, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = bi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.header = Y.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { header: Z(e.header) ? Y.fromJSON(e.header) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.header !== void 0 && (n.header = Y.toJSON(e.header)), n;
  },
  create(e) {
    return gt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = bi();
    return n.header = e.header !== void 0 && e.header !== null ? Y.fromPartial(e.header) : void 0, n;
  }
};
function Si() {
  return {};
}
const pt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Si();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return pt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Si();
  }
};
function vi() {
  return { header: void 0 };
}
const mt = {
  encode(e, n = new g()) {
    return e.header !== void 0 && Y.encode(e.header, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = vi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.header = Y.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { header: Z(e.header) ? Y.fromJSON(e.header) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.header !== void 0 && (n.header = Y.toJSON(e.header)), n;
  },
  create(e) {
    return mt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = vi();
    return n.header = e.header !== void 0 && e.header !== null ? Y.fromPartial(e.header) : void 0, n;
  }
};
function yi() {
  return { hash: "" };
}
const kt = {
  encode(e, n = new g()) {
    return e.hash !== "" && n.uint32(10).string(e.hash), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = yi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.hash = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { hash: Z(e.hash) ? globalThis.String(e.hash) : "" };
  },
  toJSON(e) {
    const n = {};
    return e.hash !== "" && (n.hash = e.hash), n;
  },
  create(e) {
    return kt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = yi();
    return n.hash = e.hash ?? "", n;
  }
};
function Ti() {
  return { depth: 0 };
}
const _t = {
  encode(e, n = new g()) {
    return e.depth !== 0 && n.uint32(8).uint32(e.depth), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ti();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.depth = t.uint32();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { depth: Z(e.depth) ? globalThis.Number(e.depth) : 0 };
  },
  toJSON(e) {
    const n = {};
    return e.depth !== 0 && (n.depth = Math.round(e.depth)), n;
  },
  create(e) {
    return _t.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ti();
    return n.depth = e.depth ?? 0, n;
  }
};
function wi() {
  return { headerHex: "", hashHex: "", height: 0, work: "" };
}
const Y = {
  encode(e, n = new g()) {
    return e.headerHex !== "" && n.uint32(10).string(e.headerHex), e.hashHex !== "" && n.uint32(18).string(e.hashHex), e.height !== 0 && n.uint32(24).uint32(e.height), e.work !== "" && n.uint32(34).string(e.work), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = wi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.headerHex = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.hashHex = t.string();
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.height = t.uint32();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.work = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      headerHex: Z(e.headerHex) ? globalThis.String(e.headerHex) : Z(e.header_hex) ? globalThis.String(e.header_hex) : "",
      hashHex: Z(e.hashHex) ? globalThis.String(e.hashHex) : Z(e.hash_hex) ? globalThis.String(e.hash_hex) : "",
      height: Z(e.height) ? globalThis.Number(e.height) : 0,
      work: Z(e.work) ? globalThis.String(e.work) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.headerHex !== "" && (n.headerHex = e.headerHex), e.hashHex !== "" && (n.hashHex = e.hashHex), e.height !== 0 && (n.height = Math.round(e.height)), e.work !== "" && (n.work = e.work), n;
  },
  create(e) {
    return Y.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = wi();
    return n.headerHex = e.headerHex ?? "", n.hashHex = e.hashHex ?? "", n.height = e.height ?? 0, n.work = e.work ?? "", n;
  }
}, La = "babylon.btclightclient.v1.Query";
let Ga = class {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || La, this.rpc = n, this.Params = this.Params.bind(this), this.Hashes = this.Hashes.bind(this), this.Contains = this.Contains.bind(this), this.ContainsBytes = this.ContainsBytes.bind(this), this.MainChain = this.MainChain.bind(this), this.Tip = this.Tip.bind(this), this.BaseHeader = this.BaseHeader.bind(this), this.HeaderDepth = this.HeaderDepth.bind(this);
  }
  Params(n) {
    const t = it.encode(n).finish();
    return this.rpc.request(this.service, "Params", t).then((s) => ot.decode(new a(s)));
  }
  Hashes(n) {
    const t = st.encode(n).finish();
    return this.rpc.request(this.service, "Hashes", t).then((s) => at.decode(new a(s)));
  }
  Contains(n) {
    const t = dt.encode(n).finish();
    return this.rpc.request(this.service, "Contains", t).then((s) => lt.decode(new a(s)));
  }
  ContainsBytes(n) {
    const t = ct.encode(n).finish();
    return this.rpc.request(this.service, "ContainsBytes", t).then((s) => ut.decode(new a(s)));
  }
  MainChain(n) {
    const t = ht.encode(n).finish();
    return this.rpc.request(this.service, "MainChain", t).then((s) => ft.decode(new a(s)));
  }
  Tip(n) {
    const t = Hn.encode(n).finish();
    return this.rpc.request(this.service, "Tip", t).then((s) => gt.decode(new a(s)));
  }
  BaseHeader(n) {
    const t = pt.encode(n).finish();
    return this.rpc.request(this.service, "BaseHeader", t).then((s) => mt.decode(new a(s)));
  }
  HeaderDepth(n) {
    const t = kt.encode(n).finish();
    return this.rpc.request(this.service, "HeaderDepth", t).then((s) => _t.decode(new a(s)));
  }
};
function bt(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function St(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function Z(e) {
  return e != null;
}
const vc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCHeaderInfoResponse: Y,
  QueryBaseHeaderRequest: pt,
  QueryBaseHeaderResponse: mt,
  QueryClientImpl: Ga,
  QueryContainsBytesRequest: ct,
  QueryContainsBytesResponse: ut,
  QueryContainsRequest: dt,
  QueryContainsResponse: lt,
  QueryHashesRequest: st,
  QueryHashesResponse: at,
  QueryHeaderDepthRequest: kt,
  QueryHeaderDepthResponse: _t,
  QueryMainChainRequest: ht,
  QueryMainChainResponse: ft,
  QueryParamsRequest: it,
  QueryParamsResponse: ot,
  QueryServiceName: La,
  QueryTipRequest: Hn,
  QueryTipResponse: gt,
  protobufPackage: zd
}, Symbol.toStringTag, { value: "Module" })), Yd = "google.protobuf";
function Pi() {
  return { typeUrl: "", value: new Uint8Array(0) };
}
const he = {
  encode(e, n = new g()) {
    return e.typeUrl !== "" && n.uint32(10).string(e.typeUrl), e.value.length !== 0 && n.uint32(18).bytes(e.value), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Pi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.typeUrl = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.value = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      typeUrl: Xn(e.typeUrl) ? globalThis.String(e.typeUrl) : Xn(e.type_url) ? globalThis.String(e.type_url) : "",
      value: Xn(e.value) ? jd(e.value) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.typeUrl !== "" && (n.typeUrl = e.typeUrl), e.value.length !== 0 && (n.value = el(e.value)), n;
  },
  create(e) {
    return he.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Pi();
    return n.typeUrl = e.typeUrl ?? "", n.value = e.value ?? new Uint8Array(0), n;
  }
};
function jd(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function el(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function Xn(e) {
  return e != null;
}
const yc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: he,
  protobufPackage: Yd
}, Symbol.toStringTag, { value: "Module" }));
function Di() {
  return { seconds: 0, nanos: 0 };
}
const Xe = {
  encode(e, n = new g()) {
    return e.seconds !== 0 && n.uint32(8).int64(e.seconds), e.nanos !== 0 && n.uint32(16).int32(e.nanos), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Di();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.seconds = nl(t.int64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.nanos = t.int32();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      seconds: Ai(e.seconds) ? globalThis.Number(e.seconds) : 0,
      nanos: Ai(e.nanos) ? globalThis.Number(e.nanos) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.seconds !== 0 && (n.seconds = Math.round(e.seconds)), e.nanos !== 0 && (n.nanos = Math.round(e.nanos)), n;
  },
  create(e) {
    return Xe.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Di();
    return n.seconds = e.seconds ?? 0, n.nanos = e.nanos ?? 0, n;
  }
};
function nl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function Ai(e) {
  return e != null;
}
function Ni() {
  return { seconds: 0, nanos: 0 };
}
const H = {
  encode(e, n = new g()) {
    return e.seconds !== 0 && n.uint32(8).int64(e.seconds), e.nanos !== 0 && n.uint32(16).int32(e.nanos), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ni();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.seconds = tl(t.int64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.nanos = t.int32();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      seconds: xi(e.seconds) ? globalThis.Number(e.seconds) : 0,
      nanos: xi(e.nanos) ? globalThis.Number(e.nanos) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.seconds !== 0 && (n.seconds = Math.round(e.seconds)), e.nanos !== 0 && (n.nanos = Math.round(e.nanos)), n;
  },
  create(e) {
    return H.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ni();
    return n.seconds = e.seconds ?? 0, n.nanos = e.nanos ?? 0, n;
  }
};
function tl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function xi(e) {
  return e != null;
}
function Bi() {
  return { ed25519: void 0, secp256k1: void 0 };
}
const Ke = {
  encode(e, n = new g()) {
    return e.ed25519 !== void 0 && n.uint32(10).bytes(e.ed25519), e.secp256k1 !== void 0 && n.uint32(18).bytes(e.secp256k1), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Bi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.ed25519 = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.secp256k1 = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      ed25519: Ei(e.ed25519) ? Ri(e.ed25519) : void 0,
      secp256k1: Ei(e.secp256k1) ? Ri(e.secp256k1) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.ed25519 !== void 0 && (n.ed25519 = Oi(e.ed25519)), e.secp256k1 !== void 0 && (n.secp256k1 = Oi(e.secp256k1)), n;
  },
  create(e) {
    return Ke.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Bi();
    return n.ed25519 = e.ed25519 ?? void 0, n.secp256k1 = e.secp256k1 ?? void 0, n;
  }
};
function Ri(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function Oi(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function Ei(e) {
  return e != null;
}
function Ji() {
  return { pubKey: void 0, power: 0 };
}
const mn = {
  encode(e, n = new g()) {
    return e.pubKey !== void 0 && Ke.encode(e.pubKey, n.uint32(10).fork()).join(), e.power !== 0 && n.uint32(16).int64(e.power), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ji();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.pubKey = Ke.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.power = rl(t.int64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      pubKey: Kn(e.pubKey) ? Ke.fromJSON(e.pubKey) : Kn(e.pub_key) ? Ke.fromJSON(e.pub_key) : void 0,
      power: Kn(e.power) ? globalThis.Number(e.power) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.pubKey !== void 0 && (n.pubKey = Ke.toJSON(e.pubKey)), e.power !== 0 && (n.power = Math.round(e.power)), n;
  },
  create(e) {
    return mn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ji();
    return n.pubKey = e.pubKey !== void 0 && e.pubKey !== null ? Ke.fromPartial(e.pubKey) : void 0, n.power = e.power ?? 0, n;
  }
};
function rl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function Kn(e) {
  return e != null;
}
function Ii() {
  return { block: 0, app: 0 };
}
const kn = {
  encode(e, n = new g()) {
    return e.block !== 0 && n.uint32(8).uint64(e.block), e.app !== 0 && n.uint32(16).uint64(e.app), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ii();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.block = Ci(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.app = Ci(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      block: Ui(e.block) ? globalThis.Number(e.block) : 0,
      app: Ui(e.app) ? globalThis.Number(e.app) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.block !== 0 && (n.block = Math.round(e.block)), e.app !== 0 && (n.app = Math.round(e.app)), n;
  },
  create(e) {
    return kn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ii();
    return n.block = e.block ?? 0, n.app = e.app ?? 0, n;
  }
};
function Ci(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function Ui(e) {
  return e != null;
}
function Hi() {
  return { total: 0, hash: new Uint8Array(0) };
}
const Ze = {
  encode(e, n = new g()) {
    return e.total !== 0 && n.uint32(8).uint32(e.total), e.hash.length !== 0 && n.uint32(18).bytes(e.hash), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Hi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.total = t.uint32();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.hash = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      total: V(e.total) ? globalThis.Number(e.total) : 0,
      hash: V(e.hash) ? q(e.hash) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.total !== 0 && (n.total = Math.round(e.total)), e.hash.length !== 0 && (n.hash = be(e.hash)), n;
  },
  create(e) {
    return Ze.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Hi();
    return n.total = e.total ?? 0, n.hash = e.hash ?? new Uint8Array(0), n;
  }
};
function Mi() {
  return { hash: new Uint8Array(0), partSetHeader: void 0 };
}
const ze = {
  encode(e, n = new g()) {
    return e.hash.length !== 0 && n.uint32(10).bytes(e.hash), e.partSetHeader !== void 0 && Ze.encode(e.partSetHeader, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Mi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.hash = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.partSetHeader = Ze.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      hash: V(e.hash) ? q(e.hash) : new Uint8Array(0),
      partSetHeader: V(e.partSetHeader) ? Ze.fromJSON(e.partSetHeader) : V(e.part_set_header) ? Ze.fromJSON(e.part_set_header) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.hash.length !== 0 && (n.hash = be(e.hash)), e.partSetHeader !== void 0 && (n.partSetHeader = Ze.toJSON(e.partSetHeader)), n;
  },
  create(e) {
    return ze.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Mi();
    return n.hash = e.hash ?? new Uint8Array(0), n.partSetHeader = e.partSetHeader !== void 0 && e.partSetHeader !== null ? Ze.fromPartial(e.partSetHeader) : void 0, n;
  }
};
function Vi() {
  return {
    version: void 0,
    chainId: "",
    height: 0,
    time: void 0,
    lastBlockId: void 0,
    lastCommitHash: new Uint8Array(0),
    dataHash: new Uint8Array(0),
    validatorsHash: new Uint8Array(0),
    nextValidatorsHash: new Uint8Array(0),
    consensusHash: new Uint8Array(0),
    appHash: new Uint8Array(0),
    lastResultsHash: new Uint8Array(0),
    evidenceHash: new Uint8Array(0),
    proposerAddress: new Uint8Array(0)
  };
}
const _n = {
  encode(e, n = new g()) {
    return e.version !== void 0 && kn.encode(e.version, n.uint32(10).fork()).join(), e.chainId !== "" && n.uint32(18).string(e.chainId), e.height !== 0 && n.uint32(24).int64(e.height), e.time !== void 0 && H.encode(il(e.time), n.uint32(34).fork()).join(), e.lastBlockId !== void 0 && ze.encode(e.lastBlockId, n.uint32(42).fork()).join(), e.lastCommitHash.length !== 0 && n.uint32(50).bytes(e.lastCommitHash), e.dataHash.length !== 0 && n.uint32(58).bytes(e.dataHash), e.validatorsHash.length !== 0 && n.uint32(66).bytes(e.validatorsHash), e.nextValidatorsHash.length !== 0 && n.uint32(74).bytes(e.nextValidatorsHash), e.consensusHash.length !== 0 && n.uint32(82).bytes(e.consensusHash), e.appHash.length !== 0 && n.uint32(90).bytes(e.appHash), e.lastResultsHash.length !== 0 && n.uint32(98).bytes(e.lastResultsHash), e.evidenceHash.length !== 0 && n.uint32(106).bytes(e.evidenceHash), e.proposerAddress.length !== 0 && n.uint32(114).bytes(e.proposerAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Vi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.version = kn.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.chainId = t.string();
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.height = sl(t.int64());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.time = Wa(H.decode(t, t.uint32()));
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.lastBlockId = ze.decode(t, t.uint32());
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.lastCommitHash = t.bytes();
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.dataHash = t.bytes();
            continue;
          }
          case 8: {
            if (r !== 66)
              break;
            o.validatorsHash = t.bytes();
            continue;
          }
          case 9: {
            if (r !== 74)
              break;
            o.nextValidatorsHash = t.bytes();
            continue;
          }
          case 10: {
            if (r !== 82)
              break;
            o.consensusHash = t.bytes();
            continue;
          }
          case 11: {
            if (r !== 90)
              break;
            o.appHash = t.bytes();
            continue;
          }
          case 12: {
            if (r !== 98)
              break;
            o.lastResultsHash = t.bytes();
            continue;
          }
          case 13: {
            if (r !== 106)
              break;
            o.evidenceHash = t.bytes();
            continue;
          }
          case 14: {
            if (r !== 114)
              break;
            o.proposerAddress = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      version: V(e.version) ? kn.fromJSON(e.version) : void 0,
      chainId: V(e.chainId) ? globalThis.String(e.chainId) : V(e.chain_id) ? globalThis.String(e.chain_id) : "",
      height: V(e.height) ? globalThis.Number(e.height) : 0,
      time: V(e.time) ? ol(e.time) : void 0,
      lastBlockId: V(e.lastBlockId) ? ze.fromJSON(e.lastBlockId) : V(e.last_block_id) ? ze.fromJSON(e.last_block_id) : void 0,
      lastCommitHash: V(e.lastCommitHash) ? q(e.lastCommitHash) : V(e.last_commit_hash) ? q(e.last_commit_hash) : new Uint8Array(0),
      dataHash: V(e.dataHash) ? q(e.dataHash) : V(e.data_hash) ? q(e.data_hash) : new Uint8Array(0),
      validatorsHash: V(e.validatorsHash) ? q(e.validatorsHash) : V(e.validators_hash) ? q(e.validators_hash) : new Uint8Array(0),
      nextValidatorsHash: V(e.nextValidatorsHash) ? q(e.nextValidatorsHash) : V(e.next_validators_hash) ? q(e.next_validators_hash) : new Uint8Array(0),
      consensusHash: V(e.consensusHash) ? q(e.consensusHash) : V(e.consensus_hash) ? q(e.consensus_hash) : new Uint8Array(0),
      appHash: V(e.appHash) ? q(e.appHash) : V(e.app_hash) ? q(e.app_hash) : new Uint8Array(0),
      lastResultsHash: V(e.lastResultsHash) ? q(e.lastResultsHash) : V(e.last_results_hash) ? q(e.last_results_hash) : new Uint8Array(0),
      evidenceHash: V(e.evidenceHash) ? q(e.evidenceHash) : V(e.evidence_hash) ? q(e.evidence_hash) : new Uint8Array(0),
      proposerAddress: V(e.proposerAddress) ? q(e.proposerAddress) : V(e.proposer_address) ? q(e.proposer_address) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.version !== void 0 && (n.version = kn.toJSON(e.version)), e.chainId !== "" && (n.chainId = e.chainId), e.height !== 0 && (n.height = Math.round(e.height)), e.time !== void 0 && (n.time = e.time.toISOString()), e.lastBlockId !== void 0 && (n.lastBlockId = ze.toJSON(e.lastBlockId)), e.lastCommitHash.length !== 0 && (n.lastCommitHash = be(e.lastCommitHash)), e.dataHash.length !== 0 && (n.dataHash = be(e.dataHash)), e.validatorsHash.length !== 0 && (n.validatorsHash = be(e.validatorsHash)), e.nextValidatorsHash.length !== 0 && (n.nextValidatorsHash = be(e.nextValidatorsHash)), e.consensusHash.length !== 0 && (n.consensusHash = be(e.consensusHash)), e.appHash.length !== 0 && (n.appHash = be(e.appHash)), e.lastResultsHash.length !== 0 && (n.lastResultsHash = be(e.lastResultsHash)), e.evidenceHash.length !== 0 && (n.evidenceHash = be(e.evidenceHash)), e.proposerAddress.length !== 0 && (n.proposerAddress = be(e.proposerAddress)), n;
  },
  create(e) {
    return _n.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Vi();
    return n.version = e.version !== void 0 && e.version !== null ? kn.fromPartial(e.version) : void 0, n.chainId = e.chainId ?? "", n.height = e.height ?? 0, n.time = e.time ?? void 0, n.lastBlockId = e.lastBlockId !== void 0 && e.lastBlockId !== null ? ze.fromPartial(e.lastBlockId) : void 0, n.lastCommitHash = e.lastCommitHash ?? new Uint8Array(0), n.dataHash = e.dataHash ?? new Uint8Array(0), n.validatorsHash = e.validatorsHash ?? new Uint8Array(0), n.nextValidatorsHash = e.nextValidatorsHash ?? new Uint8Array(0), n.consensusHash = e.consensusHash ?? new Uint8Array(0), n.appHash = e.appHash ?? new Uint8Array(0), n.lastResultsHash = e.lastResultsHash ?? new Uint8Array(0), n.evidenceHash = e.evidenceHash ?? new Uint8Array(0), n.proposerAddress = e.proposerAddress ?? new Uint8Array(0), n;
  }
};
function q(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function be(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function il(e) {
  const n = Math.trunc(e.getTime() / 1e3), t = e.getTime() % 1e3 * 1e6;
  return { seconds: n, nanos: t };
}
function Wa(e) {
  let n = (e.seconds || 0) * 1e3;
  return n += (e.nanos || 0) / 1e6, new globalThis.Date(n);
}
function ol(e) {
  return e instanceof globalThis.Date ? e : typeof e == "string" ? new globalThis.Date(e) : Wa(H.fromJSON(e));
}
function sl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function V(e) {
  return e != null;
}
function Fi() {
  return { denom: "", amount: "" };
}
const w = {
  encode(e, n = new g()) {
    return e.denom !== "" && n.uint32(10).string(e.denom), e.amount !== "" && n.uint32(18).string(e.amount), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Fi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.denom = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.amount = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      denom: Li(e.denom) ? globalThis.String(e.denom) : "",
      amount: Li(e.amount) ? globalThis.String(e.amount) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.denom !== "" && (n.denom = e.denom), e.amount !== "" && (n.amount = e.amount), n;
  },
  create(e) {
    return w.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Fi();
    return n.denom = e.denom ?? "", n.amount = e.amount ?? "", n;
  }
};
function Li(e) {
  return e != null;
}
const al = "cosmos.staking.v1beta1";
var $a = /* @__PURE__ */ ((e) => (e[e.BOND_STATUS_UNSPECIFIED = 0] = "BOND_STATUS_UNSPECIFIED", e[e.BOND_STATUS_UNBONDED = 1] = "BOND_STATUS_UNBONDED", e[e.BOND_STATUS_UNBONDING = 2] = "BOND_STATUS_UNBONDING", e[e.BOND_STATUS_BONDED = 3] = "BOND_STATUS_BONDED", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED", e))($a || {});
function Qa(e) {
  switch (e) {
    case 0:
    case "BOND_STATUS_UNSPECIFIED":
      return 0;
    case 1:
    case "BOND_STATUS_UNBONDED":
      return 1;
    case 2:
    case "BOND_STATUS_UNBONDING":
      return 2;
    case 3:
    case "BOND_STATUS_BONDED":
      return 3;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function qa(e) {
  switch (e) {
    case 0:
      return "BOND_STATUS_UNSPECIFIED";
    case 1:
      return "BOND_STATUS_UNBONDED";
    case 2:
      return "BOND_STATUS_UNBONDING";
    case 3:
      return "BOND_STATUS_BONDED";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
var Xa = /* @__PURE__ */ ((e) => (e[e.INFRACTION_UNSPECIFIED = 0] = "INFRACTION_UNSPECIFIED", e[e.INFRACTION_DOUBLE_SIGN = 1] = "INFRACTION_DOUBLE_SIGN", e[e.INFRACTION_DOWNTIME = 2] = "INFRACTION_DOWNTIME", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED", e))(Xa || {});
function dl(e) {
  switch (e) {
    case 0:
    case "INFRACTION_UNSPECIFIED":
      return 0;
    case 1:
    case "INFRACTION_DOUBLE_SIGN":
      return 1;
    case 2:
    case "INFRACTION_DOWNTIME":
      return 2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function ll(e) {
  switch (e) {
    case 0:
      return "INFRACTION_UNSPECIFIED";
    case 1:
      return "INFRACTION_DOUBLE_SIGN";
    case 2:
      return "INFRACTION_DOWNTIME";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function Gi() {
  return { header: void 0, valset: [] };
}
const Ka = {
  encode(e, n = new g()) {
    e.header !== void 0 && _n.encode(e.header, n.uint32(10).fork()).join();
    for (const t of e.valset)
      tn.encode(t, n.uint32(18).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Gi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.header = _n.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.valset.push(tn.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      header: _(e.header) ? _n.fromJSON(e.header) : void 0,
      valset: globalThis.Array.isArray(e == null ? void 0 : e.valset) ? e.valset.map((n) => tn.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.header !== void 0 && (n.header = _n.toJSON(e.header)), (t = e.valset) != null && t.length && (n.valset = e.valset.map((i) => tn.toJSON(i))), n;
  },
  create(e) {
    return Ka.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Gi();
    return n.header = e.header !== void 0 && e.header !== null ? _n.fromPartial(e.header) : void 0, n.valset = ((t = e.valset) == null ? void 0 : t.map((i) => tn.fromPartial(i))) || [], n;
  }
};
function Wi() {
  return { rate: "", maxRate: "", maxChangeRate: "" };
}
const fe = {
  encode(e, n = new g()) {
    return e.rate !== "" && n.uint32(10).string(e.rate), e.maxRate !== "" && n.uint32(18).string(e.maxRate), e.maxChangeRate !== "" && n.uint32(26).string(e.maxChangeRate), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Wi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.rate = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.maxRate = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.maxChangeRate = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      rate: _(e.rate) ? globalThis.String(e.rate) : "",
      maxRate: _(e.maxRate) ? globalThis.String(e.maxRate) : _(e.max_rate) ? globalThis.String(e.max_rate) : "",
      maxChangeRate: _(e.maxChangeRate) ? globalThis.String(e.maxChangeRate) : _(e.max_change_rate) ? globalThis.String(e.max_change_rate) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.rate !== "" && (n.rate = e.rate), e.maxRate !== "" && (n.maxRate = e.maxRate), e.maxChangeRate !== "" && (n.maxChangeRate = e.maxChangeRate), n;
  },
  create(e) {
    return fe.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Wi();
    return n.rate = e.rate ?? "", n.maxRate = e.maxRate ?? "", n.maxChangeRate = e.maxChangeRate ?? "", n;
  }
};
function $i() {
  return { commissionRates: void 0, updateTime: void 0 };
}
const nn = {
  encode(e, n = new g()) {
    return e.commissionRates !== void 0 && fe.encode(e.commissionRates, n.uint32(10).fork()).join(), e.updateTime !== void 0 && H.encode(Mn(e.updateTime), n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = $i();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.commissionRates = fe.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.updateTime = Pn(H.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      commissionRates: _(e.commissionRates) ? fe.fromJSON(e.commissionRates) : _(e.commission_rates) ? fe.fromJSON(e.commission_rates) : void 0,
      updateTime: _(e.updateTime) ? Qe(e.updateTime) : _(e.update_time) ? Qe(e.update_time) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.commissionRates !== void 0 && (n.commissionRates = fe.toJSON(e.commissionRates)), e.updateTime !== void 0 && (n.updateTime = e.updateTime.toISOString()), n;
  },
  create(e) {
    return nn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = $i();
    return n.commissionRates = e.commissionRates !== void 0 && e.commissionRates !== null ? fe.fromPartial(e.commissionRates) : void 0, n.updateTime = e.updateTime ?? void 0, n;
  }
};
function Qi() {
  return { moniker: "", identity: "", website: "", securityContact: "", details: "" };
}
const I = {
  encode(e, n = new g()) {
    return e.moniker !== "" && n.uint32(10).string(e.moniker), e.identity !== "" && n.uint32(18).string(e.identity), e.website !== "" && n.uint32(26).string(e.website), e.securityContact !== "" && n.uint32(34).string(e.securityContact), e.details !== "" && n.uint32(42).string(e.details), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Qi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.moniker = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.identity = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.website = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.securityContact = t.string();
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.details = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      moniker: _(e.moniker) ? globalThis.String(e.moniker) : "",
      identity: _(e.identity) ? globalThis.String(e.identity) : "",
      website: _(e.website) ? globalThis.String(e.website) : "",
      securityContact: _(e.securityContact) ? globalThis.String(e.securityContact) : _(e.security_contact) ? globalThis.String(e.security_contact) : "",
      details: _(e.details) ? globalThis.String(e.details) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.moniker !== "" && (n.moniker = e.moniker), e.identity !== "" && (n.identity = e.identity), e.website !== "" && (n.website = e.website), e.securityContact !== "" && (n.securityContact = e.securityContact), e.details !== "" && (n.details = e.details), n;
  },
  create(e) {
    return I.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Qi();
    return n.moniker = e.moniker ?? "", n.identity = e.identity ?? "", n.website = e.website ?? "", n.securityContact = e.securityContact ?? "", n.details = e.details ?? "", n;
  }
};
function qi() {
  return {
    operatorAddress: "",
    consensusPubkey: void 0,
    jailed: !1,
    status: 0,
    tokens: "",
    delegatorShares: "",
    description: void 0,
    unbondingHeight: 0,
    unbondingTime: void 0,
    commission: void 0,
    minSelfDelegation: "",
    unbondingOnHoldRefCount: 0,
    unbondingIds: []
  };
}
const tn = {
  encode(e, n = new g()) {
    e.operatorAddress !== "" && n.uint32(10).string(e.operatorAddress), e.consensusPubkey !== void 0 && he.encode(e.consensusPubkey, n.uint32(18).fork()).join(), e.jailed !== !1 && n.uint32(24).bool(e.jailed), e.status !== 0 && n.uint32(32).int32(e.status), e.tokens !== "" && n.uint32(42).string(e.tokens), e.delegatorShares !== "" && n.uint32(50).string(e.delegatorShares), e.description !== void 0 && I.encode(e.description, n.uint32(58).fork()).join(), e.unbondingHeight !== 0 && n.uint32(64).int64(e.unbondingHeight), e.unbondingTime !== void 0 && H.encode(Mn(e.unbondingTime), n.uint32(74).fork()).join(), e.commission !== void 0 && nn.encode(e.commission, n.uint32(82).fork()).join(), e.minSelfDelegation !== "" && n.uint32(90).string(e.minSelfDelegation), e.unbondingOnHoldRefCount !== 0 && n.uint32(96).int64(e.unbondingOnHoldRefCount), n.uint32(106).fork();
    for (const t of e.unbondingIds)
      n.uint64(t);
    return n.join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = qi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.operatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.consensusPubkey = he.decode(t, t.uint32());
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.jailed = t.bool();
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.status = t.int32();
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.tokens = t.string();
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.delegatorShares = t.string();
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.description = I.decode(t, t.uint32());
            continue;
          }
          case 8: {
            if (r !== 64)
              break;
            o.unbondingHeight = Pe(t.int64());
            continue;
          }
          case 9: {
            if (r !== 74)
              break;
            o.unbondingTime = Pn(H.decode(t, t.uint32()));
            continue;
          }
          case 10: {
            if (r !== 82)
              break;
            o.commission = nn.decode(t, t.uint32());
            continue;
          }
          case 11: {
            if (r !== 90)
              break;
            o.minSelfDelegation = t.string();
            continue;
          }
          case 12: {
            if (r !== 96)
              break;
            o.unbondingOnHoldRefCount = Pe(t.int64());
            continue;
          }
          case 13: {
            if (r === 104) {
              o.unbondingIds.push(Pe(t.uint64()));
              continue;
            }
            if (r === 106) {
              const p = t.uint32() + t.pos;
              for (; t.pos < p; )
                o.unbondingIds.push(Pe(t.uint64()));
              continue;
            }
            break;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      operatorAddress: _(e.operatorAddress) ? globalThis.String(e.operatorAddress) : _(e.operator_address) ? globalThis.String(e.operator_address) : "",
      consensusPubkey: _(e.consensusPubkey) ? he.fromJSON(e.consensusPubkey) : _(e.consensus_pubkey) ? he.fromJSON(e.consensus_pubkey) : void 0,
      jailed: _(e.jailed) ? globalThis.Boolean(e.jailed) : !1,
      status: _(e.status) ? Qa(e.status) : 0,
      tokens: _(e.tokens) ? globalThis.String(e.tokens) : "",
      delegatorShares: _(e.delegatorShares) ? globalThis.String(e.delegatorShares) : _(e.delegator_shares) ? globalThis.String(e.delegator_shares) : "",
      description: _(e.description) ? I.fromJSON(e.description) : void 0,
      unbondingHeight: _(e.unbondingHeight) ? globalThis.Number(e.unbondingHeight) : _(e.unbonding_height) ? globalThis.Number(e.unbonding_height) : 0,
      unbondingTime: _(e.unbondingTime) ? Qe(e.unbondingTime) : _(e.unbonding_time) ? Qe(e.unbonding_time) : void 0,
      commission: _(e.commission) ? nn.fromJSON(e.commission) : void 0,
      minSelfDelegation: _(e.minSelfDelegation) ? globalThis.String(e.minSelfDelegation) : _(e.min_self_delegation) ? globalThis.String(e.min_self_delegation) : "",
      unbondingOnHoldRefCount: _(e.unbondingOnHoldRefCount) ? globalThis.Number(e.unbondingOnHoldRefCount) : _(e.unbonding_on_hold_ref_count) ? globalThis.Number(e.unbonding_on_hold_ref_count) : 0,
      unbondingIds: globalThis.Array.isArray(e == null ? void 0 : e.unbondingIds) ? e.unbondingIds.map((n) => globalThis.Number(n)) : globalThis.Array.isArray(e == null ? void 0 : e.unbonding_ids) ? e.unbonding_ids.map((n) => globalThis.Number(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.operatorAddress !== "" && (n.operatorAddress = e.operatorAddress), e.consensusPubkey !== void 0 && (n.consensusPubkey = he.toJSON(e.consensusPubkey)), e.jailed !== !1 && (n.jailed = e.jailed), e.status !== 0 && (n.status = qa(e.status)), e.tokens !== "" && (n.tokens = e.tokens), e.delegatorShares !== "" && (n.delegatorShares = e.delegatorShares), e.description !== void 0 && (n.description = I.toJSON(e.description)), e.unbondingHeight !== 0 && (n.unbondingHeight = Math.round(e.unbondingHeight)), e.unbondingTime !== void 0 && (n.unbondingTime = e.unbondingTime.toISOString()), e.commission !== void 0 && (n.commission = nn.toJSON(e.commission)), e.minSelfDelegation !== "" && (n.minSelfDelegation = e.minSelfDelegation), e.unbondingOnHoldRefCount !== 0 && (n.unbondingOnHoldRefCount = Math.round(e.unbondingOnHoldRefCount)), (t = e.unbondingIds) != null && t.length && (n.unbondingIds = e.unbondingIds.map((i) => Math.round(i))), n;
  },
  create(e) {
    return tn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = qi();
    return n.operatorAddress = e.operatorAddress ?? "", n.consensusPubkey = e.consensusPubkey !== void 0 && e.consensusPubkey !== null ? he.fromPartial(e.consensusPubkey) : void 0, n.jailed = e.jailed ?? !1, n.status = e.status ?? 0, n.tokens = e.tokens ?? "", n.delegatorShares = e.delegatorShares ?? "", n.description = e.description !== void 0 && e.description !== null ? I.fromPartial(e.description) : void 0, n.unbondingHeight = e.unbondingHeight ?? 0, n.unbondingTime = e.unbondingTime ?? void 0, n.commission = e.commission !== void 0 && e.commission !== null ? nn.fromPartial(e.commission) : void 0, n.minSelfDelegation = e.minSelfDelegation ?? "", n.unbondingOnHoldRefCount = e.unbondingOnHoldRefCount ?? 0, n.unbondingIds = ((t = e.unbondingIds) == null ? void 0 : t.map((i) => i)) || [], n;
  }
};
function Xi() {
  return { addresses: [] };
}
const Za = {
  encode(e, n = new g()) {
    for (const t of e.addresses)
      n.uint32(10).string(t);
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Xi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.addresses.push(t.string());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      addresses: globalThis.Array.isArray(e == null ? void 0 : e.addresses) ? e.addresses.map((n) => globalThis.String(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.addresses) != null && t.length && (n.addresses = e.addresses), n;
  },
  create(e) {
    return Za.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Xi();
    return n.addresses = ((t = e.addresses) == null ? void 0 : t.map((i) => i)) || [], n;
  }
};
function Ki() {
  return { delegatorAddress: "", validatorAddress: "" };
}
const rn = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ki();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: _(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : _(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: _(e.validatorAddress) ? globalThis.String(e.validatorAddress) : _(e.validator_address) ? globalThis.String(e.validator_address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), n;
  },
  create(e) {
    return rn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ki();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n;
  }
};
function Zi() {
  return { pairs: [] };
}
const za = {
  encode(e, n = new g()) {
    for (const t of e.pairs)
      rn.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Zi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.pairs.push(rn.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { pairs: globalThis.Array.isArray(e == null ? void 0 : e.pairs) ? e.pairs.map((n) => rn.fromJSON(n)) : [] };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.pairs) != null && t.length && (n.pairs = e.pairs.map((i) => rn.toJSON(i))), n;
  },
  create(e) {
    return za.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Zi();
    return n.pairs = ((t = e.pairs) == null ? void 0 : t.map((i) => rn.fromPartial(i))) || [], n;
  }
};
function zi() {
  return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "" };
}
const on = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorSrcAddress !== "" && n.uint32(18).string(e.validatorSrcAddress), e.validatorDstAddress !== "" && n.uint32(26).string(e.validatorDstAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = zi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorSrcAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.validatorDstAddress = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: _(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : _(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorSrcAddress: _(e.validatorSrcAddress) ? globalThis.String(e.validatorSrcAddress) : _(e.validator_src_address) ? globalThis.String(e.validator_src_address) : "",
      validatorDstAddress: _(e.validatorDstAddress) ? globalThis.String(e.validatorDstAddress) : _(e.validator_dst_address) ? globalThis.String(e.validator_dst_address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorSrcAddress !== "" && (n.validatorSrcAddress = e.validatorSrcAddress), e.validatorDstAddress !== "" && (n.validatorDstAddress = e.validatorDstAddress), n;
  },
  create(e) {
    return on.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = zi();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorSrcAddress = e.validatorSrcAddress ?? "", n.validatorDstAddress = e.validatorDstAddress ?? "", n;
  }
};
function Yi() {
  return { triplets: [] };
}
const Ya = {
  encode(e, n = new g()) {
    for (const t of e.triplets)
      on.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Yi();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.triplets.push(on.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      triplets: globalThis.Array.isArray(e == null ? void 0 : e.triplets) ? e.triplets.map((n) => on.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.triplets) != null && t.length && (n.triplets = e.triplets.map((i) => on.toJSON(i))), n;
  },
  create(e) {
    return Ya.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Yi();
    return n.triplets = ((t = e.triplets) == null ? void 0 : t.map((i) => on.fromPartial(i))) || [], n;
  }
};
function ji() {
  return { delegatorAddress: "", validatorAddress: "", shares: "" };
}
const sn = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.shares !== "" && n.uint32(26).string(e.shares), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ji();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.shares = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: _(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : _(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: _(e.validatorAddress) ? globalThis.String(e.validatorAddress) : _(e.validator_address) ? globalThis.String(e.validator_address) : "",
      shares: _(e.shares) ? globalThis.String(e.shares) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), e.shares !== "" && (n.shares = e.shares), n;
  },
  create(e) {
    return sn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ji();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n.shares = e.shares ?? "", n;
  }
};
function eo() {
  return { delegatorAddress: "", validatorAddress: "", entries: [] };
}
const ja = {
  encode(e, n = new g()) {
    e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress);
    for (const t of e.entries)
      an.encode(t, n.uint32(26).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = eo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.entries.push(an.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: _(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : _(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: _(e.validatorAddress) ? globalThis.String(e.validatorAddress) : _(e.validator_address) ? globalThis.String(e.validator_address) : "",
      entries: globalThis.Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => an.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), (t = e.entries) != null && t.length && (n.entries = e.entries.map((i) => an.toJSON(i))), n;
  },
  create(e) {
    return ja.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = eo();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n.entries = ((t = e.entries) == null ? void 0 : t.map((i) => an.fromPartial(i))) || [], n;
  }
};
function no() {
  return {
    creationHeight: 0,
    completionTime: void 0,
    initialBalance: "",
    balance: "",
    unbondingId: 0,
    unbondingOnHoldRefCount: 0
  };
}
const an = {
  encode(e, n = new g()) {
    return e.creationHeight !== 0 && n.uint32(8).int64(e.creationHeight), e.completionTime !== void 0 && H.encode(Mn(e.completionTime), n.uint32(18).fork()).join(), e.initialBalance !== "" && n.uint32(26).string(e.initialBalance), e.balance !== "" && n.uint32(34).string(e.balance), e.unbondingId !== 0 && n.uint32(40).uint64(e.unbondingId), e.unbondingOnHoldRefCount !== 0 && n.uint32(48).int64(e.unbondingOnHoldRefCount), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = no();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.creationHeight = Pe(t.int64());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.completionTime = Pn(H.decode(t, t.uint32()));
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.initialBalance = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.balance = t.string();
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.unbondingId = Pe(t.uint64());
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.unbondingOnHoldRefCount = Pe(t.int64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      creationHeight: _(e.creationHeight) ? globalThis.Number(e.creationHeight) : _(e.creation_height) ? globalThis.Number(e.creation_height) : 0,
      completionTime: _(e.completionTime) ? Qe(e.completionTime) : _(e.completion_time) ? Qe(e.completion_time) : void 0,
      initialBalance: _(e.initialBalance) ? globalThis.String(e.initialBalance) : _(e.initial_balance) ? globalThis.String(e.initial_balance) : "",
      balance: _(e.balance) ? globalThis.String(e.balance) : "",
      unbondingId: _(e.unbondingId) ? globalThis.Number(e.unbondingId) : _(e.unbonding_id) ? globalThis.Number(e.unbonding_id) : 0,
      unbondingOnHoldRefCount: _(e.unbondingOnHoldRefCount) ? globalThis.Number(e.unbondingOnHoldRefCount) : _(e.unbonding_on_hold_ref_count) ? globalThis.Number(e.unbonding_on_hold_ref_count) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.creationHeight !== 0 && (n.creationHeight = Math.round(e.creationHeight)), e.completionTime !== void 0 && (n.completionTime = e.completionTime.toISOString()), e.initialBalance !== "" && (n.initialBalance = e.initialBalance), e.balance !== "" && (n.balance = e.balance), e.unbondingId !== 0 && (n.unbondingId = Math.round(e.unbondingId)), e.unbondingOnHoldRefCount !== 0 && (n.unbondingOnHoldRefCount = Math.round(e.unbondingOnHoldRefCount)), n;
  },
  create(e) {
    return an.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = no();
    return n.creationHeight = e.creationHeight ?? 0, n.completionTime = e.completionTime ?? void 0, n.initialBalance = e.initialBalance ?? "", n.balance = e.balance ?? "", n.unbondingId = e.unbondingId ?? 0, n.unbondingOnHoldRefCount = e.unbondingOnHoldRefCount ?? 0, n;
  }
};
function to() {
  return {
    creationHeight: 0,
    completionTime: void 0,
    initialBalance: "",
    sharesDst: "",
    unbondingId: 0,
    unbondingOnHoldRefCount: 0
  };
}
const ge = {
  encode(e, n = new g()) {
    return e.creationHeight !== 0 && n.uint32(8).int64(e.creationHeight), e.completionTime !== void 0 && H.encode(Mn(e.completionTime), n.uint32(18).fork()).join(), e.initialBalance !== "" && n.uint32(26).string(e.initialBalance), e.sharesDst !== "" && n.uint32(34).string(e.sharesDst), e.unbondingId !== 0 && n.uint32(40).uint64(e.unbondingId), e.unbondingOnHoldRefCount !== 0 && n.uint32(48).int64(e.unbondingOnHoldRefCount), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = to();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.creationHeight = Pe(t.int64());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.completionTime = Pn(H.decode(t, t.uint32()));
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.initialBalance = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.sharesDst = t.string();
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.unbondingId = Pe(t.uint64());
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.unbondingOnHoldRefCount = Pe(t.int64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      creationHeight: _(e.creationHeight) ? globalThis.Number(e.creationHeight) : _(e.creation_height) ? globalThis.Number(e.creation_height) : 0,
      completionTime: _(e.completionTime) ? Qe(e.completionTime) : _(e.completion_time) ? Qe(e.completion_time) : void 0,
      initialBalance: _(e.initialBalance) ? globalThis.String(e.initialBalance) : _(e.initial_balance) ? globalThis.String(e.initial_balance) : "",
      sharesDst: _(e.sharesDst) ? globalThis.String(e.sharesDst) : _(e.shares_dst) ? globalThis.String(e.shares_dst) : "",
      unbondingId: _(e.unbondingId) ? globalThis.Number(e.unbondingId) : _(e.unbonding_id) ? globalThis.Number(e.unbonding_id) : 0,
      unbondingOnHoldRefCount: _(e.unbondingOnHoldRefCount) ? globalThis.Number(e.unbondingOnHoldRefCount) : _(e.unbonding_on_hold_ref_count) ? globalThis.Number(e.unbonding_on_hold_ref_count) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.creationHeight !== 0 && (n.creationHeight = Math.round(e.creationHeight)), e.completionTime !== void 0 && (n.completionTime = e.completionTime.toISOString()), e.initialBalance !== "" && (n.initialBalance = e.initialBalance), e.sharesDst !== "" && (n.sharesDst = e.sharesDst), e.unbondingId !== 0 && (n.unbondingId = Math.round(e.unbondingId)), e.unbondingOnHoldRefCount !== 0 && (n.unbondingOnHoldRefCount = Math.round(e.unbondingOnHoldRefCount)), n;
  },
  create(e) {
    return ge.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = to();
    return n.creationHeight = e.creationHeight ?? 0, n.completionTime = e.completionTime ?? void 0, n.initialBalance = e.initialBalance ?? "", n.sharesDst = e.sharesDst ?? "", n.unbondingId = e.unbondingId ?? 0, n.unbondingOnHoldRefCount = e.unbondingOnHoldRefCount ?? 0, n;
  }
};
function ro() {
  return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "", entries: [] };
}
const dn = {
  encode(e, n = new g()) {
    e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorSrcAddress !== "" && n.uint32(18).string(e.validatorSrcAddress), e.validatorDstAddress !== "" && n.uint32(26).string(e.validatorDstAddress);
    for (const t of e.entries)
      ge.encode(t, n.uint32(34).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ro();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorSrcAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.validatorDstAddress = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.entries.push(ge.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: _(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : _(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorSrcAddress: _(e.validatorSrcAddress) ? globalThis.String(e.validatorSrcAddress) : _(e.validator_src_address) ? globalThis.String(e.validator_src_address) : "",
      validatorDstAddress: _(e.validatorDstAddress) ? globalThis.String(e.validatorDstAddress) : _(e.validator_dst_address) ? globalThis.String(e.validator_dst_address) : "",
      entries: globalThis.Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => ge.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorSrcAddress !== "" && (n.validatorSrcAddress = e.validatorSrcAddress), e.validatorDstAddress !== "" && (n.validatorDstAddress = e.validatorDstAddress), (t = e.entries) != null && t.length && (n.entries = e.entries.map((i) => ge.toJSON(i))), n;
  },
  create(e) {
    return dn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ro();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorSrcAddress = e.validatorSrcAddress ?? "", n.validatorDstAddress = e.validatorDstAddress ?? "", n.entries = ((t = e.entries) == null ? void 0 : t.map((i) => ge.fromPartial(i))) || [], n;
  }
};
function io() {
  return {
    unbondingTime: void 0,
    maxValidators: 0,
    maxEntries: 0,
    historicalEntries: 0,
    bondDenom: "",
    minCommissionRate: ""
  };
}
const ln = {
  encode(e, n = new g()) {
    return e.unbondingTime !== void 0 && Xe.encode(e.unbondingTime, n.uint32(10).fork()).join(), e.maxValidators !== 0 && n.uint32(16).uint32(e.maxValidators), e.maxEntries !== 0 && n.uint32(24).uint32(e.maxEntries), e.historicalEntries !== 0 && n.uint32(32).uint32(e.historicalEntries), e.bondDenom !== "" && n.uint32(42).string(e.bondDenom), e.minCommissionRate !== "" && n.uint32(50).string(e.minCommissionRate), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = io();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.unbondingTime = Xe.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.maxValidators = t.uint32();
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.maxEntries = t.uint32();
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.historicalEntries = t.uint32();
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.bondDenom = t.string();
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.minCommissionRate = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      unbondingTime: _(e.unbondingTime) ? Xe.fromJSON(e.unbondingTime) : _(e.unbonding_time) ? Xe.fromJSON(e.unbonding_time) : void 0,
      maxValidators: _(e.maxValidators) ? globalThis.Number(e.maxValidators) : _(e.max_validators) ? globalThis.Number(e.max_validators) : 0,
      maxEntries: _(e.maxEntries) ? globalThis.Number(e.maxEntries) : _(e.max_entries) ? globalThis.Number(e.max_entries) : 0,
      historicalEntries: _(e.historicalEntries) ? globalThis.Number(e.historicalEntries) : _(e.historical_entries) ? globalThis.Number(e.historical_entries) : 0,
      bondDenom: _(e.bondDenom) ? globalThis.String(e.bondDenom) : _(e.bond_denom) ? globalThis.String(e.bond_denom) : "",
      minCommissionRate: _(e.minCommissionRate) ? globalThis.String(e.minCommissionRate) : _(e.min_commission_rate) ? globalThis.String(e.min_commission_rate) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.unbondingTime !== void 0 && (n.unbondingTime = Xe.toJSON(e.unbondingTime)), e.maxValidators !== 0 && (n.maxValidators = Math.round(e.maxValidators)), e.maxEntries !== 0 && (n.maxEntries = Math.round(e.maxEntries)), e.historicalEntries !== 0 && (n.historicalEntries = Math.round(e.historicalEntries)), e.bondDenom !== "" && (n.bondDenom = e.bondDenom), e.minCommissionRate !== "" && (n.minCommissionRate = e.minCommissionRate), n;
  },
  create(e) {
    return ln.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = io();
    return n.unbondingTime = e.unbondingTime !== void 0 && e.unbondingTime !== null ? Xe.fromPartial(e.unbondingTime) : void 0, n.maxValidators = e.maxValidators ?? 0, n.maxEntries = e.maxEntries ?? 0, n.historicalEntries = e.historicalEntries ?? 0, n.bondDenom = e.bondDenom ?? "", n.minCommissionRate = e.minCommissionRate ?? "", n;
  }
};
function oo() {
  return { delegation: void 0, balance: void 0 };
}
const ed = {
  encode(e, n = new g()) {
    return e.delegation !== void 0 && sn.encode(e.delegation, n.uint32(10).fork()).join(), e.balance !== void 0 && w.encode(e.balance, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = oo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegation = sn.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.balance = w.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegation: _(e.delegation) ? sn.fromJSON(e.delegation) : void 0,
      balance: _(e.balance) ? w.fromJSON(e.balance) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegation !== void 0 && (n.delegation = sn.toJSON(e.delegation)), e.balance !== void 0 && (n.balance = w.toJSON(e.balance)), n;
  },
  create(e) {
    return ed.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = oo();
    return n.delegation = e.delegation !== void 0 && e.delegation !== null ? sn.fromPartial(e.delegation) : void 0, n.balance = e.balance !== void 0 && e.balance !== null ? w.fromPartial(e.balance) : void 0, n;
  }
};
function so() {
  return { redelegationEntry: void 0, balance: "" };
}
const cn = {
  encode(e, n = new g()) {
    return e.redelegationEntry !== void 0 && ge.encode(e.redelegationEntry, n.uint32(10).fork()).join(), e.balance !== "" && n.uint32(34).string(e.balance), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = so();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.redelegationEntry = ge.decode(t, t.uint32());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.balance = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      redelegationEntry: _(e.redelegationEntry) ? ge.fromJSON(e.redelegationEntry) : _(e.redelegation_entry) ? ge.fromJSON(e.redelegation_entry) : void 0,
      balance: _(e.balance) ? globalThis.String(e.balance) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.redelegationEntry !== void 0 && (n.redelegationEntry = ge.toJSON(e.redelegationEntry)), e.balance !== "" && (n.balance = e.balance), n;
  },
  create(e) {
    return cn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = so();
    return n.redelegationEntry = e.redelegationEntry !== void 0 && e.redelegationEntry !== null ? ge.fromPartial(e.redelegationEntry) : void 0, n.balance = e.balance ?? "", n;
  }
};
function ao() {
  return { redelegation: void 0, entries: [] };
}
const nd = {
  encode(e, n = new g()) {
    e.redelegation !== void 0 && dn.encode(e.redelegation, n.uint32(10).fork()).join();
    for (const t of e.entries)
      cn.encode(t, n.uint32(18).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ao();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.redelegation = dn.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.entries.push(cn.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      redelegation: _(e.redelegation) ? dn.fromJSON(e.redelegation) : void 0,
      entries: globalThis.Array.isArray(e == null ? void 0 : e.entries) ? e.entries.map((n) => cn.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.redelegation !== void 0 && (n.redelegation = dn.toJSON(e.redelegation)), (t = e.entries) != null && t.length && (n.entries = e.entries.map((i) => cn.toJSON(i))), n;
  },
  create(e) {
    return nd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ao();
    return n.redelegation = e.redelegation !== void 0 && e.redelegation !== null ? dn.fromPartial(e.redelegation) : void 0, n.entries = ((t = e.entries) == null ? void 0 : t.map((i) => cn.fromPartial(i))) || [], n;
  }
};
function lo() {
  return { notBondedTokens: "", bondedTokens: "" };
}
const td = {
  encode(e, n = new g()) {
    return e.notBondedTokens !== "" && n.uint32(10).string(e.notBondedTokens), e.bondedTokens !== "" && n.uint32(18).string(e.bondedTokens), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = lo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.notBondedTokens = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.bondedTokens = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      notBondedTokens: _(e.notBondedTokens) ? globalThis.String(e.notBondedTokens) : _(e.not_bonded_tokens) ? globalThis.String(e.not_bonded_tokens) : "",
      bondedTokens: _(e.bondedTokens) ? globalThis.String(e.bondedTokens) : _(e.bonded_tokens) ? globalThis.String(e.bonded_tokens) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.notBondedTokens !== "" && (n.notBondedTokens = e.notBondedTokens), e.bondedTokens !== "" && (n.bondedTokens = e.bondedTokens), n;
  },
  create(e) {
    return td.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = lo();
    return n.notBondedTokens = e.notBondedTokens ?? "", n.bondedTokens = e.bondedTokens ?? "", n;
  }
};
function co() {
  return { updates: [] };
}
const rd = {
  encode(e, n = new g()) {
    for (const t of e.updates)
      mn.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = co();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.updates.push(mn.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      updates: globalThis.Array.isArray(e == null ? void 0 : e.updates) ? e.updates.map((n) => mn.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.updates) != null && t.length && (n.updates = e.updates.map((i) => mn.toJSON(i))), n;
  },
  create(e) {
    return rd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = co();
    return n.updates = ((t = e.updates) == null ? void 0 : t.map((i) => mn.fromPartial(i))) || [], n;
  }
};
function Mn(e) {
  const n = Math.trunc(e.getTime() / 1e3), t = e.getTime() % 1e3 * 1e6;
  return { seconds: n, nanos: t };
}
function Pn(e) {
  let n = (e.seconds || 0) * 1e3;
  return n += (e.nanos || 0) / 1e6, new globalThis.Date(n);
}
function Qe(e) {
  return e instanceof globalThis.Date ? e : typeof e == "string" ? new globalThis.Date(e) : Pn(H.fromJSON(e));
}
function Pe(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function _(e) {
  return e != null;
}
const Tc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BondStatus: $a,
  Commission: nn,
  CommissionRates: fe,
  DVPair: rn,
  DVPairs: za,
  DVVTriplet: on,
  DVVTriplets: Ya,
  Delegation: sn,
  DelegationResponse: ed,
  Description: I,
  HistoricalInfo: Ka,
  Infraction: Xa,
  Params: ln,
  Pool: td,
  Redelegation: dn,
  RedelegationEntry: ge,
  RedelegationEntryResponse: cn,
  RedelegationResponse: nd,
  UnbondingDelegation: ja,
  UnbondingDelegationEntry: an,
  ValAddresses: Za,
  Validator: tn,
  ValidatorUpdates: rd,
  bondStatusFromJSON: Qa,
  bondStatusToJSON: qa,
  infractionFromJSON: dl,
  infractionToJSON: ll,
  protobufPackage: al
}, Symbol.toStringTag, { value: "Module" })), cl = "babylon.btcstaking.v1";
var id = /* @__PURE__ */ ((e) => (e[e.BIP340 = 0] = "BIP340", e[e.BIP322 = 1] = "BIP322", e[e.ECDSA = 2] = "ECDSA", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED", e))(id || {});
function et(e) {
  switch (e) {
    case 0:
    case "BIP340":
      return 0;
    case 1:
    case "BIP322":
      return 1;
    case 2:
    case "ECDSA":
      return 2;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function od(e) {
  switch (e) {
    case 0:
      return "BIP340";
    case 1:
      return "BIP322";
    case 2:
      return "ECDSA";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function uo() {
  return { btcSigType: 0, btcSig: new Uint8Array(0) };
}
const G = {
  encode(e, n = new g()) {
    return e.btcSigType !== 0 && n.uint32(8).int32(e.btcSigType), e.btcSig.length !== 0 && n.uint32(18).bytes(e.btcSig), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = uo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.btcSigType = t.int32();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.btcSig = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      btcSigType: vn(e.btcSigType) ? et(e.btcSigType) : vn(e.btc_sig_type) ? et(e.btc_sig_type) : 0,
      btcSig: vn(e.btcSig) ? nt(e.btcSig) : vn(e.btc_sig) ? nt(e.btc_sig) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.btcSigType !== 0 && (n.btcSigType = od(e.btcSigType)), e.btcSig.length !== 0 && (n.btcSig = ad(e.btcSig)), n;
  },
  create(e) {
    return G.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = uo();
    return n.btcSigType = e.btcSigType ?? 0, n.btcSig = e.btcSig ?? new Uint8Array(0), n;
  }
};
function ho() {
  return { address: "", sig: new Uint8Array(0) };
}
const sd = {
  encode(e, n = new g()) {
    return e.address !== "" && n.uint32(10).string(e.address), e.sig.length !== 0 && n.uint32(18).bytes(e.sig), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ho();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.address = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.sig = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      address: vn(e.address) ? globalThis.String(e.address) : "",
      sig: vn(e.sig) ? nt(e.sig) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.address !== "" && (n.address = e.address), e.sig.length !== 0 && (n.sig = ad(e.sig)), n;
  },
  create(e) {
    return sd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ho();
    return n.address = e.address ?? "", n.sig = e.sig ?? new Uint8Array(0), n;
  }
};
function nt(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function ad(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function vn(e) {
  return e != null;
}
const wc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BIP322Sig: sd,
  BTCSigType: id,
  ProofOfPossessionBTC: G,
  bTCSigTypeFromJSON: et,
  bTCSigTypeToJSON: od,
  protobufPackage: cl
}, Symbol.toStringTag, { value: "Module" })), ul = "babylon.btcstaking.v1";
var dd = /* @__PURE__ */ ((e) => (e[e.PENDING = 0] = "PENDING", e[e.VERIFIED = 1] = "VERIFIED", e[e.ACTIVE = 2] = "ACTIVE", e[e.UNBONDED = 3] = "UNBONDED", e[e.EXPIRED = 4] = "EXPIRED", e[e.ANY = 5] = "ANY", e[e.UNRECOGNIZED = -1] = "UNRECOGNIZED", e))(dd || {});
function hl(e) {
  switch (e) {
    case 0:
    case "PENDING":
      return 0;
    case 1:
    case "VERIFIED":
      return 1;
    case 2:
    case "ACTIVE":
      return 2;
    case 3:
    case "UNBONDED":
      return 3;
    case 4:
    case "EXPIRED":
      return 4;
    case 5:
    case "ANY":
      return 5;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function fl(e) {
  switch (e) {
    case 0:
      return "PENDING";
    case 1:
      return "VERIFIED";
    case 2:
      return "ACTIVE";
    case 3:
      return "UNBONDED";
    case 4:
      return "EXPIRED";
    case 5:
      return "ANY";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function fo() {
  return {
    addr: "",
    description: void 0,
    commission: "",
    btcPk: new Uint8Array(0),
    pop: void 0,
    slashedBabylonHeight: 0,
    slashedBtcHeight: 0,
    jailed: !1,
    highestVotedHeight: 0,
    bsnId: "",
    commissionInfo: void 0
  };
}
const ld = {
  encode(e, n = new g()) {
    return e.addr !== "" && n.uint32(10).string(e.addr), e.description !== void 0 && I.encode(e.description, n.uint32(18).fork()).join(), e.commission !== "" && n.uint32(26).string(e.commission), e.btcPk.length !== 0 && n.uint32(34).bytes(e.btcPk), e.pop !== void 0 && G.encode(e.pop, n.uint32(42).fork()).join(), e.slashedBabylonHeight !== 0 && n.uint32(48).uint64(e.slashedBabylonHeight), e.slashedBtcHeight !== 0 && n.uint32(56).uint32(e.slashedBtcHeight), e.jailed !== !1 && n.uint32(64).bool(e.jailed), e.highestVotedHeight !== 0 && n.uint32(72).uint32(e.highestVotedHeight), e.bsnId !== "" && n.uint32(82).string(e.bsnId), e.commissionInfo !== void 0 && Re.encode(e.commissionInfo, n.uint32(90).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = fo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.addr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.description = I.decode(t, t.uint32());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.commission = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.pop = G.decode(t, t.uint32());
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.slashedBabylonHeight = wn(t.uint64());
            continue;
          }
          case 7: {
            if (r !== 56)
              break;
            o.slashedBtcHeight = t.uint32();
            continue;
          }
          case 8: {
            if (r !== 64)
              break;
            o.jailed = t.bool();
            continue;
          }
          case 9: {
            if (r !== 72)
              break;
            o.highestVotedHeight = t.uint32();
            continue;
          }
          case 10: {
            if (r !== 82)
              break;
            o.bsnId = t.string();
            continue;
          }
          case 11: {
            if (r !== 90)
              break;
            o.commissionInfo = Re.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      addr: b(e.addr) ? globalThis.String(e.addr) : "",
      description: b(e.description) ? I.fromJSON(e.description) : void 0,
      commission: b(e.commission) ? globalThis.String(e.commission) : "",
      btcPk: b(e.btcPk) ? E(e.btcPk) : b(e.btc_pk) ? E(e.btc_pk) : new Uint8Array(0),
      pop: b(e.pop) ? G.fromJSON(e.pop) : void 0,
      slashedBabylonHeight: b(e.slashedBabylonHeight) ? globalThis.Number(e.slashedBabylonHeight) : b(e.slashed_babylon_height) ? globalThis.Number(e.slashed_babylon_height) : 0,
      slashedBtcHeight: b(e.slashedBtcHeight) ? globalThis.Number(e.slashedBtcHeight) : b(e.slashed_btc_height) ? globalThis.Number(e.slashed_btc_height) : 0,
      jailed: b(e.jailed) ? globalThis.Boolean(e.jailed) : !1,
      highestVotedHeight: b(e.highestVotedHeight) ? globalThis.Number(e.highestVotedHeight) : b(e.highest_voted_height) ? globalThis.Number(e.highest_voted_height) : 0,
      bsnId: b(e.bsnId) ? globalThis.String(e.bsnId) : b(e.bsn_id) ? globalThis.String(e.bsn_id) : "",
      commissionInfo: b(e.commissionInfo) ? Re.fromJSON(e.commissionInfo) : b(e.commission_info) ? Re.fromJSON(e.commission_info) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.addr !== "" && (n.addr = e.addr), e.description !== void 0 && (n.description = I.toJSON(e.description)), e.commission !== "" && (n.commission = e.commission), e.btcPk.length !== 0 && (n.btcPk = Q(e.btcPk)), e.pop !== void 0 && (n.pop = G.toJSON(e.pop)), e.slashedBabylonHeight !== 0 && (n.slashedBabylonHeight = Math.round(e.slashedBabylonHeight)), e.slashedBtcHeight !== 0 && (n.slashedBtcHeight = Math.round(e.slashedBtcHeight)), e.jailed !== !1 && (n.jailed = e.jailed), e.highestVotedHeight !== 0 && (n.highestVotedHeight = Math.round(e.highestVotedHeight)), e.bsnId !== "" && (n.bsnId = e.bsnId), e.commissionInfo !== void 0 && (n.commissionInfo = Re.toJSON(e.commissionInfo)), n;
  },
  create(e) {
    return ld.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = fo();
    return n.addr = e.addr ?? "", n.description = e.description !== void 0 && e.description !== null ? I.fromPartial(e.description) : void 0, n.commission = e.commission ?? "", n.btcPk = e.btcPk ?? new Uint8Array(0), n.pop = e.pop !== void 0 && e.pop !== null ? G.fromPartial(e.pop) : void 0, n.slashedBabylonHeight = e.slashedBabylonHeight ?? 0, n.slashedBtcHeight = e.slashedBtcHeight ?? 0, n.jailed = e.jailed ?? !1, n.highestVotedHeight = e.highestVotedHeight ?? 0, n.bsnId = e.bsnId ?? "", n.commissionInfo = e.commissionInfo !== void 0 && e.commissionInfo !== null ? Re.fromPartial(e.commissionInfo) : void 0, n;
  }
};
function go() {
  return { maxRate: "", maxChangeRate: "", updateTime: void 0 };
}
const Re = {
  encode(e, n = new g()) {
    return e.maxRate !== "" && n.uint32(10).string(e.maxRate), e.maxChangeRate !== "" && n.uint32(18).string(e.maxChangeRate), e.updateTime !== void 0 && H.encode(gl(e.updateTime), n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = go();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.maxRate = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.maxChangeRate = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.updateTime = pd(H.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      maxRate: b(e.maxRate) ? globalThis.String(e.maxRate) : b(e.max_rate) ? globalThis.String(e.max_rate) : "",
      maxChangeRate: b(e.maxChangeRate) ? globalThis.String(e.maxChangeRate) : b(e.max_change_rate) ? globalThis.String(e.max_change_rate) : "",
      updateTime: b(e.updateTime) ? Ao(e.updateTime) : b(e.update_time) ? Ao(e.update_time) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.maxRate !== "" && (n.maxRate = e.maxRate), e.maxChangeRate !== "" && (n.maxChangeRate = e.maxChangeRate), e.updateTime !== void 0 && (n.updateTime = e.updateTime.toISOString()), n;
  },
  create(e) {
    return Re.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = go();
    return n.maxRate = e.maxRate ?? "", n.maxChangeRate = e.maxChangeRate ?? "", n.updateTime = e.updateTime ?? void 0, n;
  }
};
function po() {
  return {
    btcPk: new Uint8Array(0),
    height: 0,
    votingPower: 0,
    slashedBabylonHeight: 0,
    slashedBtcHeight: 0,
    jailed: !1,
    highestVotedHeight: 0
  };
}
const cd = {
  encode(e, n = new g()) {
    return e.btcPk.length !== 0 && n.uint32(10).bytes(e.btcPk), e.height !== 0 && n.uint32(16).uint64(e.height), e.votingPower !== 0 && n.uint32(24).uint64(e.votingPower), e.slashedBabylonHeight !== 0 && n.uint32(32).uint64(e.slashedBabylonHeight), e.slashedBtcHeight !== 0 && n.uint32(40).uint32(e.slashedBtcHeight), e.jailed !== !1 && n.uint32(48).bool(e.jailed), e.highestVotedHeight !== 0 && n.uint32(56).uint32(e.highestVotedHeight), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = po();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.height = wn(t.uint64());
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.votingPower = wn(t.uint64());
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.slashedBabylonHeight = wn(t.uint64());
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.slashedBtcHeight = t.uint32();
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.jailed = t.bool();
            continue;
          }
          case 7: {
            if (r !== 56)
              break;
            o.highestVotedHeight = t.uint32();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      btcPk: b(e.btcPk) ? E(e.btcPk) : b(e.btc_pk) ? E(e.btc_pk) : new Uint8Array(0),
      height: b(e.height) ? globalThis.Number(e.height) : 0,
      votingPower: b(e.votingPower) ? globalThis.Number(e.votingPower) : b(e.voting_power) ? globalThis.Number(e.voting_power) : 0,
      slashedBabylonHeight: b(e.slashedBabylonHeight) ? globalThis.Number(e.slashedBabylonHeight) : b(e.slashed_babylon_height) ? globalThis.Number(e.slashed_babylon_height) : 0,
      slashedBtcHeight: b(e.slashedBtcHeight) ? globalThis.Number(e.slashedBtcHeight) : b(e.slashed_btc_height) ? globalThis.Number(e.slashed_btc_height) : 0,
      jailed: b(e.jailed) ? globalThis.Boolean(e.jailed) : !1,
      highestVotedHeight: b(e.highestVotedHeight) ? globalThis.Number(e.highestVotedHeight) : b(e.highest_voted_height) ? globalThis.Number(e.highest_voted_height) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.btcPk.length !== 0 && (n.btcPk = Q(e.btcPk)), e.height !== 0 && (n.height = Math.round(e.height)), e.votingPower !== 0 && (n.votingPower = Math.round(e.votingPower)), e.slashedBabylonHeight !== 0 && (n.slashedBabylonHeight = Math.round(e.slashedBabylonHeight)), e.slashedBtcHeight !== 0 && (n.slashedBtcHeight = Math.round(e.slashedBtcHeight)), e.jailed !== !1 && (n.jailed = e.jailed), e.highestVotedHeight !== 0 && (n.highestVotedHeight = Math.round(e.highestVotedHeight)), n;
  },
  create(e) {
    return cd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = po();
    return n.btcPk = e.btcPk ?? new Uint8Array(0), n.height = e.height ?? 0, n.votingPower = e.votingPower ?? 0, n.slashedBabylonHeight = e.slashedBabylonHeight ?? 0, n.slashedBtcHeight = e.slashedBtcHeight ?? 0, n.jailed = e.jailed ?? !1, n.highestVotedHeight = e.highestVotedHeight ?? 0, n;
  }
};
function mo() {
  return {
    stakerAddr: "",
    btcPk: new Uint8Array(0),
    pop: void 0,
    fpBtcPkList: [],
    stakingTime: 0,
    startHeight: 0,
    endHeight: 0,
    totalSat: 0,
    stakingTx: new Uint8Array(0),
    stakingOutputIdx: 0,
    slashingTx: new Uint8Array(0),
    delegatorSig: new Uint8Array(0),
    covenantSigs: [],
    unbondingTime: 0,
    btcUndelegation: void 0,
    paramsVersion: 0,
    btcTipHeight: 0,
    stkExp: void 0
  };
}
const un = {
  encode(e, n = new g()) {
    e.stakerAddr !== "" && n.uint32(10).string(e.stakerAddr), e.btcPk.length !== 0 && n.uint32(18).bytes(e.btcPk), e.pop !== void 0 && G.encode(e.pop, n.uint32(26).fork()).join();
    for (const t of e.fpBtcPkList)
      n.uint32(34).bytes(t);
    e.stakingTime !== 0 && n.uint32(40).uint32(e.stakingTime), e.startHeight !== 0 && n.uint32(48).uint32(e.startHeight), e.endHeight !== 0 && n.uint32(56).uint32(e.endHeight), e.totalSat !== 0 && n.uint32(64).uint64(e.totalSat), e.stakingTx.length !== 0 && n.uint32(74).bytes(e.stakingTx), e.stakingOutputIdx !== 0 && n.uint32(80).uint32(e.stakingOutputIdx), e.slashingTx.length !== 0 && n.uint32(90).bytes(e.slashingTx), e.delegatorSig.length !== 0 && n.uint32(98).bytes(e.delegatorSig);
    for (const t of e.covenantSigs)
      ae.encode(t, n.uint32(106).fork()).join();
    return e.unbondingTime !== 0 && n.uint32(112).uint32(e.unbondingTime), e.btcUndelegation !== void 0 && Je.encode(e.btcUndelegation, n.uint32(122).fork()).join(), e.paramsVersion !== 0 && n.uint32(128).uint32(e.paramsVersion), e.btcTipHeight !== 0 && n.uint32(136).uint32(e.btcTipHeight), e.stkExp !== void 0 && Oe.encode(e.stkExp, n.uint32(146).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = mo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.stakerAddr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.pop = G.decode(t, t.uint32());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.fpBtcPkList.push(t.bytes());
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.stakingTime = t.uint32();
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.startHeight = t.uint32();
            continue;
          }
          case 7: {
            if (r !== 56)
              break;
            o.endHeight = t.uint32();
            continue;
          }
          case 8: {
            if (r !== 64)
              break;
            o.totalSat = wn(t.uint64());
            continue;
          }
          case 9: {
            if (r !== 74)
              break;
            o.stakingTx = t.bytes();
            continue;
          }
          case 10: {
            if (r !== 80)
              break;
            o.stakingOutputIdx = t.uint32();
            continue;
          }
          case 11: {
            if (r !== 90)
              break;
            o.slashingTx = t.bytes();
            continue;
          }
          case 12: {
            if (r !== 98)
              break;
            o.delegatorSig = t.bytes();
            continue;
          }
          case 13: {
            if (r !== 106)
              break;
            o.covenantSigs.push(ae.decode(t, t.uint32()));
            continue;
          }
          case 14: {
            if (r !== 112)
              break;
            o.unbondingTime = t.uint32();
            continue;
          }
          case 15: {
            if (r !== 122)
              break;
            o.btcUndelegation = Je.decode(t, t.uint32());
            continue;
          }
          case 16: {
            if (r !== 128)
              break;
            o.paramsVersion = t.uint32();
            continue;
          }
          case 17: {
            if (r !== 136)
              break;
            o.btcTipHeight = t.uint32();
            continue;
          }
          case 18: {
            if (r !== 146)
              break;
            o.stkExp = Oe.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      stakerAddr: b(e.stakerAddr) ? globalThis.String(e.stakerAddr) : b(e.staker_addr) ? globalThis.String(e.staker_addr) : "",
      btcPk: b(e.btcPk) ? E(e.btcPk) : b(e.btc_pk) ? E(e.btc_pk) : new Uint8Array(0),
      pop: b(e.pop) ? G.fromJSON(e.pop) : void 0,
      fpBtcPkList: globalThis.Array.isArray(e == null ? void 0 : e.fpBtcPkList) ? e.fpBtcPkList.map((n) => E(n)) : globalThis.Array.isArray(e == null ? void 0 : e.fp_btc_pk_list) ? e.fp_btc_pk_list.map((n) => E(n)) : [],
      stakingTime: b(e.stakingTime) ? globalThis.Number(e.stakingTime) : b(e.staking_time) ? globalThis.Number(e.staking_time) : 0,
      startHeight: b(e.startHeight) ? globalThis.Number(e.startHeight) : b(e.start_height) ? globalThis.Number(e.start_height) : 0,
      endHeight: b(e.endHeight) ? globalThis.Number(e.endHeight) : b(e.end_height) ? globalThis.Number(e.end_height) : 0,
      totalSat: b(e.totalSat) ? globalThis.Number(e.totalSat) : b(e.total_sat) ? globalThis.Number(e.total_sat) : 0,
      stakingTx: b(e.stakingTx) ? E(e.stakingTx) : b(e.staking_tx) ? E(e.staking_tx) : new Uint8Array(0),
      stakingOutputIdx: b(e.stakingOutputIdx) ? globalThis.Number(e.stakingOutputIdx) : b(e.staking_output_idx) ? globalThis.Number(e.staking_output_idx) : 0,
      slashingTx: b(e.slashingTx) ? E(e.slashingTx) : b(e.slashing_tx) ? E(e.slashing_tx) : new Uint8Array(0),
      delegatorSig: b(e.delegatorSig) ? E(e.delegatorSig) : b(e.delegator_sig) ? E(e.delegator_sig) : new Uint8Array(0),
      covenantSigs: globalThis.Array.isArray(e == null ? void 0 : e.covenantSigs) ? e.covenantSigs.map((n) => ae.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.covenant_sigs) ? e.covenant_sigs.map((n) => ae.fromJSON(n)) : [],
      unbondingTime: b(e.unbondingTime) ? globalThis.Number(e.unbondingTime) : b(e.unbonding_time) ? globalThis.Number(e.unbonding_time) : 0,
      btcUndelegation: b(e.btcUndelegation) ? Je.fromJSON(e.btcUndelegation) : b(e.btc_undelegation) ? Je.fromJSON(e.btc_undelegation) : void 0,
      paramsVersion: b(e.paramsVersion) ? globalThis.Number(e.paramsVersion) : b(e.params_version) ? globalThis.Number(e.params_version) : 0,
      btcTipHeight: b(e.btcTipHeight) ? globalThis.Number(e.btcTipHeight) : b(e.btc_tip_height) ? globalThis.Number(e.btc_tip_height) : 0,
      stkExp: b(e.stkExp) ? Oe.fromJSON(e.stkExp) : b(e.stk_exp) ? Oe.fromJSON(e.stk_exp) : void 0
    };
  },
  toJSON(e) {
    var t, i;
    const n = {};
    return e.stakerAddr !== "" && (n.stakerAddr = e.stakerAddr), e.btcPk.length !== 0 && (n.btcPk = Q(e.btcPk)), e.pop !== void 0 && (n.pop = G.toJSON(e.pop)), (t = e.fpBtcPkList) != null && t.length && (n.fpBtcPkList = e.fpBtcPkList.map((s) => Q(s))), e.stakingTime !== 0 && (n.stakingTime = Math.round(e.stakingTime)), e.startHeight !== 0 && (n.startHeight = Math.round(e.startHeight)), e.endHeight !== 0 && (n.endHeight = Math.round(e.endHeight)), e.totalSat !== 0 && (n.totalSat = Math.round(e.totalSat)), e.stakingTx.length !== 0 && (n.stakingTx = Q(e.stakingTx)), e.stakingOutputIdx !== 0 && (n.stakingOutputIdx = Math.round(e.stakingOutputIdx)), e.slashingTx.length !== 0 && (n.slashingTx = Q(e.slashingTx)), e.delegatorSig.length !== 0 && (n.delegatorSig = Q(e.delegatorSig)), (i = e.covenantSigs) != null && i.length && (n.covenantSigs = e.covenantSigs.map((s) => ae.toJSON(s))), e.unbondingTime !== 0 && (n.unbondingTime = Math.round(e.unbondingTime)), e.btcUndelegation !== void 0 && (n.btcUndelegation = Je.toJSON(e.btcUndelegation)), e.paramsVersion !== 0 && (n.paramsVersion = Math.round(e.paramsVersion)), e.btcTipHeight !== 0 && (n.btcTipHeight = Math.round(e.btcTipHeight)), e.stkExp !== void 0 && (n.stkExp = Oe.toJSON(e.stkExp)), n;
  },
  create(e) {
    return un.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t, i;
    const n = mo();
    return n.stakerAddr = e.stakerAddr ?? "", n.btcPk = e.btcPk ?? new Uint8Array(0), n.pop = e.pop !== void 0 && e.pop !== null ? G.fromPartial(e.pop) : void 0, n.fpBtcPkList = ((t = e.fpBtcPkList) == null ? void 0 : t.map((s) => s)) || [], n.stakingTime = e.stakingTime ?? 0, n.startHeight = e.startHeight ?? 0, n.endHeight = e.endHeight ?? 0, n.totalSat = e.totalSat ?? 0, n.stakingTx = e.stakingTx ?? new Uint8Array(0), n.stakingOutputIdx = e.stakingOutputIdx ?? 0, n.slashingTx = e.slashingTx ?? new Uint8Array(0), n.delegatorSig = e.delegatorSig ?? new Uint8Array(0), n.covenantSigs = ((i = e.covenantSigs) == null ? void 0 : i.map((s) => ae.fromPartial(s))) || [], n.unbondingTime = e.unbondingTime ?? 0, n.btcUndelegation = e.btcUndelegation !== void 0 && e.btcUndelegation !== null ? Je.fromPartial(e.btcUndelegation) : void 0, n.paramsVersion = e.paramsVersion ?? 0, n.btcTipHeight = e.btcTipHeight ?? 0, n.stkExp = e.stkExp !== void 0 && e.stkExp !== null ? Oe.fromPartial(e.stkExp) : void 0, n;
  }
};
function ko() {
  return {
    previousStakingTxHash: new Uint8Array(0),
    otherFundingTxOut: new Uint8Array(0),
    previousStkCovenantSigs: []
  };
}
const Oe = {
  encode(e, n = new g()) {
    e.previousStakingTxHash.length !== 0 && n.uint32(10).bytes(e.previousStakingTxHash), e.otherFundingTxOut.length !== 0 && n.uint32(18).bytes(e.otherFundingTxOut);
    for (const t of e.previousStkCovenantSigs)
      se.encode(t, n.uint32(26).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ko();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.previousStakingTxHash = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.otherFundingTxOut = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.previousStkCovenantSigs.push(se.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      previousStakingTxHash: b(e.previousStakingTxHash) ? E(e.previousStakingTxHash) : b(e.previous_staking_tx_hash) ? E(e.previous_staking_tx_hash) : new Uint8Array(0),
      otherFundingTxOut: b(e.otherFundingTxOut) ? E(e.otherFundingTxOut) : b(e.other_funding_tx_out) ? E(e.other_funding_tx_out) : new Uint8Array(0),
      previousStkCovenantSigs: globalThis.Array.isArray(e == null ? void 0 : e.previousStkCovenantSigs) ? e.previousStkCovenantSigs.map((n) => se.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.previous_stk_covenant_sigs) ? e.previous_stk_covenant_sigs.map((n) => se.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.previousStakingTxHash.length !== 0 && (n.previousStakingTxHash = Q(e.previousStakingTxHash)), e.otherFundingTxOut.length !== 0 && (n.otherFundingTxOut = Q(e.otherFundingTxOut)), (t = e.previousStkCovenantSigs) != null && t.length && (n.previousStkCovenantSigs = e.previousStkCovenantSigs.map((i) => se.toJSON(i))), n;
  },
  create(e) {
    return Oe.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ko();
    return n.previousStakingTxHash = e.previousStakingTxHash ?? new Uint8Array(0), n.otherFundingTxOut = e.otherFundingTxOut ?? new Uint8Array(0), n.previousStkCovenantSigs = ((t = e.previousStkCovenantSigs) == null ? void 0 : t.map((i) => se.fromPartial(i))) || [], n;
  }
};
function _o() {
  return { spendStakeTx: new Uint8Array(0) };
}
const Ee = {
  encode(e, n = new g()) {
    return e.spendStakeTx.length !== 0 && n.uint32(10).bytes(e.spendStakeTx), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = _o();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.spendStakeTx = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      spendStakeTx: b(e.spendStakeTx) ? E(e.spendStakeTx) : b(e.spend_stake_tx) ? E(e.spend_stake_tx) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.spendStakeTx.length !== 0 && (n.spendStakeTx = Q(e.spendStakeTx)), n;
  },
  create(e) {
    return Ee.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = _o();
    return n.spendStakeTx = e.spendStakeTx ?? new Uint8Array(0), n;
  }
};
function bo() {
  return {
    unbondingTx: new Uint8Array(0),
    slashingTx: new Uint8Array(0),
    delegatorSlashingSig: new Uint8Array(0),
    covenantSlashingSigs: [],
    covenantUnbondingSigList: [],
    delegatorUnbondingInfo: void 0
  };
}
const Je = {
  encode(e, n = new g()) {
    e.unbondingTx.length !== 0 && n.uint32(10).bytes(e.unbondingTx), e.slashingTx.length !== 0 && n.uint32(18).bytes(e.slashingTx), e.delegatorSlashingSig.length !== 0 && n.uint32(26).bytes(e.delegatorSlashingSig);
    for (const t of e.covenantSlashingSigs)
      ae.encode(t, n.uint32(34).fork()).join();
    for (const t of e.covenantUnbondingSigList)
      se.encode(t, n.uint32(42).fork()).join();
    return e.delegatorUnbondingInfo !== void 0 && Ee.encode(e.delegatorUnbondingInfo, n.uint32(50).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = bo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.unbondingTx = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.slashingTx = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.delegatorSlashingSig = t.bytes();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.covenantSlashingSigs.push(ae.decode(t, t.uint32()));
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.covenantUnbondingSigList.push(se.decode(t, t.uint32()));
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.delegatorUnbondingInfo = Ee.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      unbondingTx: b(e.unbondingTx) ? E(e.unbondingTx) : b(e.unbonding_tx) ? E(e.unbonding_tx) : new Uint8Array(0),
      slashingTx: b(e.slashingTx) ? E(e.slashingTx) : b(e.slashing_tx) ? E(e.slashing_tx) : new Uint8Array(0),
      delegatorSlashingSig: b(e.delegatorSlashingSig) ? E(e.delegatorSlashingSig) : b(e.delegator_slashing_sig) ? E(e.delegator_slashing_sig) : new Uint8Array(0),
      covenantSlashingSigs: globalThis.Array.isArray(e == null ? void 0 : e.covenantSlashingSigs) ? e.covenantSlashingSigs.map((n) => ae.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.covenant_slashing_sigs) ? e.covenant_slashing_sigs.map((n) => ae.fromJSON(n)) : [],
      covenantUnbondingSigList: globalThis.Array.isArray(e == null ? void 0 : e.covenantUnbondingSigList) ? e.covenantUnbondingSigList.map((n) => se.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.covenant_unbonding_sig_list) ? e.covenant_unbonding_sig_list.map((n) => se.fromJSON(n)) : [],
      delegatorUnbondingInfo: b(e.delegatorUnbondingInfo) ? Ee.fromJSON(e.delegatorUnbondingInfo) : b(e.delegator_unbonding_info) ? Ee.fromJSON(e.delegator_unbonding_info) : void 0
    };
  },
  toJSON(e) {
    var t, i;
    const n = {};
    return e.unbondingTx.length !== 0 && (n.unbondingTx = Q(e.unbondingTx)), e.slashingTx.length !== 0 && (n.slashingTx = Q(e.slashingTx)), e.delegatorSlashingSig.length !== 0 && (n.delegatorSlashingSig = Q(e.delegatorSlashingSig)), (t = e.covenantSlashingSigs) != null && t.length && (n.covenantSlashingSigs = e.covenantSlashingSigs.map((s) => ae.toJSON(s))), (i = e.covenantUnbondingSigList) != null && i.length && (n.covenantUnbondingSigList = e.covenantUnbondingSigList.map((s) => se.toJSON(s))), e.delegatorUnbondingInfo !== void 0 && (n.delegatorUnbondingInfo = Ee.toJSON(e.delegatorUnbondingInfo)), n;
  },
  create(e) {
    return Je.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t, i;
    const n = bo();
    return n.unbondingTx = e.unbondingTx ?? new Uint8Array(0), n.slashingTx = e.slashingTx ?? new Uint8Array(0), n.delegatorSlashingSig = e.delegatorSlashingSig ?? new Uint8Array(0), n.covenantSlashingSigs = ((t = e.covenantSlashingSigs) == null ? void 0 : t.map((s) => ae.fromPartial(s))) || [], n.covenantUnbondingSigList = ((i = e.covenantUnbondingSigList) == null ? void 0 : i.map((s) => se.fromPartial(s))) || [], n.delegatorUnbondingInfo = e.delegatorUnbondingInfo !== void 0 && e.delegatorUnbondingInfo !== null ? Ee.fromPartial(e.delegatorUnbondingInfo) : void 0, n;
  }
};
function So() {
  return { dels: [] };
}
const ud = {
  encode(e, n = new g()) {
    for (const t of e.dels)
      un.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = So();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.dels.push(un.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      dels: globalThis.Array.isArray(e == null ? void 0 : e.dels) ? e.dels.map((n) => un.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.dels) != null && t.length && (n.dels = e.dels.map((i) => un.toJSON(i))), n;
  },
  create(e) {
    return ud.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = So();
    return n.dels = ((t = e.dels) == null ? void 0 : t.map((i) => un.fromPartial(i))) || [], n;
  }
};
function vo() {
  return { stakingTxHashList: [] };
}
const hd = {
  encode(e, n = new g()) {
    for (const t of e.stakingTxHashList)
      n.uint32(10).bytes(t);
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = vo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.stakingTxHashList.push(t.bytes());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      stakingTxHashList: globalThis.Array.isArray(e == null ? void 0 : e.stakingTxHashList) ? e.stakingTxHashList.map((n) => E(n)) : globalThis.Array.isArray(e == null ? void 0 : e.staking_tx_hash_list) ? e.staking_tx_hash_list.map((n) => E(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.stakingTxHashList) != null && t.length && (n.stakingTxHashList = e.stakingTxHashList.map((i) => Q(i))), n;
  },
  create(e) {
    return hd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = vo();
    return n.stakingTxHashList = ((t = e.stakingTxHashList) == null ? void 0 : t.map((i) => i)) || [], n;
  }
};
function yo() {
  return { pk: new Uint8Array(0), sig: new Uint8Array(0) };
}
const se = {
  encode(e, n = new g()) {
    return e.pk.length !== 0 && n.uint32(10).bytes(e.pk), e.sig.length !== 0 && n.uint32(18).bytes(e.sig), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = yo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.pk = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.sig = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      pk: b(e.pk) ? E(e.pk) : new Uint8Array(0),
      sig: b(e.sig) ? E(e.sig) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.pk.length !== 0 && (n.pk = Q(e.pk)), e.sig.length !== 0 && (n.sig = Q(e.sig)), n;
  },
  create(e) {
    return se.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = yo();
    return n.pk = e.pk ?? new Uint8Array(0), n.sig = e.sig ?? new Uint8Array(0), n;
  }
};
function To() {
  return { covPk: new Uint8Array(0), adaptorSigs: [] };
}
const ae = {
  encode(e, n = new g()) {
    e.covPk.length !== 0 && n.uint32(10).bytes(e.covPk);
    for (const t of e.adaptorSigs)
      n.uint32(18).bytes(t);
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = To();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.covPk = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.adaptorSigs.push(t.bytes());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      covPk: b(e.covPk) ? E(e.covPk) : b(e.cov_pk) ? E(e.cov_pk) : new Uint8Array(0),
      adaptorSigs: globalThis.Array.isArray(e == null ? void 0 : e.adaptorSigs) ? e.adaptorSigs.map((n) => E(n)) : globalThis.Array.isArray(e == null ? void 0 : e.adaptor_sigs) ? e.adaptor_sigs.map((n) => E(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.covPk.length !== 0 && (n.covPk = Q(e.covPk)), (t = e.adaptorSigs) != null && t.length && (n.adaptorSigs = e.adaptorSigs.map((i) => Q(i))), n;
  },
  create(e) {
    return ae.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = To();
    return n.covPk = e.covPk ?? new Uint8Array(0), n.adaptorSigs = ((t = e.adaptorSigs) == null ? void 0 : t.map((i) => i)) || [], n;
  }
};
function wo() {
  return { stakingTxHash: "", fpBtcPk: new Uint8Array(0), recoveredFpBtcSk: new Uint8Array(0) };
}
const fd = {
  encode(e, n = new g()) {
    return e.stakingTxHash !== "" && n.uint32(10).string(e.stakingTxHash), e.fpBtcPk.length !== 0 && n.uint32(18).bytes(e.fpBtcPk), e.recoveredFpBtcSk.length !== 0 && n.uint32(26).bytes(e.recoveredFpBtcSk), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = wo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.stakingTxHash = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.fpBtcPk = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.recoveredFpBtcSk = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      stakingTxHash: b(e.stakingTxHash) ? globalThis.String(e.stakingTxHash) : b(e.staking_tx_hash) ? globalThis.String(e.staking_tx_hash) : "",
      fpBtcPk: b(e.fpBtcPk) ? E(e.fpBtcPk) : b(e.fp_btc_pk) ? E(e.fp_btc_pk) : new Uint8Array(0),
      recoveredFpBtcSk: b(e.recoveredFpBtcSk) ? E(e.recoveredFpBtcSk) : b(e.recovered_fp_btc_sk) ? E(e.recovered_fp_btc_sk) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.stakingTxHash !== "" && (n.stakingTxHash = e.stakingTxHash), e.fpBtcPk.length !== 0 && (n.fpBtcPk = Q(e.fpBtcPk)), e.recoveredFpBtcSk.length !== 0 && (n.recoveredFpBtcSk = Q(e.recoveredFpBtcSk)), n;
  },
  create(e) {
    return fd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = wo();
    return n.stakingTxHash = e.stakingTxHash ?? "", n.fpBtcPk = e.fpBtcPk ?? new Uint8Array(0), n.recoveredFpBtcSk = e.recoveredFpBtcSk ?? new Uint8Array(0), n;
  }
};
function Po() {
  return { key: void 0, proof: new Uint8Array(0) };
}
const X = {
  encode(e, n = new g()) {
    return e.key !== void 0 && z.encode(e.key, n.uint32(10).fork()).join(), e.proof.length !== 0 && n.uint32(18).bytes(e.proof), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Po();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.key = z.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.proof = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      key: b(e.key) ? z.fromJSON(e.key) : void 0,
      proof: b(e.proof) ? E(e.proof) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.key !== void 0 && (n.key = z.toJSON(e.key)), e.proof.length !== 0 && (n.proof = Q(e.proof)), n;
  },
  create(e) {
    return X.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Po();
    return n.key = e.key !== void 0 && e.key !== null ? z.fromPartial(e.key) : void 0, n.proof = e.proof ?? new Uint8Array(0), n;
  }
};
function Do() {
  return { blockDiff: 0, rollbackFrom: void 0, rollbackTo: void 0 };
}
const gd = {
  encode(e, n = new g()) {
    return e.blockDiff !== 0 && n.uint32(8).uint32(e.blockDiff), e.rollbackFrom !== void 0 && re.encode(e.rollbackFrom, n.uint32(18).fork()).join(), e.rollbackTo !== void 0 && re.encode(e.rollbackTo, n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Do();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.blockDiff = t.uint32();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.rollbackFrom = re.decode(t, t.uint32());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.rollbackTo = re.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      blockDiff: b(e.blockDiff) ? globalThis.Number(e.blockDiff) : b(e.block_diff) ? globalThis.Number(e.block_diff) : 0,
      rollbackFrom: b(e.rollbackFrom) ? re.fromJSON(e.rollbackFrom) : b(e.rollback_from) ? re.fromJSON(e.rollback_from) : void 0,
      rollbackTo: b(e.rollbackTo) ? re.fromJSON(e.rollbackTo) : b(e.rollback_to) ? re.fromJSON(e.rollback_to) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.blockDiff !== 0 && (n.blockDiff = Math.round(e.blockDiff)), e.rollbackFrom !== void 0 && (n.rollbackFrom = re.toJSON(e.rollbackFrom)), e.rollbackTo !== void 0 && (n.rollbackTo = re.toJSON(e.rollbackTo)), n;
  },
  create(e) {
    return gd.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Do();
    return n.blockDiff = e.blockDiff ?? 0, n.rollbackFrom = e.rollbackFrom !== void 0 && e.rollbackFrom !== null ? re.fromPartial(e.rollbackFrom) : void 0, n.rollbackTo = e.rollbackTo !== void 0 && e.rollbackTo !== null ? re.fromPartial(e.rollbackTo) : void 0, n;
  }
};
function E(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function Q(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function gl(e) {
  const n = Math.trunc(e.getTime() / 1e3), t = e.getTime() % 1e3 * 1e6;
  return { seconds: n, nanos: t };
}
function pd(e) {
  let n = (e.seconds || 0) * 1e3;
  return n += (e.nanos || 0) / 1e6, new globalThis.Date(n);
}
function Ao(e) {
  return e instanceof globalThis.Date ? e : typeof e == "string" ? new globalThis.Date(e) : pd(H.fromJSON(e));
}
function wn(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function b(e) {
  return e != null;
}
const Pc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCDelegation: un,
  BTCDelegationStatus: dd,
  BTCDelegatorDelegationIndex: hd,
  BTCDelegatorDelegations: ud,
  BTCUndelegation: Je,
  CommissionInfo: Re,
  CovenantAdaptorSignatures: ae,
  DelegatorUnbondingInfo: Ee,
  FinalityProvider: ld,
  FinalityProviderWithMeta: cd,
  InclusionProof: X,
  LargestBtcReOrg: gd,
  SelectiveSlashingEvidence: fd,
  SignatureInfo: se,
  StakeExpansion: Oe,
  bTCDelegationStatusFromJSON: hl,
  bTCDelegationStatusToJSON: fl,
  protobufPackage: ul
}, Symbol.toStringTag, { value: "Module" }));
function No() {
  return {
    covenantPks: [],
    covenantQuorum: 0,
    minStakingValueSat: 0,
    maxStakingValueSat: 0,
    minStakingTimeBlocks: 0,
    maxStakingTimeBlocks: 0,
    slashingPkScript: new Uint8Array(0),
    minSlashingTxFeeSat: 0,
    slashingRate: "",
    unbondingTimeBlocks: 0,
    unbondingFeeSat: 0,
    minCommissionRate: "",
    delegationCreationBaseGasFee: 0,
    allowListExpirationHeight: 0,
    btcActivationHeight: 0,
    maxFinalityProviders: 0
  };
}
const bn = {
  encode(e, n = new g()) {
    for (const t of e.covenantPks)
      n.uint32(10).bytes(t);
    return e.covenantQuorum !== 0 && n.uint32(16).uint32(e.covenantQuorum), e.minStakingValueSat !== 0 && n.uint32(24).int64(e.minStakingValueSat), e.maxStakingValueSat !== 0 && n.uint32(32).int64(e.maxStakingValueSat), e.minStakingTimeBlocks !== 0 && n.uint32(40).uint32(e.minStakingTimeBlocks), e.maxStakingTimeBlocks !== 0 && n.uint32(48).uint32(e.maxStakingTimeBlocks), e.slashingPkScript.length !== 0 && n.uint32(58).bytes(e.slashingPkScript), e.minSlashingTxFeeSat !== 0 && n.uint32(64).int64(e.minSlashingTxFeeSat), e.slashingRate !== "" && n.uint32(74).string(e.slashingRate), e.unbondingTimeBlocks !== 0 && n.uint32(80).uint32(e.unbondingTimeBlocks), e.unbondingFeeSat !== 0 && n.uint32(88).int64(e.unbondingFeeSat), e.minCommissionRate !== "" && n.uint32(98).string(e.minCommissionRate), e.delegationCreationBaseGasFee !== 0 && n.uint32(104).uint64(e.delegationCreationBaseGasFee), e.allowListExpirationHeight !== 0 && n.uint32(112).uint64(e.allowListExpirationHeight), e.btcActivationHeight !== 0 && n.uint32(120).uint32(e.btcActivationHeight), e.maxFinalityProviders !== 0 && n.uint32(128).uint32(e.maxFinalityProviders), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = No();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.covenantPks.push(t.bytes());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.covenantQuorum = t.uint32();
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.minStakingValueSat = gn(t.int64());
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.maxStakingValueSat = gn(t.int64());
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.minStakingTimeBlocks = t.uint32();
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.maxStakingTimeBlocks = t.uint32();
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.slashingPkScript = t.bytes();
            continue;
          }
          case 8: {
            if (r !== 64)
              break;
            o.minSlashingTxFeeSat = gn(t.int64());
            continue;
          }
          case 9: {
            if (r !== 74)
              break;
            o.slashingRate = t.string();
            continue;
          }
          case 10: {
            if (r !== 80)
              break;
            o.unbondingTimeBlocks = t.uint32();
            continue;
          }
          case 11: {
            if (r !== 88)
              break;
            o.unbondingFeeSat = gn(t.int64());
            continue;
          }
          case 12: {
            if (r !== 98)
              break;
            o.minCommissionRate = t.string();
            continue;
          }
          case 13: {
            if (r !== 104)
              break;
            o.delegationCreationBaseGasFee = gn(t.uint64());
            continue;
          }
          case 14: {
            if (r !== 112)
              break;
            o.allowListExpirationHeight = gn(t.uint64());
            continue;
          }
          case 15: {
            if (r !== 120)
              break;
            o.btcActivationHeight = t.uint32();
            continue;
          }
          case 16: {
            if (r !== 128)
              break;
            o.maxFinalityProviders = t.uint32();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      covenantPks: globalThis.Array.isArray(e == null ? void 0 : e.covenantPks) ? e.covenantPks.map((n) => Rn(n)) : globalThis.Array.isArray(e == null ? void 0 : e.covenant_pks) ? e.covenant_pks.map((n) => Rn(n)) : [],
      covenantQuorum: M(e.covenantQuorum) ? globalThis.Number(e.covenantQuorum) : M(e.covenant_quorum) ? globalThis.Number(e.covenant_quorum) : 0,
      minStakingValueSat: M(e.minStakingValueSat) ? globalThis.Number(e.minStakingValueSat) : M(e.min_staking_value_sat) ? globalThis.Number(e.min_staking_value_sat) : 0,
      maxStakingValueSat: M(e.maxStakingValueSat) ? globalThis.Number(e.maxStakingValueSat) : M(e.max_staking_value_sat) ? globalThis.Number(e.max_staking_value_sat) : 0,
      minStakingTimeBlocks: M(e.minStakingTimeBlocks) ? globalThis.Number(e.minStakingTimeBlocks) : M(e.min_staking_time_blocks) ? globalThis.Number(e.min_staking_time_blocks) : 0,
      maxStakingTimeBlocks: M(e.maxStakingTimeBlocks) ? globalThis.Number(e.maxStakingTimeBlocks) : M(e.max_staking_time_blocks) ? globalThis.Number(e.max_staking_time_blocks) : 0,
      slashingPkScript: M(e.slashingPkScript) ? Rn(e.slashingPkScript) : M(e.slashing_pk_script) ? Rn(e.slashing_pk_script) : new Uint8Array(0),
      minSlashingTxFeeSat: M(e.minSlashingTxFeeSat) ? globalThis.Number(e.minSlashingTxFeeSat) : M(e.min_slashing_tx_fee_sat) ? globalThis.Number(e.min_slashing_tx_fee_sat) : 0,
      slashingRate: M(e.slashingRate) ? globalThis.String(e.slashingRate) : M(e.slashing_rate) ? globalThis.String(e.slashing_rate) : "",
      unbondingTimeBlocks: M(e.unbondingTimeBlocks) ? globalThis.Number(e.unbondingTimeBlocks) : M(e.unbonding_time_blocks) ? globalThis.Number(e.unbonding_time_blocks) : 0,
      unbondingFeeSat: M(e.unbondingFeeSat) ? globalThis.Number(e.unbondingFeeSat) : M(e.unbonding_fee_sat) ? globalThis.Number(e.unbonding_fee_sat) : 0,
      minCommissionRate: M(e.minCommissionRate) ? globalThis.String(e.minCommissionRate) : M(e.min_commission_rate) ? globalThis.String(e.min_commission_rate) : "",
      delegationCreationBaseGasFee: M(e.delegationCreationBaseGasFee) ? globalThis.Number(e.delegationCreationBaseGasFee) : M(e.delegation_creation_base_gas_fee) ? globalThis.Number(e.delegation_creation_base_gas_fee) : 0,
      allowListExpirationHeight: M(e.allowListExpirationHeight) ? globalThis.Number(e.allowListExpirationHeight) : M(e.allow_list_expiration_height) ? globalThis.Number(e.allow_list_expiration_height) : 0,
      btcActivationHeight: M(e.btcActivationHeight) ? globalThis.Number(e.btcActivationHeight) : M(e.btc_activation_height) ? globalThis.Number(e.btc_activation_height) : 0,
      maxFinalityProviders: M(e.maxFinalityProviders) ? globalThis.Number(e.maxFinalityProviders) : M(e.max_finality_providers) ? globalThis.Number(e.max_finality_providers) : 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.covenantPks) != null && t.length && (n.covenantPks = e.covenantPks.map((i) => xo(i))), e.covenantQuorum !== 0 && (n.covenantQuorum = Math.round(e.covenantQuorum)), e.minStakingValueSat !== 0 && (n.minStakingValueSat = Math.round(e.minStakingValueSat)), e.maxStakingValueSat !== 0 && (n.maxStakingValueSat = Math.round(e.maxStakingValueSat)), e.minStakingTimeBlocks !== 0 && (n.minStakingTimeBlocks = Math.round(e.minStakingTimeBlocks)), e.maxStakingTimeBlocks !== 0 && (n.maxStakingTimeBlocks = Math.round(e.maxStakingTimeBlocks)), e.slashingPkScript.length !== 0 && (n.slashingPkScript = xo(e.slashingPkScript)), e.minSlashingTxFeeSat !== 0 && (n.minSlashingTxFeeSat = Math.round(e.minSlashingTxFeeSat)), e.slashingRate !== "" && (n.slashingRate = e.slashingRate), e.unbondingTimeBlocks !== 0 && (n.unbondingTimeBlocks = Math.round(e.unbondingTimeBlocks)), e.unbondingFeeSat !== 0 && (n.unbondingFeeSat = Math.round(e.unbondingFeeSat)), e.minCommissionRate !== "" && (n.minCommissionRate = e.minCommissionRate), e.delegationCreationBaseGasFee !== 0 && (n.delegationCreationBaseGasFee = Math.round(e.delegationCreationBaseGasFee)), e.allowListExpirationHeight !== 0 && (n.allowListExpirationHeight = Math.round(e.allowListExpirationHeight)), e.btcActivationHeight !== 0 && (n.btcActivationHeight = Math.round(e.btcActivationHeight)), e.maxFinalityProviders !== 0 && (n.maxFinalityProviders = Math.round(e.maxFinalityProviders)), n;
  },
  create(e) {
    return bn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = No();
    return n.covenantPks = ((t = e.covenantPks) == null ? void 0 : t.map((i) => i)) || [], n.covenantQuorum = e.covenantQuorum ?? 0, n.minStakingValueSat = e.minStakingValueSat ?? 0, n.maxStakingValueSat = e.maxStakingValueSat ?? 0, n.minStakingTimeBlocks = e.minStakingTimeBlocks ?? 0, n.maxStakingTimeBlocks = e.maxStakingTimeBlocks ?? 0, n.slashingPkScript = e.slashingPkScript ?? new Uint8Array(0), n.minSlashingTxFeeSat = e.minSlashingTxFeeSat ?? 0, n.slashingRate = e.slashingRate ?? "", n.unbondingTimeBlocks = e.unbondingTimeBlocks ?? 0, n.unbondingFeeSat = e.unbondingFeeSat ?? 0, n.minCommissionRate = e.minCommissionRate ?? "", n.delegationCreationBaseGasFee = e.delegationCreationBaseGasFee ?? 0, n.allowListExpirationHeight = e.allowListExpirationHeight ?? 0, n.btcActivationHeight = e.btcActivationHeight ?? 0, n.maxFinalityProviders = e.maxFinalityProviders ?? 0, n;
  }
};
function Rn(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function xo(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function gn(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function M(e) {
  return e != null;
}
const pl = "babylon.btcstaking.v1";
function Bo() {
  return {
    addr: "",
    description: void 0,
    btcPk: new Uint8Array(0),
    pop: void 0,
    bsnId: "",
    commission: void 0
  };
}
const vt = {
  encode(e, n = new g()) {
    return e.addr !== "" && n.uint32(10).string(e.addr), e.description !== void 0 && I.encode(e.description, n.uint32(18).fork()).join(), e.btcPk.length !== 0 && n.uint32(34).bytes(e.btcPk), e.pop !== void 0 && G.encode(e.pop, n.uint32(42).fork()).join(), e.bsnId !== "" && n.uint32(50).string(e.bsnId), e.commission !== void 0 && hn.encode(e.commission, n.uint32(58).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Bo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.addr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.description = I.decode(t, t.uint32());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.pop = G.decode(t, t.uint32());
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.bsnId = t.string();
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.commission = hn.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      addr: k(e.addr) ? globalThis.String(e.addr) : "",
      description: k(e.description) ? I.fromJSON(e.description) : void 0,
      btcPk: k(e.btcPk) ? N(e.btcPk) : k(e.btc_pk) ? N(e.btc_pk) : new Uint8Array(0),
      pop: k(e.pop) ? G.fromJSON(e.pop) : void 0,
      bsnId: k(e.bsnId) ? globalThis.String(e.bsnId) : k(e.bsn_id) ? globalThis.String(e.bsn_id) : "",
      commission: k(e.commission) ? hn.fromJSON(e.commission) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.addr !== "" && (n.addr = e.addr), e.description !== void 0 && (n.description = I.toJSON(e.description)), e.btcPk.length !== 0 && (n.btcPk = F(e.btcPk)), e.pop !== void 0 && (n.pop = G.toJSON(e.pop)), e.bsnId !== "" && (n.bsnId = e.bsnId), e.commission !== void 0 && (n.commission = hn.toJSON(e.commission)), n;
  },
  create(e) {
    return vt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Bo();
    return n.addr = e.addr ?? "", n.description = e.description !== void 0 && e.description !== null ? I.fromPartial(e.description) : void 0, n.btcPk = e.btcPk ?? new Uint8Array(0), n.pop = e.pop !== void 0 && e.pop !== null ? G.fromPartial(e.pop) : void 0, n.bsnId = e.bsnId ?? "", n.commission = e.commission !== void 0 && e.commission !== null ? hn.fromPartial(e.commission) : void 0, n;
  }
};
function Ro() {
  return {};
}
const yt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ro();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return yt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Ro();
  }
};
function Oo() {
  return { rate: "", maxRate: "", maxChangeRate: "" };
}
const hn = {
  encode(e, n = new g()) {
    return e.rate !== "" && n.uint32(10).string(e.rate), e.maxRate !== "" && n.uint32(18).string(e.maxRate), e.maxChangeRate !== "" && n.uint32(26).string(e.maxChangeRate), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Oo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.rate = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.maxRate = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.maxChangeRate = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      rate: k(e.rate) ? globalThis.String(e.rate) : "",
      maxRate: k(e.maxRate) ? globalThis.String(e.maxRate) : k(e.max_rate) ? globalThis.String(e.max_rate) : "",
      maxChangeRate: k(e.maxChangeRate) ? globalThis.String(e.maxChangeRate) : k(e.max_change_rate) ? globalThis.String(e.max_change_rate) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.rate !== "" && (n.rate = e.rate), e.maxRate !== "" && (n.maxRate = e.maxRate), e.maxChangeRate !== "" && (n.maxChangeRate = e.maxChangeRate), n;
  },
  create(e) {
    return hn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Oo();
    return n.rate = e.rate ?? "", n.maxRate = e.maxRate ?? "", n.maxChangeRate = e.maxChangeRate ?? "", n;
  }
};
function Eo() {
  return { addr: "", btcPk: new Uint8Array(0), description: void 0, commission: "" };
}
const Tt = {
  encode(e, n = new g()) {
    return e.addr !== "" && n.uint32(10).string(e.addr), e.btcPk.length !== 0 && n.uint32(18).bytes(e.btcPk), e.description !== void 0 && I.encode(e.description, n.uint32(26).fork()).join(), e.commission !== "" && n.uint32(34).string(e.commission), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Eo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.addr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.description = I.decode(t, t.uint32());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.commission = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      addr: k(e.addr) ? globalThis.String(e.addr) : "",
      btcPk: k(e.btcPk) ? N(e.btcPk) : k(e.btc_pk) ? N(e.btc_pk) : new Uint8Array(0),
      description: k(e.description) ? I.fromJSON(e.description) : void 0,
      commission: k(e.commission) ? globalThis.String(e.commission) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.addr !== "" && (n.addr = e.addr), e.btcPk.length !== 0 && (n.btcPk = F(e.btcPk)), e.description !== void 0 && (n.description = I.toJSON(e.description)), e.commission !== "" && (n.commission = e.commission), n;
  },
  create(e) {
    return Tt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Eo();
    return n.addr = e.addr ?? "", n.btcPk = e.btcPk ?? new Uint8Array(0), n.description = e.description !== void 0 && e.description !== null ? I.fromPartial(e.description) : void 0, n.commission = e.commission ?? "", n;
  }
};
function Jo() {
  return {};
}
const wt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Jo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return wt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Jo();
  }
};
function Io() {
  return {
    stakerAddr: "",
    pop: void 0,
    btcPk: new Uint8Array(0),
    fpBtcPkList: [],
    stakingTime: 0,
    stakingValue: 0,
    stakingTx: new Uint8Array(0),
    stakingTxInclusionProof: void 0,
    slashingTx: new Uint8Array(0),
    delegatorSlashingSig: new Uint8Array(0),
    unbondingTime: 0,
    unbondingTx: new Uint8Array(0),
    unbondingValue: 0,
    unbondingSlashingTx: new Uint8Array(0),
    delegatorUnbondingSlashingSig: new Uint8Array(0)
  };
}
const Vn = {
  encode(e, n = new g()) {
    e.stakerAddr !== "" && n.uint32(10).string(e.stakerAddr), e.pop !== void 0 && G.encode(e.pop, n.uint32(18).fork()).join(), e.btcPk.length !== 0 && n.uint32(26).bytes(e.btcPk);
    for (const t of e.fpBtcPkList)
      n.uint32(34).bytes(t);
    return e.stakingTime !== 0 && n.uint32(40).uint32(e.stakingTime), e.stakingValue !== 0 && n.uint32(48).int64(e.stakingValue), e.stakingTx.length !== 0 && n.uint32(58).bytes(e.stakingTx), e.stakingTxInclusionProof !== void 0 && X.encode(e.stakingTxInclusionProof, n.uint32(66).fork()).join(), e.slashingTx.length !== 0 && n.uint32(74).bytes(e.slashingTx), e.delegatorSlashingSig.length !== 0 && n.uint32(82).bytes(e.delegatorSlashingSig), e.unbondingTime !== 0 && n.uint32(88).uint32(e.unbondingTime), e.unbondingTx.length !== 0 && n.uint32(98).bytes(e.unbondingTx), e.unbondingValue !== 0 && n.uint32(104).int64(e.unbondingValue), e.unbondingSlashingTx.length !== 0 && n.uint32(114).bytes(e.unbondingSlashingTx), e.delegatorUnbondingSlashingSig.length !== 0 && n.uint32(122).bytes(e.delegatorUnbondingSlashingSig), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Io();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.stakerAddr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pop = G.decode(t, t.uint32());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.fpBtcPkList.push(t.bytes());
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.stakingTime = t.uint32();
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.stakingValue = En(t.int64());
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.stakingTx = t.bytes();
            continue;
          }
          case 8: {
            if (r !== 66)
              break;
            o.stakingTxInclusionProof = X.decode(t, t.uint32());
            continue;
          }
          case 9: {
            if (r !== 74)
              break;
            o.slashingTx = t.bytes();
            continue;
          }
          case 10: {
            if (r !== 82)
              break;
            o.delegatorSlashingSig = t.bytes();
            continue;
          }
          case 11: {
            if (r !== 88)
              break;
            o.unbondingTime = t.uint32();
            continue;
          }
          case 12: {
            if (r !== 98)
              break;
            o.unbondingTx = t.bytes();
            continue;
          }
          case 13: {
            if (r !== 104)
              break;
            o.unbondingValue = En(t.int64());
            continue;
          }
          case 14: {
            if (r !== 114)
              break;
            o.unbondingSlashingTx = t.bytes();
            continue;
          }
          case 15: {
            if (r !== 122)
              break;
            o.delegatorUnbondingSlashingSig = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      stakerAddr: k(e.stakerAddr) ? globalThis.String(e.stakerAddr) : k(e.staker_addr) ? globalThis.String(e.staker_addr) : "",
      pop: k(e.pop) ? G.fromJSON(e.pop) : void 0,
      btcPk: k(e.btcPk) ? N(e.btcPk) : k(e.btc_pk) ? N(e.btc_pk) : new Uint8Array(0),
      fpBtcPkList: globalThis.Array.isArray(e == null ? void 0 : e.fpBtcPkList) ? e.fpBtcPkList.map((n) => N(n)) : globalThis.Array.isArray(e == null ? void 0 : e.fp_btc_pk_list) ? e.fp_btc_pk_list.map((n) => N(n)) : [],
      stakingTime: k(e.stakingTime) ? globalThis.Number(e.stakingTime) : k(e.staking_time) ? globalThis.Number(e.staking_time) : 0,
      stakingValue: k(e.stakingValue) ? globalThis.Number(e.stakingValue) : k(e.staking_value) ? globalThis.Number(e.staking_value) : 0,
      stakingTx: k(e.stakingTx) ? N(e.stakingTx) : k(e.staking_tx) ? N(e.staking_tx) : new Uint8Array(0),
      stakingTxInclusionProof: k(e.stakingTxInclusionProof) ? X.fromJSON(e.stakingTxInclusionProof) : k(e.staking_tx_inclusion_proof) ? X.fromJSON(e.staking_tx_inclusion_proof) : void 0,
      slashingTx: k(e.slashingTx) ? N(e.slashingTx) : k(e.slashing_tx) ? N(e.slashing_tx) : new Uint8Array(0),
      delegatorSlashingSig: k(e.delegatorSlashingSig) ? N(e.delegatorSlashingSig) : k(e.delegator_slashing_sig) ? N(e.delegator_slashing_sig) : new Uint8Array(0),
      unbondingTime: k(e.unbondingTime) ? globalThis.Number(e.unbondingTime) : k(e.unbonding_time) ? globalThis.Number(e.unbonding_time) : 0,
      unbondingTx: k(e.unbondingTx) ? N(e.unbondingTx) : k(e.unbonding_tx) ? N(e.unbonding_tx) : new Uint8Array(0),
      unbondingValue: k(e.unbondingValue) ? globalThis.Number(e.unbondingValue) : k(e.unbonding_value) ? globalThis.Number(e.unbonding_value) : 0,
      unbondingSlashingTx: k(e.unbondingSlashingTx) ? N(e.unbondingSlashingTx) : k(e.unbonding_slashing_tx) ? N(e.unbonding_slashing_tx) : new Uint8Array(0),
      delegatorUnbondingSlashingSig: k(e.delegatorUnbondingSlashingSig) ? N(e.delegatorUnbondingSlashingSig) : k(e.delegator_unbonding_slashing_sig) ? N(e.delegator_unbonding_slashing_sig) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.stakerAddr !== "" && (n.stakerAddr = e.stakerAddr), e.pop !== void 0 && (n.pop = G.toJSON(e.pop)), e.btcPk.length !== 0 && (n.btcPk = F(e.btcPk)), (t = e.fpBtcPkList) != null && t.length && (n.fpBtcPkList = e.fpBtcPkList.map((i) => F(i))), e.stakingTime !== 0 && (n.stakingTime = Math.round(e.stakingTime)), e.stakingValue !== 0 && (n.stakingValue = Math.round(e.stakingValue)), e.stakingTx.length !== 0 && (n.stakingTx = F(e.stakingTx)), e.stakingTxInclusionProof !== void 0 && (n.stakingTxInclusionProof = X.toJSON(e.stakingTxInclusionProof)), e.slashingTx.length !== 0 && (n.slashingTx = F(e.slashingTx)), e.delegatorSlashingSig.length !== 0 && (n.delegatorSlashingSig = F(e.delegatorSlashingSig)), e.unbondingTime !== 0 && (n.unbondingTime = Math.round(e.unbondingTime)), e.unbondingTx.length !== 0 && (n.unbondingTx = F(e.unbondingTx)), e.unbondingValue !== 0 && (n.unbondingValue = Math.round(e.unbondingValue)), e.unbondingSlashingTx.length !== 0 && (n.unbondingSlashingTx = F(e.unbondingSlashingTx)), e.delegatorUnbondingSlashingSig.length !== 0 && (n.delegatorUnbondingSlashingSig = F(e.delegatorUnbondingSlashingSig)), n;
  },
  create(e) {
    return Vn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Io();
    return n.stakerAddr = e.stakerAddr ?? "", n.pop = e.pop !== void 0 && e.pop !== null ? G.fromPartial(e.pop) : void 0, n.btcPk = e.btcPk ?? new Uint8Array(0), n.fpBtcPkList = ((t = e.fpBtcPkList) == null ? void 0 : t.map((i) => i)) || [], n.stakingTime = e.stakingTime ?? 0, n.stakingValue = e.stakingValue ?? 0, n.stakingTx = e.stakingTx ?? new Uint8Array(0), n.stakingTxInclusionProof = e.stakingTxInclusionProof !== void 0 && e.stakingTxInclusionProof !== null ? X.fromPartial(e.stakingTxInclusionProof) : void 0, n.slashingTx = e.slashingTx ?? new Uint8Array(0), n.delegatorSlashingSig = e.delegatorSlashingSig ?? new Uint8Array(0), n.unbondingTime = e.unbondingTime ?? 0, n.unbondingTx = e.unbondingTx ?? new Uint8Array(0), n.unbondingValue = e.unbondingValue ?? 0, n.unbondingSlashingTx = e.unbondingSlashingTx ?? new Uint8Array(0), n.delegatorUnbondingSlashingSig = e.delegatorUnbondingSlashingSig ?? new Uint8Array(0), n;
  }
};
function Co() {
  return {};
}
const Pt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Co();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Pt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Co();
  }
};
function Uo() {
  return {
    stakerAddr: "",
    pop: void 0,
    btcPk: new Uint8Array(0),
    fpBtcPkList: [],
    stakingTime: 0,
    stakingValue: 0,
    stakingTx: new Uint8Array(0),
    slashingTx: new Uint8Array(0),
    delegatorSlashingSig: new Uint8Array(0),
    unbondingTime: 0,
    unbondingTx: new Uint8Array(0),
    unbondingValue: 0,
    unbondingSlashingTx: new Uint8Array(0),
    delegatorUnbondingSlashingSig: new Uint8Array(0),
    previousStakingTxHash: "",
    fundingTx: new Uint8Array(0)
  };
}
const Dn = {
  encode(e, n = new g()) {
    e.stakerAddr !== "" && n.uint32(10).string(e.stakerAddr), e.pop !== void 0 && G.encode(e.pop, n.uint32(18).fork()).join(), e.btcPk.length !== 0 && n.uint32(26).bytes(e.btcPk);
    for (const t of e.fpBtcPkList)
      n.uint32(34).bytes(t);
    return e.stakingTime !== 0 && n.uint32(40).uint32(e.stakingTime), e.stakingValue !== 0 && n.uint32(48).int64(e.stakingValue), e.stakingTx.length !== 0 && n.uint32(58).bytes(e.stakingTx), e.slashingTx.length !== 0 && n.uint32(66).bytes(e.slashingTx), e.delegatorSlashingSig.length !== 0 && n.uint32(74).bytes(e.delegatorSlashingSig), e.unbondingTime !== 0 && n.uint32(80).uint32(e.unbondingTime), e.unbondingTx.length !== 0 && n.uint32(90).bytes(e.unbondingTx), e.unbondingValue !== 0 && n.uint32(96).int64(e.unbondingValue), e.unbondingSlashingTx.length !== 0 && n.uint32(106).bytes(e.unbondingSlashingTx), e.delegatorUnbondingSlashingSig.length !== 0 && n.uint32(114).bytes(e.delegatorUnbondingSlashingSig), e.previousStakingTxHash !== "" && n.uint32(122).string(e.previousStakingTxHash), e.fundingTx.length !== 0 && n.uint32(130).bytes(e.fundingTx), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Uo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.stakerAddr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pop = G.decode(t, t.uint32());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.fpBtcPkList.push(t.bytes());
            continue;
          }
          case 5: {
            if (r !== 40)
              break;
            o.stakingTime = t.uint32();
            continue;
          }
          case 6: {
            if (r !== 48)
              break;
            o.stakingValue = En(t.int64());
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.stakingTx = t.bytes();
            continue;
          }
          case 8: {
            if (r !== 66)
              break;
            o.slashingTx = t.bytes();
            continue;
          }
          case 9: {
            if (r !== 74)
              break;
            o.delegatorSlashingSig = t.bytes();
            continue;
          }
          case 10: {
            if (r !== 80)
              break;
            o.unbondingTime = t.uint32();
            continue;
          }
          case 11: {
            if (r !== 90)
              break;
            o.unbondingTx = t.bytes();
            continue;
          }
          case 12: {
            if (r !== 96)
              break;
            o.unbondingValue = En(t.int64());
            continue;
          }
          case 13: {
            if (r !== 106)
              break;
            o.unbondingSlashingTx = t.bytes();
            continue;
          }
          case 14: {
            if (r !== 114)
              break;
            o.delegatorUnbondingSlashingSig = t.bytes();
            continue;
          }
          case 15: {
            if (r !== 122)
              break;
            o.previousStakingTxHash = t.string();
            continue;
          }
          case 16: {
            if (r !== 130)
              break;
            o.fundingTx = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      stakerAddr: k(e.stakerAddr) ? globalThis.String(e.stakerAddr) : k(e.staker_addr) ? globalThis.String(e.staker_addr) : "",
      pop: k(e.pop) ? G.fromJSON(e.pop) : void 0,
      btcPk: k(e.btcPk) ? N(e.btcPk) : k(e.btc_pk) ? N(e.btc_pk) : new Uint8Array(0),
      fpBtcPkList: globalThis.Array.isArray(e == null ? void 0 : e.fpBtcPkList) ? e.fpBtcPkList.map((n) => N(n)) : globalThis.Array.isArray(e == null ? void 0 : e.fp_btc_pk_list) ? e.fp_btc_pk_list.map((n) => N(n)) : [],
      stakingTime: k(e.stakingTime) ? globalThis.Number(e.stakingTime) : k(e.staking_time) ? globalThis.Number(e.staking_time) : 0,
      stakingValue: k(e.stakingValue) ? globalThis.Number(e.stakingValue) : k(e.staking_value) ? globalThis.Number(e.staking_value) : 0,
      stakingTx: k(e.stakingTx) ? N(e.stakingTx) : k(e.staking_tx) ? N(e.staking_tx) : new Uint8Array(0),
      slashingTx: k(e.slashingTx) ? N(e.slashingTx) : k(e.slashing_tx) ? N(e.slashing_tx) : new Uint8Array(0),
      delegatorSlashingSig: k(e.delegatorSlashingSig) ? N(e.delegatorSlashingSig) : k(e.delegator_slashing_sig) ? N(e.delegator_slashing_sig) : new Uint8Array(0),
      unbondingTime: k(e.unbondingTime) ? globalThis.Number(e.unbondingTime) : k(e.unbonding_time) ? globalThis.Number(e.unbonding_time) : 0,
      unbondingTx: k(e.unbondingTx) ? N(e.unbondingTx) : k(e.unbonding_tx) ? N(e.unbonding_tx) : new Uint8Array(0),
      unbondingValue: k(e.unbondingValue) ? globalThis.Number(e.unbondingValue) : k(e.unbonding_value) ? globalThis.Number(e.unbonding_value) : 0,
      unbondingSlashingTx: k(e.unbondingSlashingTx) ? N(e.unbondingSlashingTx) : k(e.unbonding_slashing_tx) ? N(e.unbonding_slashing_tx) : new Uint8Array(0),
      delegatorUnbondingSlashingSig: k(e.delegatorUnbondingSlashingSig) ? N(e.delegatorUnbondingSlashingSig) : k(e.delegator_unbonding_slashing_sig) ? N(e.delegator_unbonding_slashing_sig) : new Uint8Array(0),
      previousStakingTxHash: k(e.previousStakingTxHash) ? globalThis.String(e.previousStakingTxHash) : k(e.previous_staking_tx_hash) ? globalThis.String(e.previous_staking_tx_hash) : "",
      fundingTx: k(e.fundingTx) ? N(e.fundingTx) : k(e.funding_tx) ? N(e.funding_tx) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.stakerAddr !== "" && (n.stakerAddr = e.stakerAddr), e.pop !== void 0 && (n.pop = G.toJSON(e.pop)), e.btcPk.length !== 0 && (n.btcPk = F(e.btcPk)), (t = e.fpBtcPkList) != null && t.length && (n.fpBtcPkList = e.fpBtcPkList.map((i) => F(i))), e.stakingTime !== 0 && (n.stakingTime = Math.round(e.stakingTime)), e.stakingValue !== 0 && (n.stakingValue = Math.round(e.stakingValue)), e.stakingTx.length !== 0 && (n.stakingTx = F(e.stakingTx)), e.slashingTx.length !== 0 && (n.slashingTx = F(e.slashingTx)), e.delegatorSlashingSig.length !== 0 && (n.delegatorSlashingSig = F(e.delegatorSlashingSig)), e.unbondingTime !== 0 && (n.unbondingTime = Math.round(e.unbondingTime)), e.unbondingTx.length !== 0 && (n.unbondingTx = F(e.unbondingTx)), e.unbondingValue !== 0 && (n.unbondingValue = Math.round(e.unbondingValue)), e.unbondingSlashingTx.length !== 0 && (n.unbondingSlashingTx = F(e.unbondingSlashingTx)), e.delegatorUnbondingSlashingSig.length !== 0 && (n.delegatorUnbondingSlashingSig = F(e.delegatorUnbondingSlashingSig)), e.previousStakingTxHash !== "" && (n.previousStakingTxHash = e.previousStakingTxHash), e.fundingTx.length !== 0 && (n.fundingTx = F(e.fundingTx)), n;
  },
  create(e) {
    return Dn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Uo();
    return n.stakerAddr = e.stakerAddr ?? "", n.pop = e.pop !== void 0 && e.pop !== null ? G.fromPartial(e.pop) : void 0, n.btcPk = e.btcPk ?? new Uint8Array(0), n.fpBtcPkList = ((t = e.fpBtcPkList) == null ? void 0 : t.map((i) => i)) || [], n.stakingTime = e.stakingTime ?? 0, n.stakingValue = e.stakingValue ?? 0, n.stakingTx = e.stakingTx ?? new Uint8Array(0), n.slashingTx = e.slashingTx ?? new Uint8Array(0), n.delegatorSlashingSig = e.delegatorSlashingSig ?? new Uint8Array(0), n.unbondingTime = e.unbondingTime ?? 0, n.unbondingTx = e.unbondingTx ?? new Uint8Array(0), n.unbondingValue = e.unbondingValue ?? 0, n.unbondingSlashingTx = e.unbondingSlashingTx ?? new Uint8Array(0), n.delegatorUnbondingSlashingSig = e.delegatorUnbondingSlashingSig ?? new Uint8Array(0), n.previousStakingTxHash = e.previousStakingTxHash ?? "", n.fundingTx = e.fundingTx ?? new Uint8Array(0), n;
  }
};
function Ho() {
  return {};
}
const Dt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ho();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Dt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Ho();
  }
};
function Mo() {
  return { signer: "", stakingTxHash: "", stakingTxInclusionProof: void 0 };
}
const At = {
  encode(e, n = new g()) {
    return e.signer !== "" && n.uint32(10).string(e.signer), e.stakingTxHash !== "" && n.uint32(18).string(e.stakingTxHash), e.stakingTxInclusionProof !== void 0 && X.encode(e.stakingTxInclusionProof, n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Mo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.signer = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.stakingTxHash = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.stakingTxInclusionProof = X.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      signer: k(e.signer) ? globalThis.String(e.signer) : "",
      stakingTxHash: k(e.stakingTxHash) ? globalThis.String(e.stakingTxHash) : k(e.staking_tx_hash) ? globalThis.String(e.staking_tx_hash) : "",
      stakingTxInclusionProof: k(e.stakingTxInclusionProof) ? X.fromJSON(e.stakingTxInclusionProof) : k(e.staking_tx_inclusion_proof) ? X.fromJSON(e.staking_tx_inclusion_proof) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.signer !== "" && (n.signer = e.signer), e.stakingTxHash !== "" && (n.stakingTxHash = e.stakingTxHash), e.stakingTxInclusionProof !== void 0 && (n.stakingTxInclusionProof = X.toJSON(e.stakingTxInclusionProof)), n;
  },
  create(e) {
    return At.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Mo();
    return n.signer = e.signer ?? "", n.stakingTxHash = e.stakingTxHash ?? "", n.stakingTxInclusionProof = e.stakingTxInclusionProof !== void 0 && e.stakingTxInclusionProof !== null ? X.fromPartial(e.stakingTxInclusionProof) : void 0, n;
  }
};
function Vo() {
  return {};
}
const Nt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Vo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Nt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Vo();
  }
};
function Fo() {
  return {
    signer: "",
    pk: new Uint8Array(0),
    stakingTxHash: "",
    slashingTxSigs: [],
    unbondingTxSig: new Uint8Array(0),
    slashingUnbondingTxSigs: [],
    stakeExpansionTxSig: new Uint8Array(0)
  };
}
const xt = {
  encode(e, n = new g()) {
    e.signer !== "" && n.uint32(10).string(e.signer), e.pk.length !== 0 && n.uint32(18).bytes(e.pk), e.stakingTxHash !== "" && n.uint32(26).string(e.stakingTxHash);
    for (const t of e.slashingTxSigs)
      n.uint32(34).bytes(t);
    e.unbondingTxSig.length !== 0 && n.uint32(42).bytes(e.unbondingTxSig);
    for (const t of e.slashingUnbondingTxSigs)
      n.uint32(50).bytes(t);
    return e.stakeExpansionTxSig.length !== 0 && n.uint32(58).bytes(e.stakeExpansionTxSig), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Fo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.signer = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pk = t.bytes();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.stakingTxHash = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.slashingTxSigs.push(t.bytes());
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.unbondingTxSig = t.bytes();
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.slashingUnbondingTxSigs.push(t.bytes());
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.stakeExpansionTxSig = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      signer: k(e.signer) ? globalThis.String(e.signer) : "",
      pk: k(e.pk) ? N(e.pk) : new Uint8Array(0),
      stakingTxHash: k(e.stakingTxHash) ? globalThis.String(e.stakingTxHash) : k(e.staking_tx_hash) ? globalThis.String(e.staking_tx_hash) : "",
      slashingTxSigs: globalThis.Array.isArray(e == null ? void 0 : e.slashingTxSigs) ? e.slashingTxSigs.map((n) => N(n)) : globalThis.Array.isArray(e == null ? void 0 : e.slashing_tx_sigs) ? e.slashing_tx_sigs.map((n) => N(n)) : [],
      unbondingTxSig: k(e.unbondingTxSig) ? N(e.unbondingTxSig) : k(e.unbonding_tx_sig) ? N(e.unbonding_tx_sig) : new Uint8Array(0),
      slashingUnbondingTxSigs: globalThis.Array.isArray(e == null ? void 0 : e.slashingUnbondingTxSigs) ? e.slashingUnbondingTxSigs.map((n) => N(n)) : globalThis.Array.isArray(e == null ? void 0 : e.slashing_unbonding_tx_sigs) ? e.slashing_unbonding_tx_sigs.map((n) => N(n)) : [],
      stakeExpansionTxSig: k(e.stakeExpansionTxSig) ? N(e.stakeExpansionTxSig) : k(e.stake_expansion_tx_sig) ? N(e.stake_expansion_tx_sig) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    var t, i;
    const n = {};
    return e.signer !== "" && (n.signer = e.signer), e.pk.length !== 0 && (n.pk = F(e.pk)), e.stakingTxHash !== "" && (n.stakingTxHash = e.stakingTxHash), (t = e.slashingTxSigs) != null && t.length && (n.slashingTxSigs = e.slashingTxSigs.map((s) => F(s))), e.unbondingTxSig.length !== 0 && (n.unbondingTxSig = F(e.unbondingTxSig)), (i = e.slashingUnbondingTxSigs) != null && i.length && (n.slashingUnbondingTxSigs = e.slashingUnbondingTxSigs.map((s) => F(s))), e.stakeExpansionTxSig.length !== 0 && (n.stakeExpansionTxSig = F(e.stakeExpansionTxSig)), n;
  },
  create(e) {
    return xt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t, i;
    const n = Fo();
    return n.signer = e.signer ?? "", n.pk = e.pk ?? new Uint8Array(0), n.stakingTxHash = e.stakingTxHash ?? "", n.slashingTxSigs = ((t = e.slashingTxSigs) == null ? void 0 : t.map((s) => s)) || [], n.unbondingTxSig = e.unbondingTxSig ?? new Uint8Array(0), n.slashingUnbondingTxSigs = ((i = e.slashingUnbondingTxSigs) == null ? void 0 : i.map((s) => s)) || [], n.stakeExpansionTxSig = e.stakeExpansionTxSig ?? new Uint8Array(0), n;
  }
};
function Lo() {
  return {};
}
const Bt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Lo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Bt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Lo();
  }
};
function Go() {
  return {
    signer: "",
    stakingTxHash: "",
    stakeSpendingTx: new Uint8Array(0),
    stakeSpendingTxInclusionProof: void 0,
    fundingTransactions: []
  };
}
const Rt = {
  encode(e, n = new g()) {
    e.signer !== "" && n.uint32(10).string(e.signer), e.stakingTxHash !== "" && n.uint32(18).string(e.stakingTxHash), e.stakeSpendingTx.length !== 0 && n.uint32(26).bytes(e.stakeSpendingTx), e.stakeSpendingTxInclusionProof !== void 0 && X.encode(e.stakeSpendingTxInclusionProof, n.uint32(34).fork()).join();
    for (const t of e.fundingTransactions)
      n.uint32(42).bytes(t);
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Go();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.signer = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.stakingTxHash = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.stakeSpendingTx = t.bytes();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.stakeSpendingTxInclusionProof = X.decode(t, t.uint32());
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.fundingTransactions.push(t.bytes());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      signer: k(e.signer) ? globalThis.String(e.signer) : "",
      stakingTxHash: k(e.stakingTxHash) ? globalThis.String(e.stakingTxHash) : k(e.staking_tx_hash) ? globalThis.String(e.staking_tx_hash) : "",
      stakeSpendingTx: k(e.stakeSpendingTx) ? N(e.stakeSpendingTx) : k(e.stake_spending_tx) ? N(e.stake_spending_tx) : new Uint8Array(0),
      stakeSpendingTxInclusionProof: k(e.stakeSpendingTxInclusionProof) ? X.fromJSON(e.stakeSpendingTxInclusionProof) : k(e.stake_spending_tx_inclusion_proof) ? X.fromJSON(e.stake_spending_tx_inclusion_proof) : void 0,
      fundingTransactions: globalThis.Array.isArray(e == null ? void 0 : e.fundingTransactions) ? e.fundingTransactions.map((n) => N(n)) : globalThis.Array.isArray(e == null ? void 0 : e.funding_transactions) ? e.funding_transactions.map((n) => N(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.signer !== "" && (n.signer = e.signer), e.stakingTxHash !== "" && (n.stakingTxHash = e.stakingTxHash), e.stakeSpendingTx.length !== 0 && (n.stakeSpendingTx = F(e.stakeSpendingTx)), e.stakeSpendingTxInclusionProof !== void 0 && (n.stakeSpendingTxInclusionProof = X.toJSON(e.stakeSpendingTxInclusionProof)), (t = e.fundingTransactions) != null && t.length && (n.fundingTransactions = e.fundingTransactions.map((i) => F(i))), n;
  },
  create(e) {
    return Rt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Go();
    return n.signer = e.signer ?? "", n.stakingTxHash = e.stakingTxHash ?? "", n.stakeSpendingTx = e.stakeSpendingTx ?? new Uint8Array(0), n.stakeSpendingTxInclusionProof = e.stakeSpendingTxInclusionProof !== void 0 && e.stakeSpendingTxInclusionProof !== null ? X.fromPartial(e.stakeSpendingTxInclusionProof) : void 0, n.fundingTransactions = ((t = e.fundingTransactions) == null ? void 0 : t.map((i) => i)) || [], n;
  }
};
function Wo() {
  return {};
}
const Ot = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Wo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Ot.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Wo();
  }
};
function $o() {
  return { signer: "", stakingTxHash: "", recoveredFpBtcSk: new Uint8Array(0) };
}
const Et = {
  encode(e, n = new g()) {
    return e.signer !== "" && n.uint32(10).string(e.signer), e.stakingTxHash !== "" && n.uint32(18).string(e.stakingTxHash), e.recoveredFpBtcSk.length !== 0 && n.uint32(26).bytes(e.recoveredFpBtcSk), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = $o();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.signer = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.stakingTxHash = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.recoveredFpBtcSk = t.bytes();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      signer: k(e.signer) ? globalThis.String(e.signer) : "",
      stakingTxHash: k(e.stakingTxHash) ? globalThis.String(e.stakingTxHash) : k(e.staking_tx_hash) ? globalThis.String(e.staking_tx_hash) : "",
      recoveredFpBtcSk: k(e.recoveredFpBtcSk) ? N(e.recoveredFpBtcSk) : k(e.recovered_fp_btc_sk) ? N(e.recovered_fp_btc_sk) : new Uint8Array(0)
    };
  },
  toJSON(e) {
    const n = {};
    return e.signer !== "" && (n.signer = e.signer), e.stakingTxHash !== "" && (n.stakingTxHash = e.stakingTxHash), e.recoveredFpBtcSk.length !== 0 && (n.recoveredFpBtcSk = F(e.recoveredFpBtcSk)), n;
  },
  create(e) {
    return Et.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = $o();
    return n.signer = e.signer ?? "", n.stakingTxHash = e.stakingTxHash ?? "", n.recoveredFpBtcSk = e.recoveredFpBtcSk ?? new Uint8Array(0), n;
  }
};
function Qo() {
  return {};
}
const Jt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Qo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Jt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Qo();
  }
};
function qo() {
  return { authority: "", params: void 0 };
}
const It = {
  encode(e, n = new g()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.params !== void 0 && bn.encode(e.params, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = qo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.authority = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.params = bn.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      authority: k(e.authority) ? globalThis.String(e.authority) : "",
      params: k(e.params) ? bn.fromJSON(e.params) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.authority !== "" && (n.authority = e.authority), e.params !== void 0 && (n.params = bn.toJSON(e.params)), n;
  },
  create(e) {
    return It.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = qo();
    return n.authority = e.authority ?? "", n.params = e.params !== void 0 && e.params !== null ? bn.fromPartial(e.params) : void 0, n;
  }
};
function Xo() {
  return {};
}
const Ct = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Xo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Ct.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Xo();
  }
};
function Ko() {
  return { sender: "", bsnConsumerId: "", totalRewards: [], fpRatios: [] };
}
const Ut = {
  encode(e, n = new g()) {
    e.sender !== "" && n.uint32(10).string(e.sender), e.bsnConsumerId !== "" && n.uint32(18).string(e.bsnConsumerId);
    for (const t of e.totalRewards)
      w.encode(t, n.uint32(26).fork()).join();
    for (const t of e.fpRatios)
      Ie.encode(t, n.uint32(34).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ko();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.sender = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.bsnConsumerId = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.totalRewards.push(w.decode(t, t.uint32()));
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.fpRatios.push(Ie.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      sender: k(e.sender) ? globalThis.String(e.sender) : "",
      bsnConsumerId: k(e.bsnConsumerId) ? globalThis.String(e.bsnConsumerId) : k(e.bsn_consumer_id) ? globalThis.String(e.bsn_consumer_id) : "",
      totalRewards: globalThis.Array.isArray(e == null ? void 0 : e.totalRewards) ? e.totalRewards.map((n) => w.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.total_rewards) ? e.total_rewards.map((n) => w.fromJSON(n)) : [],
      fpRatios: globalThis.Array.isArray(e == null ? void 0 : e.fpRatios) ? e.fpRatios.map((n) => Ie.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.fp_ratios) ? e.fp_ratios.map((n) => Ie.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t, i;
    const n = {};
    return e.sender !== "" && (n.sender = e.sender), e.bsnConsumerId !== "" && (n.bsnConsumerId = e.bsnConsumerId), (t = e.totalRewards) != null && t.length && (n.totalRewards = e.totalRewards.map((s) => w.toJSON(s))), (i = e.fpRatios) != null && i.length && (n.fpRatios = e.fpRatios.map((s) => Ie.toJSON(s))), n;
  },
  create(e) {
    return Ut.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t, i;
    const n = Ko();
    return n.sender = e.sender ?? "", n.bsnConsumerId = e.bsnConsumerId ?? "", n.totalRewards = ((t = e.totalRewards) == null ? void 0 : t.map((s) => w.fromPartial(s))) || [], n.fpRatios = ((i = e.fpRatios) == null ? void 0 : i.map((s) => Ie.fromPartial(s))) || [], n;
  }
};
function Zo() {
  return { btcPk: new Uint8Array(0), ratio: "" };
}
const Ie = {
  encode(e, n = new g()) {
    return e.btcPk.length !== 0 && n.uint32(10).bytes(e.btcPk), e.ratio !== "" && n.uint32(18).string(e.ratio), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Zo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.btcPk = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.ratio = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      btcPk: k(e.btcPk) ? N(e.btcPk) : k(e.btc_pk) ? N(e.btc_pk) : new Uint8Array(0),
      ratio: k(e.ratio) ? globalThis.String(e.ratio) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.btcPk.length !== 0 && (n.btcPk = F(e.btcPk)), e.ratio !== "" && (n.ratio = e.ratio), n;
  },
  create(e) {
    return Ie.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Zo();
    return n.btcPk = e.btcPk ?? new Uint8Array(0), n.ratio = e.ratio ?? "", n;
  }
};
function zo() {
  return {};
}
const Ht = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = zo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Ht.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return zo();
  }
}, md = "babylon.btcstaking.v1.Msg";
let ml = class {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || md, this.rpc = n, this.CreateFinalityProvider = this.CreateFinalityProvider.bind(this), this.EditFinalityProvider = this.EditFinalityProvider.bind(this), this.CreateBTCDelegation = this.CreateBTCDelegation.bind(this), this.AddBTCDelegationInclusionProof = this.AddBTCDelegationInclusionProof.bind(this), this.AddCovenantSigs = this.AddCovenantSigs.bind(this), this.BTCUndelegate = this.BTCUndelegate.bind(this), this.SelectiveSlashingEvidence = this.SelectiveSlashingEvidence.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.BtcStakeExpand = this.BtcStakeExpand.bind(this), this.AddBsnRewards = this.AddBsnRewards.bind(this);
  }
  CreateFinalityProvider(n) {
    const t = vt.encode(n).finish();
    return this.rpc.request(this.service, "CreateFinalityProvider", t).then((s) => yt.decode(new a(s)));
  }
  EditFinalityProvider(n) {
    const t = Tt.encode(n).finish();
    return this.rpc.request(this.service, "EditFinalityProvider", t).then((s) => wt.decode(new a(s)));
  }
  CreateBTCDelegation(n) {
    const t = Vn.encode(n).finish();
    return this.rpc.request(this.service, "CreateBTCDelegation", t).then((s) => Pt.decode(new a(s)));
  }
  AddBTCDelegationInclusionProof(n) {
    const t = At.encode(n).finish();
    return this.rpc.request(this.service, "AddBTCDelegationInclusionProof", t).then((s) => Nt.decode(new a(s)));
  }
  AddCovenantSigs(n) {
    const t = xt.encode(n).finish();
    return this.rpc.request(this.service, "AddCovenantSigs", t).then((s) => Bt.decode(new a(s)));
  }
  BTCUndelegate(n) {
    const t = Rt.encode(n).finish();
    return this.rpc.request(this.service, "BTCUndelegate", t).then((s) => Ot.decode(new a(s)));
  }
  SelectiveSlashingEvidence(n) {
    const t = Et.encode(n).finish();
    return this.rpc.request(this.service, "SelectiveSlashingEvidence", t).then((s) => Jt.decode(new a(s)));
  }
  UpdateParams(n) {
    const t = It.encode(n).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((s) => Ct.decode(new a(s)));
  }
  BtcStakeExpand(n) {
    const t = Dn.encode(n).finish();
    return this.rpc.request(this.service, "BtcStakeExpand", t).then((s) => Dt.decode(new a(s)));
  }
  AddBsnRewards(n) {
    const t = Ut.encode(n).finish();
    return this.rpc.request(this.service, "AddBsnRewards", t).then((s) => Ht.decode(new a(s)));
  }
};
function N(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function F(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function En(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function k(e) {
  return e != null;
}
const Ac = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CommissionRates: hn,
  FpRatio: Ie,
  MsgAddBTCDelegationInclusionProof: At,
  MsgAddBTCDelegationInclusionProofResponse: Nt,
  MsgAddBsnRewards: Ut,
  MsgAddBsnRewardsResponse: Ht,
  MsgAddCovenantSigs: xt,
  MsgAddCovenantSigsResponse: Bt,
  MsgBTCUndelegate: Rt,
  MsgBTCUndelegateResponse: Ot,
  MsgBtcStakeExpand: Dn,
  MsgBtcStakeExpandResponse: Dt,
  MsgClientImpl: ml,
  MsgCreateBTCDelegation: Vn,
  MsgCreateBTCDelegationResponse: Pt,
  MsgCreateFinalityProvider: vt,
  MsgCreateFinalityProviderResponse: yt,
  MsgEditFinalityProvider: Tt,
  MsgEditFinalityProviderResponse: wt,
  MsgSelectiveSlashingEvidence: Et,
  MsgSelectiveSlashingEvidenceResponse: Jt,
  MsgServiceName: md,
  MsgUpdateParams: It,
  MsgUpdateParamsResponse: Ct,
  protobufPackage: pl
}, Symbol.toStringTag, { value: "Module" })), kl = "cosmos.staking.v1beta1";
function Yo() {
  return {
    description: void 0,
    commission: void 0,
    minSelfDelegation: "",
    delegatorAddress: "",
    validatorAddress: "",
    pubkey: void 0,
    value: void 0
  };
}
const Mt = {
  encode(e, n = new g()) {
    return e.description !== void 0 && I.encode(e.description, n.uint32(10).fork()).join(), e.commission !== void 0 && fe.encode(e.commission, n.uint32(18).fork()).join(), e.minSelfDelegation !== "" && n.uint32(26).string(e.minSelfDelegation), e.delegatorAddress !== "" && n.uint32(34).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(42).string(e.validatorAddress), e.pubkey !== void 0 && he.encode(e.pubkey, n.uint32(50).fork()).join(), e.value !== void 0 && w.encode(e.value, n.uint32(58).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Yo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.description = I.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.commission = fe.decode(t, t.uint32());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.minSelfDelegation = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.pubkey = he.decode(t, t.uint32());
            continue;
          }
          case 7: {
            if (r !== 58)
              break;
            o.value = w.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      description: B(e.description) ? I.fromJSON(e.description) : void 0,
      commission: B(e.commission) ? fe.fromJSON(e.commission) : void 0,
      minSelfDelegation: B(e.minSelfDelegation) ? globalThis.String(e.minSelfDelegation) : B(e.min_self_delegation) ? globalThis.String(e.min_self_delegation) : "",
      delegatorAddress: B(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : B(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: B(e.validatorAddress) ? globalThis.String(e.validatorAddress) : B(e.validator_address) ? globalThis.String(e.validator_address) : "",
      pubkey: B(e.pubkey) ? he.fromJSON(e.pubkey) : void 0,
      value: B(e.value) ? w.fromJSON(e.value) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.description !== void 0 && (n.description = I.toJSON(e.description)), e.commission !== void 0 && (n.commission = fe.toJSON(e.commission)), e.minSelfDelegation !== "" && (n.minSelfDelegation = e.minSelfDelegation), e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), e.pubkey !== void 0 && (n.pubkey = he.toJSON(e.pubkey)), e.value !== void 0 && (n.value = w.toJSON(e.value)), n;
  },
  create(e) {
    return Mt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Yo();
    return n.description = e.description !== void 0 && e.description !== null ? I.fromPartial(e.description) : void 0, n.commission = e.commission !== void 0 && e.commission !== null ? fe.fromPartial(e.commission) : void 0, n.minSelfDelegation = e.minSelfDelegation ?? "", n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n.pubkey = e.pubkey !== void 0 && e.pubkey !== null ? he.fromPartial(e.pubkey) : void 0, n.value = e.value !== void 0 && e.value !== null ? w.fromPartial(e.value) : void 0, n;
  }
};
function jo() {
  return {};
}
const Vt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = jo();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Vt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return jo();
  }
};
function es() {
  return { description: void 0, validatorAddress: "", commissionRate: "", minSelfDelegation: "" };
}
const He = {
  encode(e, n = new g()) {
    return e.description !== void 0 && I.encode(e.description, n.uint32(10).fork()).join(), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.commissionRate !== "" && n.uint32(26).string(e.commissionRate), e.minSelfDelegation !== "" && n.uint32(34).string(e.minSelfDelegation), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = es();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.description = I.decode(t, t.uint32());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.commissionRate = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.minSelfDelegation = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      description: B(e.description) ? I.fromJSON(e.description) : void 0,
      validatorAddress: B(e.validatorAddress) ? globalThis.String(e.validatorAddress) : B(e.validator_address) ? globalThis.String(e.validator_address) : "",
      commissionRate: B(e.commissionRate) ? globalThis.String(e.commissionRate) : B(e.commission_rate) ? globalThis.String(e.commission_rate) : "",
      minSelfDelegation: B(e.minSelfDelegation) ? globalThis.String(e.minSelfDelegation) : B(e.min_self_delegation) ? globalThis.String(e.min_self_delegation) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.description !== void 0 && (n.description = I.toJSON(e.description)), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), e.commissionRate !== "" && (n.commissionRate = e.commissionRate), e.minSelfDelegation !== "" && (n.minSelfDelegation = e.minSelfDelegation), n;
  },
  create(e) {
    return He.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = es();
    return n.description = e.description !== void 0 && e.description !== null ? I.fromPartial(e.description) : void 0, n.validatorAddress = e.validatorAddress ?? "", n.commissionRate = e.commissionRate ?? "", n.minSelfDelegation = e.minSelfDelegation ?? "", n;
  }
};
function ns() {
  return {};
}
const Ft = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ns();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Ft.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return ns();
  }
};
function ts() {
  return { delegatorAddress: "", validatorAddress: "", amount: void 0 };
}
const Me = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.amount !== void 0 && w.encode(e.amount, n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ts();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.amount = w.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: B(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : B(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: B(e.validatorAddress) ? globalThis.String(e.validatorAddress) : B(e.validator_address) ? globalThis.String(e.validator_address) : "",
      amount: B(e.amount) ? w.fromJSON(e.amount) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), e.amount !== void 0 && (n.amount = w.toJSON(e.amount)), n;
  },
  create(e) {
    return Me.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ts();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n.amount = e.amount !== void 0 && e.amount !== null ? w.fromPartial(e.amount) : void 0, n;
  }
};
function rs() {
  return {};
}
const Lt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = rs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Lt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return rs();
  }
};
function is() {
  return { delegatorAddress: "", validatorSrcAddress: "", validatorDstAddress: "", amount: void 0 };
}
const Ve = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorSrcAddress !== "" && n.uint32(18).string(e.validatorSrcAddress), e.validatorDstAddress !== "" && n.uint32(26).string(e.validatorDstAddress), e.amount !== void 0 && w.encode(e.amount, n.uint32(34).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = is();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorSrcAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.validatorDstAddress = t.string();
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.amount = w.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: B(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : B(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorSrcAddress: B(e.validatorSrcAddress) ? globalThis.String(e.validatorSrcAddress) : B(e.validator_src_address) ? globalThis.String(e.validator_src_address) : "",
      validatorDstAddress: B(e.validatorDstAddress) ? globalThis.String(e.validatorDstAddress) : B(e.validator_dst_address) ? globalThis.String(e.validator_dst_address) : "",
      amount: B(e.amount) ? w.fromJSON(e.amount) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorSrcAddress !== "" && (n.validatorSrcAddress = e.validatorSrcAddress), e.validatorDstAddress !== "" && (n.validatorDstAddress = e.validatorDstAddress), e.amount !== void 0 && (n.amount = w.toJSON(e.amount)), n;
  },
  create(e) {
    return Ve.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = is();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorSrcAddress = e.validatorSrcAddress ?? "", n.validatorDstAddress = e.validatorDstAddress ?? "", n.amount = e.amount !== void 0 && e.amount !== null ? w.fromPartial(e.amount) : void 0, n;
  }
};
function os() {
  return { completionTime: void 0 };
}
const Gt = {
  encode(e, n = new g()) {
    return e.completionTime !== void 0 && H.encode(_d(e.completionTime), n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = os();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.completionTime = qt(H.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      completionTime: B(e.completionTime) ? Jn(e.completionTime) : B(e.completion_time) ? Jn(e.completion_time) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.completionTime !== void 0 && (n.completionTime = e.completionTime.toISOString()), n;
  },
  create(e) {
    return Gt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = os();
    return n.completionTime = e.completionTime ?? void 0, n;
  }
};
function ss() {
  return { delegatorAddress: "", validatorAddress: "", amount: void 0 };
}
const Fe = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.amount !== void 0 && w.encode(e.amount, n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ss();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.amount = w.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: B(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : B(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: B(e.validatorAddress) ? globalThis.String(e.validatorAddress) : B(e.validator_address) ? globalThis.String(e.validator_address) : "",
      amount: B(e.amount) ? w.fromJSON(e.amount) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), e.amount !== void 0 && (n.amount = w.toJSON(e.amount)), n;
  },
  create(e) {
    return Fe.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ss();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n.amount = e.amount !== void 0 && e.amount !== null ? w.fromPartial(e.amount) : void 0, n;
  }
};
function as() {
  return { completionTime: void 0, amount: void 0 };
}
const Wt = {
  encode(e, n = new g()) {
    return e.completionTime !== void 0 && H.encode(_d(e.completionTime), n.uint32(10).fork()).join(), e.amount !== void 0 && w.encode(e.amount, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = as();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.completionTime = qt(H.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.amount = w.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      completionTime: B(e.completionTime) ? Jn(e.completionTime) : B(e.completion_time) ? Jn(e.completion_time) : void 0,
      amount: B(e.amount) ? w.fromJSON(e.amount) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.completionTime !== void 0 && (n.completionTime = e.completionTime.toISOString()), e.amount !== void 0 && (n.amount = w.toJSON(e.amount)), n;
  },
  create(e) {
    return Wt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = as();
    return n.completionTime = e.completionTime ?? void 0, n.amount = e.amount !== void 0 && e.amount !== null ? w.fromPartial(e.amount) : void 0, n;
  }
};
function ds() {
  return { delegatorAddress: "", validatorAddress: "", amount: void 0, creationHeight: 0 };
}
const Le = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.validatorAddress !== "" && n.uint32(18).string(e.validatorAddress), e.amount !== void 0 && w.encode(e.amount, n.uint32(26).fork()).join(), e.creationHeight !== 0 && n.uint32(32).int64(e.creationHeight), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ds();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.validatorAddress = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.amount = w.decode(t, t.uint32());
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.creationHeight = bl(t.int64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: B(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : B(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      validatorAddress: B(e.validatorAddress) ? globalThis.String(e.validatorAddress) : B(e.validator_address) ? globalThis.String(e.validator_address) : "",
      amount: B(e.amount) ? w.fromJSON(e.amount) : void 0,
      creationHeight: B(e.creationHeight) ? globalThis.Number(e.creationHeight) : B(e.creation_height) ? globalThis.Number(e.creation_height) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.validatorAddress !== "" && (n.validatorAddress = e.validatorAddress), e.amount !== void 0 && (n.amount = w.toJSON(e.amount)), e.creationHeight !== 0 && (n.creationHeight = Math.round(e.creationHeight)), n;
  },
  create(e) {
    return Le.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ds();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.validatorAddress = e.validatorAddress ?? "", n.amount = e.amount !== void 0 && e.amount !== null ? w.fromPartial(e.amount) : void 0, n.creationHeight = e.creationHeight ?? 0, n;
  }
};
function ls() {
  return {};
}
const $t = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ls();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return $t.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return ls();
  }
};
function cs() {
  return { authority: "", params: void 0 };
}
const Ge = {
  encode(e, n = new g()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.params !== void 0 && ln.encode(e.params, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = cs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.authority = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.params = ln.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      authority: B(e.authority) ? globalThis.String(e.authority) : "",
      params: B(e.params) ? ln.fromJSON(e.params) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.authority !== "" && (n.authority = e.authority), e.params !== void 0 && (n.params = ln.toJSON(e.params)), n;
  },
  create(e) {
    return Ge.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = cs();
    return n.authority = e.authority ?? "", n.params = e.params !== void 0 && e.params !== null ? ln.fromPartial(e.params) : void 0, n;
  }
};
function us() {
  return {};
}
const Qt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = us();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Qt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return us();
  }
}, kd = "cosmos.staking.v1beta1.Msg";
let _l = class {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || kd, this.rpc = n, this.CreateValidator = this.CreateValidator.bind(this), this.EditValidator = this.EditValidator.bind(this), this.Delegate = this.Delegate.bind(this), this.BeginRedelegate = this.BeginRedelegate.bind(this), this.Undelegate = this.Undelegate.bind(this), this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
  }
  CreateValidator(n) {
    const t = Mt.encode(n).finish();
    return this.rpc.request(this.service, "CreateValidator", t).then((s) => Vt.decode(new a(s)));
  }
  EditValidator(n) {
    const t = He.encode(n).finish();
    return this.rpc.request(this.service, "EditValidator", t).then((s) => Ft.decode(new a(s)));
  }
  Delegate(n) {
    const t = Me.encode(n).finish();
    return this.rpc.request(this.service, "Delegate", t).then((s) => Lt.decode(new a(s)));
  }
  BeginRedelegate(n) {
    const t = Ve.encode(n).finish();
    return this.rpc.request(this.service, "BeginRedelegate", t).then((s) => Gt.decode(new a(s)));
  }
  Undelegate(n) {
    const t = Fe.encode(n).finish();
    return this.rpc.request(this.service, "Undelegate", t).then((s) => Wt.decode(new a(s)));
  }
  CancelUnbondingDelegation(n) {
    const t = Le.encode(n).finish();
    return this.rpc.request(this.service, "CancelUnbondingDelegation", t).then((s) => $t.decode(new a(s)));
  }
  UpdateParams(n) {
    const t = Ge.encode(n).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((s) => Qt.decode(new a(s)));
  }
};
function _d(e) {
  const n = Math.trunc(e.getTime() / 1e3), t = e.getTime() % 1e3 * 1e6;
  return { seconds: n, nanos: t };
}
function qt(e) {
  let n = (e.seconds || 0) * 1e3;
  return n += (e.nanos || 0) / 1e6, new globalThis.Date(n);
}
function Jn(e) {
  return e instanceof globalThis.Date ? e : typeof e == "string" ? new globalThis.Date(e) : qt(H.fromJSON(e));
}
function bl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function B(e) {
  return e != null;
}
const xc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgBeginRedelegate: Ve,
  MsgBeginRedelegateResponse: Gt,
  MsgCancelUnbondingDelegation: Le,
  MsgCancelUnbondingDelegationResponse: $t,
  MsgClientImpl: _l,
  MsgCreateValidator: Mt,
  MsgCreateValidatorResponse: Vt,
  MsgDelegate: Me,
  MsgDelegateResponse: Lt,
  MsgEditValidator: He,
  MsgEditValidatorResponse: Ft,
  MsgServiceName: kd,
  MsgUndelegate: Fe,
  MsgUndelegateResponse: Wt,
  MsgUpdateParams: Ge,
  MsgUpdateParamsResponse: Qt,
  protobufPackage: kl
}, Symbol.toStringTag, { value: "Module" }));
function Sl(e) {
  switch (e) {
    case 0:
    case "CREATED":
      return 0;
    case 1:
    case "BONDED":
      return 1;
    case 2:
    case "UNBONDING":
      return 2;
    case 3:
    case "UNBONDED":
      return 3;
    case 4:
    case "REMOVED":
      return 4;
    case -1:
    case "UNRECOGNIZED":
    default:
      return -1;
  }
}
function vl(e) {
  switch (e) {
    case 0:
      return "CREATED";
    case 1:
      return "BONDED";
    case 2:
      return "UNBONDING";
    case 3:
      return "UNBONDED";
    case 4:
      return "REMOVED";
    case -1:
    default:
      return "UNRECOGNIZED";
  }
}
function hs() {
  return { state: 0, valAddr: "", amount: void 0, blockHeight: 0, blockTime: void 0 };
}
const Ye = {
  encode(e, n = new g()) {
    return e.state !== 0 && n.uint32(8).int32(e.state), e.valAddr !== "" && n.uint32(18).string(e.valAddr), e.amount !== void 0 && w.encode(e.amount, n.uint32(26).fork()).join(), e.blockHeight !== 0 && n.uint32(32).uint64(e.blockHeight), e.blockTime !== void 0 && H.encode(wl(e.blockTime), n.uint32(42).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = hs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.state = t.int32();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.valAddr = t.string();
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.amount = w.decode(t, t.uint32());
            continue;
          }
          case 4: {
            if (r !== 32)
              break;
            o.blockHeight = Sd(t.uint64());
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.blockTime = bd(H.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      state: me(e.state) ? Sl(e.state) : 0,
      valAddr: me(e.valAddr) ? globalThis.String(e.valAddr) : me(e.val_addr) ? globalThis.String(e.val_addr) : "",
      amount: me(e.amount) ? w.fromJSON(e.amount) : void 0,
      blockHeight: me(e.blockHeight) ? globalThis.Number(e.blockHeight) : me(e.block_height) ? globalThis.Number(e.block_height) : 0,
      blockTime: me(e.blockTime) ? ps(e.blockTime) : me(e.block_time) ? ps(e.block_time) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.state !== 0 && (n.state = vl(e.state)), e.valAddr !== "" && (n.valAddr = e.valAddr), e.amount !== void 0 && (n.amount = w.toJSON(e.amount)), e.blockHeight !== 0 && (n.blockHeight = Math.round(e.blockHeight)), e.blockTime !== void 0 && (n.blockTime = e.blockTime.toISOString()), n;
  },
  create(e) {
    return Ye.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = hs();
    return n.state = e.state ?? 0, n.valAddr = e.valAddr ?? "", n.amount = e.amount !== void 0 && e.amount !== null ? w.fromPartial(e.amount) : void 0, n.blockHeight = e.blockHeight ?? 0, n.blockTime = e.blockTime ?? void 0, n;
  }
};
function fs() {
  return { delAddr: "", delLife: [] };
}
const je = {
  encode(e, n = new g()) {
    e.delAddr !== "" && n.uint32(10).string(e.delAddr);
    for (const t of e.delLife)
      Ye.encode(t, n.uint32(18).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = fs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delAddr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.delLife.push(Ye.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delAddr: me(e.delAddr) ? globalThis.String(e.delAddr) : me(e.del_addr) ? globalThis.String(e.del_addr) : "",
      delLife: globalThis.Array.isArray(e == null ? void 0 : e.delLife) ? e.delLife.map((n) => Ye.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.del_life) ? e.del_life.map((n) => Ye.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.delAddr !== "" && (n.delAddr = e.delAddr), (t = e.delLife) != null && t.length && (n.delLife = e.delLife.map((i) => Ye.toJSON(i))), n;
  },
  create(e) {
    return je.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = fs();
    return n.delAddr = e.delAddr ?? "", n.delLife = ((t = e.delLife) == null ? void 0 : t.map((i) => Ye.fromPartial(i))) || [], n;
  }
};
function gs() {
  return { addr: new Uint8Array(0), power: 0 };
}
const Sn = {
  encode(e, n = new g()) {
    return e.addr.length !== 0 && n.uint32(10).bytes(e.addr), e.power !== 0 && n.uint32(16).int64(e.power), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = gs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.addr = t.bytes();
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.power = Sd(t.int64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      addr: me(e.addr) ? yl(e.addr) : new Uint8Array(0),
      power: me(e.power) ? globalThis.Number(e.power) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.addr.length !== 0 && (n.addr = Tl(e.addr)), e.power !== 0 && (n.power = Math.round(e.power)), n;
  },
  create(e) {
    return Sn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = gs();
    return n.addr = e.addr ?? new Uint8Array(0), n.power = e.power ?? 0, n;
  }
};
function yl(e) {
  if (globalThis.Buffer)
    return Uint8Array.from(globalThis.Buffer.from(e, "base64"));
  {
    const n = globalThis.atob(e), t = new Uint8Array(n.length);
    for (let i = 0; i < n.length; ++i)
      t[i] = n.charCodeAt(i);
    return t;
  }
}
function Tl(e) {
  if (globalThis.Buffer)
    return globalThis.Buffer.from(e).toString("base64");
  {
    const n = [];
    return e.forEach((t) => {
      n.push(globalThis.String.fromCharCode(t));
    }), globalThis.btoa(n.join(""));
  }
}
function wl(e) {
  const n = Math.trunc(e.getTime() / 1e3), t = e.getTime() % 1e3 * 1e6;
  return { seconds: n, nanos: t };
}
function bd(e) {
  let n = (e.seconds || 0) * 1e3;
  return n += (e.nanos || 0) / 1e6, new globalThis.Date(n);
}
function ps(e) {
  return e instanceof globalThis.Date ? e : typeof e == "string" ? new globalThis.Date(e) : bd(H.fromJSON(e));
}
function Sd(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function me(e) {
  return e != null;
}
function ms() {
  return { epochInterval: 0 };
}
const Se = {
  encode(e, n = new g()) {
    return e.epochInterval !== 0 && n.uint32(8).uint64(e.epochInterval), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ms();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochInterval = Pl(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochInterval: ks(e.epochInterval) ? globalThis.Number(e.epochInterval) : ks(e.epoch_interval) ? globalThis.Number(e.epoch_interval) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.epochInterval !== 0 && (n.epochInterval = Math.round(e.epochInterval)), n;
  },
  create(e) {
    return Se.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ms();
    return n.epochInterval = e.epochInterval ?? 0, n;
  }
};
function Pl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function ks(e) {
  return e != null;
}
const Dl = "babylon.epoching.v1";
function _s() {
  return {};
}
const Xt = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = _s();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Xt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return _s();
  }
};
function bs() {
  return { params: void 0 };
}
const Kt = {
  encode(e, n = new g()) {
    return e.params !== void 0 && Se.encode(e.params, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = bs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.params = Se.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { params: A(e.params) ? Se.fromJSON(e.params) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.params !== void 0 && (n.params = Se.toJSON(e.params)), n;
  },
  create(e) {
    return Kt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = bs();
    return n.params = e.params !== void 0 && e.params !== null ? Se.fromPartial(e.params) : void 0, n;
  }
};
function Ss() {
  return { epochNum: 0 };
}
const Zt = {
  encode(e, n = new g()) {
    return e.epochNum !== 0 && n.uint32(8).uint64(e.epochNum), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ss();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochNum = le(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochNum: A(e.epochNum) ? globalThis.Number(e.epochNum) : A(e.epoch_num) ? globalThis.Number(e.epoch_num) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.epochNum !== 0 && (n.epochNum = Math.round(e.epochNum)), n;
  },
  create(e) {
    return Zt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ss();
    return n.epochNum = e.epochNum ?? 0, n;
  }
};
function vs() {
  return { epoch: void 0 };
}
const zt = {
  encode(e, n = new g()) {
    return e.epoch !== void 0 && ke.encode(e.epoch, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = vs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.epoch = ke.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { epoch: A(e.epoch) ? ke.fromJSON(e.epoch) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.epoch !== void 0 && (n.epoch = ke.toJSON(e.epoch)), n;
  },
  create(e) {
    return zt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = vs();
    return n.epoch = e.epoch !== void 0 && e.epoch !== null ? ke.fromPartial(e.epoch) : void 0, n;
  }
};
function ys() {
  return { pagination: void 0 };
}
const Yt = {
  encode(e, n = new g()) {
    return e.pagination !== void 0 && C.encode(e.pagination, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ys();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.pagination = C.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { pagination: A(e.pagination) ? C.fromJSON(e.pagination) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.pagination !== void 0 && (n.pagination = C.toJSON(e.pagination)), n;
  },
  create(e) {
    return Yt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ys();
    return n.pagination = e.pagination !== void 0 && e.pagination !== null ? C.fromPartial(e.pagination) : void 0, n;
  }
};
function Ts() {
  return { epochs: [], pagination: void 0 };
}
const jt = {
  encode(e, n = new g()) {
    for (const t of e.epochs)
      ke.encode(t, n.uint32(10).fork()).join();
    return e.pagination !== void 0 && U.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ts();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.epochs.push(ke.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = U.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochs: globalThis.Array.isArray(e == null ? void 0 : e.epochs) ? e.epochs.map((n) => ke.fromJSON(n)) : [],
      pagination: A(e.pagination) ? U.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.epochs) != null && t.length && (n.epochs = e.epochs.map((i) => ke.toJSON(i))), e.pagination !== void 0 && (n.pagination = U.toJSON(e.pagination)), n;
  },
  create(e) {
    return jt.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Ts();
    return n.epochs = ((t = e.epochs) == null ? void 0 : t.map((i) => ke.fromPartial(i))) || [], n.pagination = e.pagination !== void 0 && e.pagination !== null ? U.fromPartial(e.pagination) : void 0, n;
  }
};
function ws() {
  return {};
}
const er = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ws();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return er.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return ws();
  }
};
function Ps() {
  return { currentEpoch: 0, epochBoundary: 0 };
}
const nr = {
  encode(e, n = new g()) {
    return e.currentEpoch !== 0 && n.uint32(8).uint64(e.currentEpoch), e.epochBoundary !== 0 && n.uint32(16).uint64(e.epochBoundary), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ps();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.currentEpoch = le(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.epochBoundary = le(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      currentEpoch: A(e.currentEpoch) ? globalThis.Number(e.currentEpoch) : A(e.current_epoch) ? globalThis.Number(e.current_epoch) : 0,
      epochBoundary: A(e.epochBoundary) ? globalThis.Number(e.epochBoundary) : A(e.epoch_boundary) ? globalThis.Number(e.epoch_boundary) : 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.currentEpoch !== 0 && (n.currentEpoch = Math.round(e.currentEpoch)), e.epochBoundary !== 0 && (n.epochBoundary = Math.round(e.epochBoundary)), n;
  },
  create(e) {
    return nr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ps();
    return n.currentEpoch = e.currentEpoch ?? 0, n.epochBoundary = e.epochBoundary ?? 0, n;
  }
};
function Ds() {
  return { epochNum: 0, pagination: void 0 };
}
const tr = {
  encode(e, n = new g()) {
    return e.epochNum !== 0 && n.uint32(8).uint64(e.epochNum), e.pagination !== void 0 && C.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ds();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochNum = le(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = C.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochNum: A(e.epochNum) ? globalThis.Number(e.epochNum) : A(e.epoch_num) ? globalThis.Number(e.epoch_num) : 0,
      pagination: A(e.pagination) ? C.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.epochNum !== 0 && (n.epochNum = Math.round(e.epochNum)), e.pagination !== void 0 && (n.pagination = C.toJSON(e.pagination)), n;
  },
  create(e) {
    return tr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ds();
    return n.epochNum = e.epochNum ?? 0, n.pagination = e.pagination !== void 0 && e.pagination !== null ? C.fromPartial(e.pagination) : void 0, n;
  }
};
function As() {
  return { msgs: [], pagination: void 0 };
}
const rr = {
  encode(e, n = new g()) {
    for (const t of e.msgs)
      _e.encode(t, n.uint32(10).fork()).join();
    return e.pagination !== void 0 && U.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = As();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msgs.push(_e.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = U.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      msgs: globalThis.Array.isArray(e == null ? void 0 : e.msgs) ? e.msgs.map((n) => _e.fromJSON(n)) : [],
      pagination: A(e.pagination) ? U.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.msgs) != null && t.length && (n.msgs = e.msgs.map((i) => _e.toJSON(i))), e.pagination !== void 0 && (n.pagination = U.toJSON(e.pagination)), n;
  },
  create(e) {
    return rr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = As();
    return n.msgs = ((t = e.msgs) == null ? void 0 : t.map((i) => _e.fromPartial(i))) || [], n.pagination = e.pagination !== void 0 && e.pagination !== null ? U.fromPartial(e.pagination) : void 0, n;
  }
};
function Ns() {
  return { endEpoch: 0, epochCount: 0, pagination: void 0 };
}
const ir = {
  encode(e, n = new g()) {
    return e.endEpoch !== 0 && n.uint32(8).uint64(e.endEpoch), e.epochCount !== 0 && n.uint32(16).uint64(e.epochCount), e.pagination !== void 0 && C.encode(e.pagination, n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ns();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.endEpoch = le(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.epochCount = le(t.uint64());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.pagination = C.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      endEpoch: A(e.endEpoch) ? globalThis.Number(e.endEpoch) : A(e.end_epoch) ? globalThis.Number(e.end_epoch) : 0,
      epochCount: A(e.epochCount) ? globalThis.Number(e.epochCount) : A(e.epoch_count) ? globalThis.Number(e.epoch_count) : 0,
      pagination: A(e.pagination) ? C.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.endEpoch !== 0 && (n.endEpoch = Math.round(e.endEpoch)), e.epochCount !== 0 && (n.epochCount = Math.round(e.epochCount)), e.pagination !== void 0 && (n.pagination = C.toJSON(e.pagination)), n;
  },
  create(e) {
    return ir.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ns();
    return n.endEpoch = e.endEpoch ?? 0, n.epochCount = e.epochCount ?? 0, n.pagination = e.pagination !== void 0 && e.pagination !== null ? C.fromPartial(e.pagination) : void 0, n;
  }
};
function xs() {
  return { latestEpochMsgs: [], pagination: void 0 };
}
const or = {
  encode(e, n = new g()) {
    for (const t of e.latestEpochMsgs)
      Ce.encode(t, n.uint32(10).fork()).join();
    return e.pagination !== void 0 && U.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = xs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.latestEpochMsgs.push(Ce.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = U.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      latestEpochMsgs: globalThis.Array.isArray(e == null ? void 0 : e.latestEpochMsgs) ? e.latestEpochMsgs.map((n) => Ce.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.latest_epoch_msgs) ? e.latest_epoch_msgs.map((n) => Ce.fromJSON(n)) : [],
      pagination: A(e.pagination) ? U.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.latestEpochMsgs) != null && t.length && (n.latestEpochMsgs = e.latestEpochMsgs.map((i) => Ce.toJSON(i))), e.pagination !== void 0 && (n.pagination = U.toJSON(e.pagination)), n;
  },
  create(e) {
    return or.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = xs();
    return n.latestEpochMsgs = ((t = e.latestEpochMsgs) == null ? void 0 : t.map((i) => Ce.fromPartial(i))) || [], n.pagination = e.pagination !== void 0 && e.pagination !== null ? U.fromPartial(e.pagination) : void 0, n;
  }
};
function Bs() {
  return { valAddr: "" };
}
const sr = {
  encode(e, n = new g()) {
    return e.valAddr !== "" && n.uint32(10).string(e.valAddr), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Bs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.valAddr = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      valAddr: A(e.valAddr) ? globalThis.String(e.valAddr) : A(e.val_addr) ? globalThis.String(e.val_addr) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.valAddr !== "" && (n.valAddr = e.valAddr), n;
  },
  create(e) {
    return sr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Bs();
    return n.valAddr = e.valAddr ?? "", n;
  }
};
function Rs() {
  return { valAddr: "", valLife: [] };
}
const ar = {
  encode(e, n = new g()) {
    e.valAddr !== "" && n.uint32(10).string(e.valAddr);
    for (const t of e.valLife)
      Ue.encode(t, n.uint32(18).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Rs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.valAddr = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.valLife.push(Ue.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      valAddr: A(e.valAddr) ? globalThis.String(e.valAddr) : A(e.val_addr) ? globalThis.String(e.val_addr) : "",
      valLife: globalThis.Array.isArray(e == null ? void 0 : e.valLife) ? e.valLife.map((n) => Ue.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.val_life) ? e.val_life.map((n) => Ue.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.valAddr !== "" && (n.valAddr = e.valAddr), (t = e.valLife) != null && t.length && (n.valLife = e.valLife.map((i) => Ue.toJSON(i))), n;
  },
  create(e) {
    return ar.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Rs();
    return n.valAddr = e.valAddr ?? "", n.valLife = ((t = e.valLife) == null ? void 0 : t.map((i) => Ue.fromPartial(i))) || [], n;
  }
};
function Os() {
  return { delAddr: "" };
}
const dr = {
  encode(e, n = new g()) {
    return e.delAddr !== "" && n.uint32(10).string(e.delAddr), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Os();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delAddr = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delAddr: A(e.delAddr) ? globalThis.String(e.delAddr) : A(e.del_addr) ? globalThis.String(e.del_addr) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.delAddr !== "" && (n.delAddr = e.delAddr), n;
  },
  create(e) {
    return dr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Os();
    return n.delAddr = e.delAddr ?? "", n;
  }
};
function Es() {
  return { delLife: void 0 };
}
const lr = {
  encode(e, n = new g()) {
    return e.delLife !== void 0 && je.encode(e.delLife, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Es();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delLife = je.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delLife: A(e.delLife) ? je.fromJSON(e.delLife) : A(e.del_life) ? je.fromJSON(e.del_life) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.delLife !== void 0 && (n.delLife = je.toJSON(e.delLife)), n;
  },
  create(e) {
    return lr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Es();
    return n.delLife = e.delLife !== void 0 && e.delLife !== null ? je.fromPartial(e.delLife) : void 0, n;
  }
};
function Js() {
  return { epochNum: 0, pagination: void 0 };
}
const cr = {
  encode(e, n = new g()) {
    return e.epochNum !== 0 && n.uint32(8).uint64(e.epochNum), e.pagination !== void 0 && C.encode(e.pagination, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Js();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochNum = le(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.pagination = C.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochNum: A(e.epochNum) ? globalThis.Number(e.epochNum) : A(e.epoch_num) ? globalThis.Number(e.epoch_num) : 0,
      pagination: A(e.pagination) ? C.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.epochNum !== 0 && (n.epochNum = Math.round(e.epochNum)), e.pagination !== void 0 && (n.pagination = C.toJSON(e.pagination)), n;
  },
  create(e) {
    return cr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Js();
    return n.epochNum = e.epochNum ?? 0, n.pagination = e.pagination !== void 0 && e.pagination !== null ? C.fromPartial(e.pagination) : void 0, n;
  }
};
function Is() {
  return { validators: [], totalVotingPower: 0, pagination: void 0 };
}
const ur = {
  encode(e, n = new g()) {
    for (const t of e.validators)
      Sn.encode(t, n.uint32(10).fork()).join();
    return e.totalVotingPower !== 0 && n.uint32(16).int64(e.totalVotingPower), e.pagination !== void 0 && U.encode(e.pagination, n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Is();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.validators.push(Sn.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.totalVotingPower = le(t.int64());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.pagination = U.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      validators: globalThis.Array.isArray(e == null ? void 0 : e.validators) ? e.validators.map((n) => Sn.fromJSON(n)) : [],
      totalVotingPower: A(e.totalVotingPower) ? globalThis.Number(e.totalVotingPower) : A(e.total_voting_power) ? globalThis.Number(e.total_voting_power) : 0,
      pagination: A(e.pagination) ? U.fromJSON(e.pagination) : void 0
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.validators) != null && t.length && (n.validators = e.validators.map((i) => Sn.toJSON(i))), e.totalVotingPower !== 0 && (n.totalVotingPower = Math.round(e.totalVotingPower)), e.pagination !== void 0 && (n.pagination = U.toJSON(e.pagination)), n;
  },
  create(e) {
    return ur.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Is();
    return n.validators = ((t = e.validators) == null ? void 0 : t.map((i) => Sn.fromPartial(i))) || [], n.totalVotingPower = e.totalVotingPower ?? 0, n.pagination = e.pagination !== void 0 && e.pagination !== null ? U.fromPartial(e.pagination) : void 0, n;
  }
};
function Cs() {
  return {
    epochNumber: 0,
    currentEpochInterval: 0,
    firstBlockHeight: 0,
    lastBlockTime: void 0,
    sealerAppHashHex: "",
    sealerBlockHash: ""
  };
}
const ke = {
  encode(e, n = new g()) {
    return e.epochNumber !== 0 && n.uint32(8).uint64(e.epochNumber), e.currentEpochInterval !== 0 && n.uint32(16).uint64(e.currentEpochInterval), e.firstBlockHeight !== 0 && n.uint32(24).uint64(e.firstBlockHeight), e.lastBlockTime !== void 0 && H.encode(hr(e.lastBlockTime), n.uint32(34).fork()).join(), e.sealerAppHashHex !== "" && n.uint32(42).string(e.sealerAppHashHex), e.sealerBlockHash !== "" && n.uint32(50).string(e.sealerBlockHash), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Cs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochNumber = le(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.currentEpochInterval = le(t.uint64());
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.firstBlockHeight = le(t.uint64());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.lastBlockTime = Fn(H.decode(t, t.uint32()));
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.sealerAppHashHex = t.string();
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.sealerBlockHash = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochNumber: A(e.epochNumber) ? globalThis.Number(e.epochNumber) : A(e.epoch_number) ? globalThis.Number(e.epoch_number) : 0,
      currentEpochInterval: A(e.currentEpochInterval) ? globalThis.Number(e.currentEpochInterval) : A(e.current_epoch_interval) ? globalThis.Number(e.current_epoch_interval) : 0,
      firstBlockHeight: A(e.firstBlockHeight) ? globalThis.Number(e.firstBlockHeight) : A(e.first_block_height) ? globalThis.Number(e.first_block_height) : 0,
      lastBlockTime: A(e.lastBlockTime) ? yn(e.lastBlockTime) : A(e.last_block_time) ? yn(e.last_block_time) : void 0,
      sealerAppHashHex: A(e.sealerAppHashHex) ? globalThis.String(e.sealerAppHashHex) : A(e.sealer_app_hash_hex) ? globalThis.String(e.sealer_app_hash_hex) : "",
      sealerBlockHash: A(e.sealerBlockHash) ? globalThis.String(e.sealerBlockHash) : A(e.sealer_block_hash) ? globalThis.String(e.sealer_block_hash) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.epochNumber !== 0 && (n.epochNumber = Math.round(e.epochNumber)), e.currentEpochInterval !== 0 && (n.currentEpochInterval = Math.round(e.currentEpochInterval)), e.firstBlockHeight !== 0 && (n.firstBlockHeight = Math.round(e.firstBlockHeight)), e.lastBlockTime !== void 0 && (n.lastBlockTime = e.lastBlockTime.toISOString()), e.sealerAppHashHex !== "" && (n.sealerAppHashHex = e.sealerAppHashHex), e.sealerBlockHash !== "" && (n.sealerBlockHash = e.sealerBlockHash), n;
  },
  create(e) {
    return ke.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Cs();
    return n.epochNumber = e.epochNumber ?? 0, n.currentEpochInterval = e.currentEpochInterval ?? 0, n.firstBlockHeight = e.firstBlockHeight ?? 0, n.lastBlockTime = e.lastBlockTime ?? void 0, n.sealerAppHashHex = e.sealerAppHashHex ?? "", n.sealerBlockHash = e.sealerBlockHash ?? "", n;
  }
};
function Us() {
  return { txId: "", msgId: "", blockHeight: 0, blockTime: void 0, msg: "", msgType: "" };
}
const _e = {
  encode(e, n = new g()) {
    return e.txId !== "" && n.uint32(10).string(e.txId), e.msgId !== "" && n.uint32(18).string(e.msgId), e.blockHeight !== 0 && n.uint32(24).uint64(e.blockHeight), e.blockTime !== void 0 && H.encode(hr(e.blockTime), n.uint32(34).fork()).join(), e.msg !== "" && n.uint32(42).string(e.msg), e.msgType !== "" && n.uint32(50).string(e.msgType), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Us();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.txId = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.msgId = t.string();
            continue;
          }
          case 3: {
            if (r !== 24)
              break;
            o.blockHeight = le(t.uint64());
            continue;
          }
          case 4: {
            if (r !== 34)
              break;
            o.blockTime = Fn(H.decode(t, t.uint32()));
            continue;
          }
          case 5: {
            if (r !== 42)
              break;
            o.msg = t.string();
            continue;
          }
          case 6: {
            if (r !== 50)
              break;
            o.msgType = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      txId: A(e.txId) ? globalThis.String(e.txId) : A(e.tx_id) ? globalThis.String(e.tx_id) : "",
      msgId: A(e.msgId) ? globalThis.String(e.msgId) : A(e.msg_id) ? globalThis.String(e.msg_id) : "",
      blockHeight: A(e.blockHeight) ? globalThis.Number(e.blockHeight) : A(e.block_height) ? globalThis.Number(e.block_height) : 0,
      blockTime: A(e.blockTime) ? yn(e.blockTime) : A(e.block_time) ? yn(e.block_time) : void 0,
      msg: A(e.msg) ? globalThis.String(e.msg) : "",
      msgType: A(e.msgType) ? globalThis.String(e.msgType) : A(e.msg_type) ? globalThis.String(e.msg_type) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.txId !== "" && (n.txId = e.txId), e.msgId !== "" && (n.msgId = e.msgId), e.blockHeight !== 0 && (n.blockHeight = Math.round(e.blockHeight)), e.blockTime !== void 0 && (n.blockTime = e.blockTime.toISOString()), e.msg !== "" && (n.msg = e.msg), e.msgType !== "" && (n.msgType = e.msgType), n;
  },
  create(e) {
    return _e.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Us();
    return n.txId = e.txId ?? "", n.msgId = e.msgId ?? "", n.blockHeight = e.blockHeight ?? 0, n.blockTime = e.blockTime ?? void 0, n.msg = e.msg ?? "", n.msgType = e.msgType ?? "", n;
  }
};
function Hs() {
  return { epochNumber: 0, msgs: [] };
}
const Ce = {
  encode(e, n = new g()) {
    e.epochNumber !== 0 && n.uint32(8).uint64(e.epochNumber);
    for (const t of e.msgs)
      _e.encode(t, n.uint32(18).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Hs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.epochNumber = le(t.uint64());
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.msgs.push(_e.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      epochNumber: A(e.epochNumber) ? globalThis.Number(e.epochNumber) : A(e.epoch_number) ? globalThis.Number(e.epoch_number) : 0,
      msgs: globalThis.Array.isArray(e == null ? void 0 : e.msgs) ? e.msgs.map((n) => _e.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return e.epochNumber !== 0 && (n.epochNumber = Math.round(e.epochNumber)), (t = e.msgs) != null && t.length && (n.msgs = e.msgs.map((i) => _e.toJSON(i))), n;
  },
  create(e) {
    return Ce.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = Hs();
    return n.epochNumber = e.epochNumber ?? 0, n.msgs = ((t = e.msgs) == null ? void 0 : t.map((i) => _e.fromPartial(i))) || [], n;
  }
};
function Ms() {
  return { stateDesc: "", blockHeight: 0, blockTime: void 0 };
}
const Ue = {
  encode(e, n = new g()) {
    return e.stateDesc !== "" && n.uint32(10).string(e.stateDesc), e.blockHeight !== 0 && n.uint32(16).uint64(e.blockHeight), e.blockTime !== void 0 && H.encode(hr(e.blockTime), n.uint32(26).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ms();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.stateDesc = t.string();
            continue;
          }
          case 2: {
            if (r !== 16)
              break;
            o.blockHeight = le(t.uint64());
            continue;
          }
          case 3: {
            if (r !== 26)
              break;
            o.blockTime = Fn(H.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      stateDesc: A(e.stateDesc) ? globalThis.String(e.stateDesc) : A(e.state_desc) ? globalThis.String(e.state_desc) : "",
      blockHeight: A(e.blockHeight) ? globalThis.Number(e.blockHeight) : A(e.block_height) ? globalThis.Number(e.block_height) : 0,
      blockTime: A(e.blockTime) ? yn(e.blockTime) : A(e.block_time) ? yn(e.block_time) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.stateDesc !== "" && (n.stateDesc = e.stateDesc), e.blockHeight !== 0 && (n.blockHeight = Math.round(e.blockHeight)), e.blockTime !== void 0 && (n.blockTime = e.blockTime.toISOString()), n;
  },
  create(e) {
    return Ue.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ms();
    return n.stateDesc = e.stateDesc ?? "", n.blockHeight = e.blockHeight ?? 0, n.blockTime = e.blockTime ?? void 0, n;
  }
}, vd = "babylon.epoching.v1.Query";
let Al = class {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || vd, this.rpc = n, this.Params = this.Params.bind(this), this.EpochInfo = this.EpochInfo.bind(this), this.EpochsInfo = this.EpochsInfo.bind(this), this.CurrentEpoch = this.CurrentEpoch.bind(this), this.EpochMsgs = this.EpochMsgs.bind(this), this.LatestEpochMsgs = this.LatestEpochMsgs.bind(this), this.ValidatorLifecycle = this.ValidatorLifecycle.bind(this), this.DelegationLifecycle = this.DelegationLifecycle.bind(this), this.EpochValSet = this.EpochValSet.bind(this);
  }
  Params(n) {
    const t = Xt.encode(n).finish();
    return this.rpc.request(this.service, "Params", t).then((s) => Kt.decode(new a(s)));
  }
  EpochInfo(n) {
    const t = Zt.encode(n).finish();
    return this.rpc.request(this.service, "EpochInfo", t).then((s) => zt.decode(new a(s)));
  }
  EpochsInfo(n) {
    const t = Yt.encode(n).finish();
    return this.rpc.request(this.service, "EpochsInfo", t).then((s) => jt.decode(new a(s)));
  }
  CurrentEpoch(n) {
    const t = er.encode(n).finish();
    return this.rpc.request(this.service, "CurrentEpoch", t).then((s) => nr.decode(new a(s)));
  }
  EpochMsgs(n) {
    const t = tr.encode(n).finish();
    return this.rpc.request(this.service, "EpochMsgs", t).then((s) => rr.decode(new a(s)));
  }
  LatestEpochMsgs(n) {
    const t = ir.encode(n).finish();
    return this.rpc.request(this.service, "LatestEpochMsgs", t).then((s) => or.decode(new a(s)));
  }
  ValidatorLifecycle(n) {
    const t = sr.encode(n).finish();
    return this.rpc.request(this.service, "ValidatorLifecycle", t).then((s) => ar.decode(new a(s)));
  }
  DelegationLifecycle(n) {
    const t = dr.encode(n).finish();
    return this.rpc.request(this.service, "DelegationLifecycle", t).then((s) => lr.decode(new a(s)));
  }
  EpochValSet(n) {
    const t = cr.encode(n).finish();
    return this.rpc.request(this.service, "EpochValSet", t).then((s) => ur.decode(new a(s)));
  }
};
function hr(e) {
  const n = Math.trunc(e.getTime() / 1e3), t = e.getTime() % 1e3 * 1e6;
  return { seconds: n, nanos: t };
}
function Fn(e) {
  let n = (e.seconds || 0) * 1e3;
  return n += (e.nanos || 0) / 1e6, new globalThis.Date(n);
}
function yn(e) {
  return e instanceof globalThis.Date ? e : typeof e == "string" ? new globalThis.Date(e) : Fn(H.fromJSON(e));
}
function le(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function A(e) {
  return e != null;
}
const Rc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  EpochResponse: ke,
  QueryClientImpl: Al,
  QueryCurrentEpochRequest: er,
  QueryCurrentEpochResponse: nr,
  QueryDelegationLifecycleRequest: dr,
  QueryDelegationLifecycleResponse: lr,
  QueryEpochInfoRequest: Zt,
  QueryEpochInfoResponse: zt,
  QueryEpochMsgsRequest: tr,
  QueryEpochMsgsResponse: rr,
  QueryEpochValSetRequest: cr,
  QueryEpochValSetResponse: ur,
  QueryEpochsInfoRequest: Yt,
  QueryEpochsInfoResponse: jt,
  QueryLatestEpochMsgsRequest: ir,
  QueryLatestEpochMsgsResponse: or,
  QueryParamsRequest: Xt,
  QueryParamsResponse: Kt,
  QueryServiceName: vd,
  QueryValidatorLifecycleRequest: sr,
  QueryValidatorLifecycleResponse: ar,
  QueuedMessageList: Ce,
  QueuedMessageResponse: _e,
  ValStateUpdateResponse: Ue,
  protobufPackage: Dl
}, Symbol.toStringTag, { value: "Module" })), Nl = "babylon.epoching.v1";
function Vs() {
  return { msg: void 0 };
}
const An = {
  encode(e, n = new g()) {
    return e.msg !== void 0 && Me.encode(e.msg, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Vs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msg = Me.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { msg: qe(e.msg) ? Me.fromJSON(e.msg) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = Me.toJSON(e.msg)), n;
  },
  create(e) {
    return An.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Vs();
    return n.msg = e.msg !== void 0 && e.msg !== null ? Me.fromPartial(e.msg) : void 0, n;
  }
};
function Fs() {
  return {};
}
const fr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Fs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return fr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Fs();
  }
};
function Ls() {
  return { msg: void 0 };
}
const Nn = {
  encode(e, n = new g()) {
    return e.msg !== void 0 && Fe.encode(e.msg, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ls();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msg = Fe.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { msg: qe(e.msg) ? Fe.fromJSON(e.msg) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = Fe.toJSON(e.msg)), n;
  },
  create(e) {
    return Nn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ls();
    return n.msg = e.msg !== void 0 && e.msg !== null ? Fe.fromPartial(e.msg) : void 0, n;
  }
};
function Gs() {
  return {};
}
const gr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Gs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return gr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Gs();
  }
};
function Ws() {
  return { msg: void 0 };
}
const pr = {
  encode(e, n = new g()) {
    return e.msg !== void 0 && Ve.encode(e.msg, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ws();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msg = Ve.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { msg: qe(e.msg) ? Ve.fromJSON(e.msg) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = Ve.toJSON(e.msg)), n;
  },
  create(e) {
    return pr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ws();
    return n.msg = e.msg !== void 0 && e.msg !== null ? Ve.fromPartial(e.msg) : void 0, n;
  }
};
function $s() {
  return {};
}
const mr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = $s();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return mr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return $s();
  }
};
function Qs() {
  return { msg: void 0 };
}
const kr = {
  encode(e, n = new g()) {
    return e.msg !== void 0 && Le.encode(e.msg, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Qs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msg = Le.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { msg: qe(e.msg) ? Le.fromJSON(e.msg) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = Le.toJSON(e.msg)), n;
  },
  create(e) {
    return kr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Qs();
    return n.msg = e.msg !== void 0 && e.msg !== null ? Le.fromPartial(e.msg) : void 0, n;
  }
};
function qs() {
  return {};
}
const _r = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = qs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return _r.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return qs();
  }
};
function Xs() {
  return { msg: void 0 };
}
const br = {
  encode(e, n = new g()) {
    return e.msg !== void 0 && He.encode(e.msg, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Xs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msg = He.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { msg: qe(e.msg) ? He.fromJSON(e.msg) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = He.toJSON(e.msg)), n;
  },
  create(e) {
    return br.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Xs();
    return n.msg = e.msg !== void 0 && e.msg !== null ? He.fromPartial(e.msg) : void 0, n;
  }
};
function Ks() {
  return {};
}
const Sr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ks();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Sr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return Ks();
  }
};
function Zs() {
  return { msg: void 0 };
}
const vr = {
  encode(e, n = new g()) {
    return e.msg !== void 0 && Ge.encode(e.msg, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Zs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.msg = Ge.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { msg: qe(e.msg) ? Ge.fromJSON(e.msg) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.msg !== void 0 && (n.msg = Ge.toJSON(e.msg)), n;
  },
  create(e) {
    return vr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Zs();
    return n.msg = e.msg !== void 0 && e.msg !== null ? Ge.fromPartial(e.msg) : void 0, n;
  }
};
function zs() {
  return {};
}
const yr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = zs();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return yr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return zs();
  }
};
function Ys() {
  return { authority: "", params: void 0 };
}
const Tr = {
  encode(e, n = new g()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.params !== void 0 && Se.encode(e.params, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Ys();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.authority = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.params = Se.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      authority: qe(e.authority) ? globalThis.String(e.authority) : "",
      params: qe(e.params) ? Se.fromJSON(e.params) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.authority !== "" && (n.authority = e.authority), e.params !== void 0 && (n.params = Se.toJSON(e.params)), n;
  },
  create(e) {
    return Tr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Ys();
    return n.authority = e.authority ?? "", n.params = e.params !== void 0 && e.params !== null ? Se.fromPartial(e.params) : void 0, n;
  }
};
function js() {
  return {};
}
const wr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = js();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return wr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return js();
  }
}, yd = "babylon.epoching.v1.Msg";
let xl = class {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || yd, this.rpc = n, this.WrappedDelegate = this.WrappedDelegate.bind(this), this.WrappedUndelegate = this.WrappedUndelegate.bind(this), this.WrappedBeginRedelegate = this.WrappedBeginRedelegate.bind(this), this.WrappedCancelUnbondingDelegation = this.WrappedCancelUnbondingDelegation.bind(this), this.WrappedEditValidator = this.WrappedEditValidator.bind(this), this.WrappedStakingUpdateParams = this.WrappedStakingUpdateParams.bind(this), this.UpdateParams = this.UpdateParams.bind(this);
  }
  WrappedDelegate(n) {
    const t = An.encode(n).finish();
    return this.rpc.request(this.service, "WrappedDelegate", t).then((s) => fr.decode(new a(s)));
  }
  WrappedUndelegate(n) {
    const t = Nn.encode(n).finish();
    return this.rpc.request(this.service, "WrappedUndelegate", t).then((s) => gr.decode(new a(s)));
  }
  WrappedBeginRedelegate(n) {
    const t = pr.encode(n).finish();
    return this.rpc.request(this.service, "WrappedBeginRedelegate", t).then((s) => mr.decode(new a(s)));
  }
  WrappedCancelUnbondingDelegation(n) {
    const t = kr.encode(n).finish();
    return this.rpc.request(this.service, "WrappedCancelUnbondingDelegation", t).then((s) => _r.decode(new a(s)));
  }
  WrappedEditValidator(n) {
    const t = br.encode(n).finish();
    return this.rpc.request(this.service, "WrappedEditValidator", t).then((s) => Sr.decode(new a(s)));
  }
  WrappedStakingUpdateParams(n) {
    const t = vr.encode(n).finish();
    return this.rpc.request(this.service, "WrappedStakingUpdateParams", t).then((s) => yr.decode(new a(s)));
  }
  UpdateParams(n) {
    const t = Tr.encode(n).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((s) => wr.decode(new a(s)));
  }
};
function qe(e) {
  return e != null;
}
const Ec = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: xl,
  MsgServiceName: yd,
  MsgUpdateParams: Tr,
  MsgUpdateParamsResponse: wr,
  MsgWrappedBeginRedelegate: pr,
  MsgWrappedBeginRedelegateResponse: mr,
  MsgWrappedCancelUnbondingDelegation: kr,
  MsgWrappedCancelUnbondingDelegationResponse: _r,
  MsgWrappedDelegate: An,
  MsgWrappedDelegateResponse: fr,
  MsgWrappedEditValidator: br,
  MsgWrappedEditValidatorResponse: Sr,
  MsgWrappedStakingUpdateParams: vr,
  MsgWrappedStakingUpdateParamsResponse: yr,
  MsgWrappedUndelegate: Nn,
  MsgWrappedUndelegateResponse: gr,
  protobufPackage: Nl
}, Symbol.toStringTag, { value: "Module" }));
function ea() {
  return { btcStakingPortion: "" };
}
const ve = {
  encode(e, n = new g()) {
    return e.btcStakingPortion !== "" && n.uint32(10).string(e.btcStakingPortion), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ea();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.btcStakingPortion = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      btcStakingPortion: na(e.btcStakingPortion) ? globalThis.String(e.btcStakingPortion) : na(e.btc_staking_portion) ? globalThis.String(e.btc_staking_portion) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.btcStakingPortion !== "" && (n.btcStakingPortion = e.btcStakingPortion), n;
  },
  create(e) {
    return ve.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ea();
    return n.btcStakingPortion = e.btcStakingPortion ?? "", n;
  }
};
function na(e) {
  return e != null;
}
const Bl = "babylon.incentive";
function ta() {
  return {};
}
const Pr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ta();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Pr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return ta();
  }
};
function ra() {
  return { params: void 0 };
}
const Dr = {
  encode(e, n = new g()) {
    return e.params !== void 0 && ve.encode(e.params, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ra();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.params = ve.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { params: de(e.params) ? ve.fromJSON(e.params) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.params !== void 0 && (n.params = ve.toJSON(e.params)), n;
  },
  create(e) {
    return Dr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ra();
    return n.params = e.params !== void 0 && e.params !== null ? ve.fromPartial(e.params) : void 0, n;
  }
};
function ia() {
  return { address: "" };
}
const Ln = {
  encode(e, n = new g()) {
    return e.address !== "" && n.uint32(10).string(e.address), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ia();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.address = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { address: de(e.address) ? globalThis.String(e.address) : "" };
  },
  toJSON(e) {
    const n = {};
    return e.address !== "" && (n.address = e.address), n;
  },
  create(e) {
    return Ln.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ia();
    return n.address = e.address ?? "", n;
  }
};
function oa() {
  return { coins: [], withdrawnCoins: [] };
}
const ye = {
  encode(e, n = new g()) {
    for (const t of e.coins)
      w.encode(t, n.uint32(10).fork()).join();
    for (const t of e.withdrawnCoins)
      w.encode(t, n.uint32(18).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = oa();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.coins.push(w.decode(t, t.uint32()));
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.withdrawnCoins.push(w.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      coins: globalThis.Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => w.fromJSON(n)) : [],
      withdrawnCoins: globalThis.Array.isArray(e == null ? void 0 : e.withdrawnCoins) ? e.withdrawnCoins.map((n) => w.fromJSON(n)) : globalThis.Array.isArray(e == null ? void 0 : e.withdrawn_coins) ? e.withdrawn_coins.map((n) => w.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t, i;
    const n = {};
    return (t = e.coins) != null && t.length && (n.coins = e.coins.map((s) => w.toJSON(s))), (i = e.withdrawnCoins) != null && i.length && (n.withdrawnCoins = e.withdrawnCoins.map((s) => w.toJSON(s))), n;
  },
  create(e) {
    return ye.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t, i;
    const n = oa();
    return n.coins = ((t = e.coins) == null ? void 0 : t.map((s) => w.fromPartial(s))) || [], n.withdrawnCoins = ((i = e.withdrawnCoins) == null ? void 0 : i.map((s) => w.fromPartial(s))) || [], n;
  }
};
function sa() {
  return { rewardGauges: {} };
}
const Ar = {
  encode(e, n = new g()) {
    return globalThis.Object.entries(e.rewardGauges).forEach(([t, i]) => {
      In.encode({ key: t, value: i }, n.uint32(10).fork()).join();
    }), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = sa();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            const p = In.decode(t, t.uint32());
            p.value !== void 0 && (o.rewardGauges[p.key] = p.value);
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      rewardGauges: pa(e.rewardGauges) ? globalThis.Object.entries(e.rewardGauges).reduce(
        (n, [t, i]) => (globalThis.Object.defineProperty(n, t, {
          value: ye.fromJSON(i),
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), n),
        {}
      ) : pa(e.reward_gauges) ? globalThis.Object.entries(e.reward_gauges).reduce(
        (n, [t, i]) => (globalThis.Object.defineProperty(n, t, {
          value: ye.fromJSON(i),
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), n),
        {}
      ) : {}
    };
  },
  toJSON(e) {
    const n = {};
    if (e.rewardGauges) {
      const t = globalThis.Object.entries(e.rewardGauges);
      t.length > 0 && (n.rewardGauges = {}, t.forEach(([i, s]) => {
        n.rewardGauges[i] = ye.toJSON(s);
      }));
    }
    return n;
  },
  create(e) {
    return Ar.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = sa();
    return n.rewardGauges = globalThis.Object.entries(e.rewardGauges ?? {}).reduce((t, [i, s]) => (s !== void 0 && (t[i] = ye.fromPartial(s)), t), {}), n;
  }
};
function aa() {
  return { key: "", value: void 0 };
}
const In = {
  encode(e, n = new g()) {
    return e.key !== "" && n.uint32(10).string(e.key), e.value !== void 0 && ye.encode(e.value, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = aa();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.key = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.value = ye.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      key: de(e.key) ? globalThis.String(e.key) : "",
      value: de(e.value) ? ye.fromJSON(e.value) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.key !== "" && (n.key = e.key), e.value !== void 0 && (n.value = ye.toJSON(e.value)), n;
  },
  create(e) {
    return In.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = aa();
    return n.key = e.key ?? "", n.value = e.value !== void 0 && e.value !== null ? ye.fromPartial(e.value) : void 0, n;
  }
};
function da() {
  return { height: 0 };
}
const Nr = {
  encode(e, n = new g()) {
    return e.height !== 0 && n.uint32(8).uint64(e.height), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = da();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 8)
              break;
            o.height = Rl(t.uint64());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { height: de(e.height) ? globalThis.Number(e.height) : 0 };
  },
  toJSON(e) {
    const n = {};
    return e.height !== 0 && (n.height = Math.round(e.height)), n;
  },
  create(e) {
    return Nr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = da();
    return n.height = e.height ?? 0, n;
  }
};
function la() {
  return { coins: [] };
}
const fn = {
  encode(e, n = new g()) {
    for (const t of e.coins)
      w.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = la();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.coins.push(w.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { coins: globalThis.Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => w.fromJSON(n)) : [] };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.coins) != null && t.length && (n.coins = e.coins.map((i) => w.toJSON(i))), n;
  },
  create(e) {
    return fn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = la();
    return n.coins = ((t = e.coins) == null ? void 0 : t.map((i) => w.fromPartial(i))) || [], n;
  }
};
function ca() {
  return { gauge: void 0 };
}
const xr = {
  encode(e, n = new g()) {
    return e.gauge !== void 0 && fn.encode(e.gauge, n.uint32(10).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ca();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.gauge = fn.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { gauge: de(e.gauge) ? fn.fromJSON(e.gauge) : void 0 };
  },
  toJSON(e) {
    const n = {};
    return e.gauge !== void 0 && (n.gauge = fn.toJSON(e.gauge)), n;
  },
  create(e) {
    return xr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ca();
    return n.gauge = e.gauge !== void 0 && e.gauge !== null ? fn.fromPartial(e.gauge) : void 0, n;
  }
};
function ua() {
  return { delegatorAddress: "" };
}
const Br = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ua();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: de(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : de(e.delegator_address) ? globalThis.String(e.delegator_address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), n;
  },
  create(e) {
    return Br.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ua();
    return n.delegatorAddress = e.delegatorAddress ?? "", n;
  }
};
function ha() {
  return { withdrawAddress: "" };
}
const Rr = {
  encode(e, n = new g()) {
    return e.withdrawAddress !== "" && n.uint32(10).string(e.withdrawAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ha();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.withdrawAddress = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      withdrawAddress: de(e.withdrawAddress) ? globalThis.String(e.withdrawAddress) : de(e.withdraw_address) ? globalThis.String(e.withdraw_address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.withdrawAddress !== "" && (n.withdrawAddress = e.withdrawAddress), n;
  },
  create(e) {
    return Rr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ha();
    return n.withdrawAddress = e.withdrawAddress ?? "", n;
  }
};
function fa() {
  return { finalityProviderAddress: "", delegatorAddress: "" };
}
const Or = {
  encode(e, n = new g()) {
    return e.finalityProviderAddress !== "" && n.uint32(10).string(e.finalityProviderAddress), e.delegatorAddress !== "" && n.uint32(18).string(e.delegatorAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = fa();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.finalityProviderAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      finalityProviderAddress: de(e.finalityProviderAddress) ? globalThis.String(e.finalityProviderAddress) : de(e.finality_provider_address) ? globalThis.String(e.finality_provider_address) : "",
      delegatorAddress: de(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : de(e.delegator_address) ? globalThis.String(e.delegator_address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.finalityProviderAddress !== "" && (n.finalityProviderAddress = e.finalityProviderAddress), e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), n;
  },
  create(e) {
    return Or.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = fa();
    return n.finalityProviderAddress = e.finalityProviderAddress ?? "", n.delegatorAddress = e.delegatorAddress ?? "", n;
  }
};
function ga() {
  return { rewards: [] };
}
const Er = {
  encode(e, n = new g()) {
    for (const t of e.rewards)
      w.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ga();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.rewards.push(w.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      rewards: globalThis.Array.isArray(e == null ? void 0 : e.rewards) ? e.rewards.map((n) => w.fromJSON(n)) : []
    };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.rewards) != null && t.length && (n.rewards = e.rewards.map((i) => w.toJSON(i))), n;
  },
  create(e) {
    return Er.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ga();
    return n.rewards = ((t = e.rewards) == null ? void 0 : t.map((i) => w.fromPartial(i))) || [], n;
  }
}, Td = "babylon.incentive.Query";
class wd {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || Td, this.rpc = n, this.Params = this.Params.bind(this), this.RewardGauges = this.RewardGauges.bind(this), this.BTCStakingGauge = this.BTCStakingGauge.bind(this), this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this), this.DelegationRewards = this.DelegationRewards.bind(this);
  }
  Params(n) {
    const t = Pr.encode(n).finish();
    return this.rpc.request(this.service, "Params", t).then((s) => Dr.decode(new a(s)));
  }
  RewardGauges(n) {
    const t = Ln.encode(n).finish();
    return this.rpc.request(this.service, "RewardGauges", t).then((s) => Ar.decode(new a(s)));
  }
  BTCStakingGauge(n) {
    const t = Nr.encode(n).finish();
    return this.rpc.request(this.service, "BTCStakingGauge", t).then((s) => xr.decode(new a(s)));
  }
  DelegatorWithdrawAddress(n) {
    const t = Br.encode(n).finish();
    return this.rpc.request(this.service, "DelegatorWithdrawAddress", t).then((s) => Rr.decode(new a(s)));
  }
  DelegationRewards(n) {
    const t = Or.encode(n).finish();
    return this.rpc.request(this.service, "DelegationRewards", t).then((s) => Er.decode(new a(s)));
  }
}
function Rl(e) {
  const n = globalThis.Number(e.toString());
  if (n > globalThis.Number.MAX_SAFE_INTEGER)
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n < globalThis.Number.MIN_SAFE_INTEGER)
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n;
}
function pa(e) {
  return typeof e == "object" && e !== null;
}
function de(e) {
  return e != null;
}
const Jc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BTCStakingGaugeResponse: fn,
  QueryBTCStakingGaugeRequest: Nr,
  QueryBTCStakingGaugeResponse: xr,
  QueryClientImpl: wd,
  QueryDelegationRewardsRequest: Or,
  QueryDelegationRewardsResponse: Er,
  QueryDelegatorWithdrawAddressRequest: Br,
  QueryDelegatorWithdrawAddressResponse: Rr,
  QueryParamsRequest: Pr,
  QueryParamsResponse: Dr,
  QueryRewardGaugesRequest: Ln,
  QueryRewardGaugesResponse: Ar,
  QueryRewardGaugesResponse_RewardGaugesEntry: In,
  QueryServiceName: Td,
  RewardGaugesResponse: ye,
  protobufPackage: Bl
}, Symbol.toStringTag, { value: "Module" })), Ol = "babylon.incentive";
function ma() {
  return { type: "", address: "" };
}
const xn = {
  encode(e, n = new g()) {
    return e.type !== "" && n.uint32(10).string(e.type), e.address !== "" && n.uint32(18).string(e.address), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ma();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.type = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.address = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      type: We(e.type) ? globalThis.String(e.type) : "",
      address: We(e.address) ? globalThis.String(e.address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.type !== "" && (n.type = e.type), e.address !== "" && (n.address = e.address), n;
  },
  create(e) {
    return xn.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = ma();
    return n.type = e.type ?? "", n.address = e.address ?? "", n;
  }
};
function ka() {
  return { coins: [] };
}
const Jr = {
  encode(e, n = new g()) {
    for (const t of e.coins)
      w.encode(t, n.uint32(10).fork()).join();
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ka();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.coins.push(w.decode(t, t.uint32()));
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return { coins: globalThis.Array.isArray(e == null ? void 0 : e.coins) ? e.coins.map((n) => w.fromJSON(n)) : [] };
  },
  toJSON(e) {
    var t;
    const n = {};
    return (t = e.coins) != null && t.length && (n.coins = e.coins.map((i) => w.toJSON(i))), n;
  },
  create(e) {
    return Jr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    var t;
    const n = ka();
    return n.coins = ((t = e.coins) == null ? void 0 : t.map((i) => w.fromPartial(i))) || [], n;
  }
};
function _a() {
  return { authority: "", params: void 0 };
}
const Ir = {
  encode(e, n = new g()) {
    return e.authority !== "" && n.uint32(10).string(e.authority), e.params !== void 0 && ve.encode(e.params, n.uint32(18).fork()).join(), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = _a();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.authority = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.params = ve.decode(t, t.uint32());
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      authority: We(e.authority) ? globalThis.String(e.authority) : "",
      params: We(e.params) ? ve.fromJSON(e.params) : void 0
    };
  },
  toJSON(e) {
    const n = {};
    return e.authority !== "" && (n.authority = e.authority), e.params !== void 0 && (n.params = ve.toJSON(e.params)), n;
  },
  create(e) {
    return Ir.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = _a();
    return n.authority = e.authority ?? "", n.params = e.params !== void 0 && e.params !== null ? ve.fromPartial(e.params) : void 0, n;
  }
};
function ba() {
  return {};
}
const Cr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = ba();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Cr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return ba();
  }
};
function Sa() {
  return { delegatorAddress: "", withdrawAddress: "" };
}
const Ur = {
  encode(e, n = new g()) {
    return e.delegatorAddress !== "" && n.uint32(10).string(e.delegatorAddress), e.withdrawAddress !== "" && n.uint32(18).string(e.withdrawAddress), n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = Sa();
      for (; t.pos < s; ) {
        const r = t.uint32();
        switch (r >>> 3) {
          case 1: {
            if (r !== 10)
              break;
            o.delegatorAddress = t.string();
            continue;
          }
          case 2: {
            if (r !== 18)
              break;
            o.withdrawAddress = t.string();
            continue;
          }
        }
        if ((r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {
      delegatorAddress: We(e.delegatorAddress) ? globalThis.String(e.delegatorAddress) : We(e.delegator_address) ? globalThis.String(e.delegator_address) : "",
      withdrawAddress: We(e.withdrawAddress) ? globalThis.String(e.withdrawAddress) : We(e.withdraw_address) ? globalThis.String(e.withdraw_address) : ""
    };
  },
  toJSON(e) {
    const n = {};
    return e.delegatorAddress !== "" && (n.delegatorAddress = e.delegatorAddress), e.withdrawAddress !== "" && (n.withdrawAddress = e.withdrawAddress), n;
  },
  create(e) {
    return Ur.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = Sa();
    return n.delegatorAddress = e.delegatorAddress ?? "", n.withdrawAddress = e.withdrawAddress ?? "", n;
  }
};
function va() {
  return {};
}
const Hr = {
  encode(e, n = new g()) {
    return n;
  },
  decode(e, n) {
    const t = e instanceof a ? e : new a(e), i = t.__tsProtoDecodeDepth ?? 0;
    if (i >= 100)
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    t.__tsProtoDecodeDepth = i + 1;
    try {
      const s = n === void 0 ? t.len : t.pos + n, o = va();
      for (; t.pos < s; ) {
        const r = t.uint32();
        if (r >>> 3, (r & 7) === 4 || r === 0)
          break;
        t.skip(r & 7);
      }
      return o;
    } finally {
      t.__tsProtoDecodeDepth = i;
    }
  },
  fromJSON(e) {
    return {};
  },
  toJSON(e) {
    return {};
  },
  create(e) {
    return Hr.fromPartial(e ?? {});
  },
  fromPartial(e) {
    return va();
  }
}, Pd = "babylon.incentive.Msg";
class El {
  constructor(n, t) {
    te(this, "rpc");
    te(this, "service");
    this.service = (t == null ? void 0 : t.service) || Pd, this.rpc = n, this.WithdrawReward = this.WithdrawReward.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
  }
  WithdrawReward(n) {
    const t = xn.encode(n).finish();
    return this.rpc.request(this.service, "WithdrawReward", t).then((s) => Jr.decode(new a(s)));
  }
  UpdateParams(n) {
    const t = Ir.encode(n).finish();
    return this.rpc.request(this.service, "UpdateParams", t).then((s) => Cr.decode(new a(s)));
  }
  SetWithdrawAddress(n) {
    const t = Ur.encode(n).finish();
    return this.rpc.request(this.service, "SetWithdrawAddress", t).then((s) => Hr.decode(new a(s)));
  }
}
function We(e) {
  return e != null;
}
const Ic = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  MsgClientImpl: El,
  MsgServiceName: Pd,
  MsgSetWithdrawAddress: Ur,
  MsgSetWithdrawAddressResponse: Hr,
  MsgUpdateParams: Ir,
  MsgUpdateParamsResponse: Cr,
  MsgWithdrawReward: xn,
  MsgWithdrawRewardResponse: Jr,
  protobufPackage: Ol
}, Symbol.toStringTag, { value: "Module" }));
class Jl extends Error {
  constructor(n, t, i) {
    super(t, i), this.code = n;
  }
}
function Il(e) {
  return e.replace(/_([a-z])/g, (n, t) => t.toUpperCase());
}
function tt(e, n) {
  if (Array.isArray(e))
    return e.map((t) => tt(t, n));
  if (e !== null && typeof e == "object") {
    const t = {};
    for (const [i, s] of Object.entries(e))
      t[n(i)] = tt(s, n);
    return t;
  }
  return e;
}
function Cl(e) {
  return async (n, t) => {
    const i = t ? `?${new URLSearchParams(t)}` : "", s = `${e}${n}${i}`, o = await fetch(s), r = await o.json();
    if (!o.ok)
      throw new Jl(
        o.status,
        (r == null ? void 0 : r.message) ?? "Unknown Server Error"
      );
    return tt(r, Il);
  };
}
const Ul = 100;
function Dd(e = {}) {
  const n = {};
  return e.limit !== void 0 && (n["pagination.limit"] = e.limit.toString()), e.key !== void 0 && e.key !== "" && (n["pagination.key"] = e.key), n;
}
async function Tn(e, n, t, i = {}) {
  var p;
  const s = [];
  let o = i.key || null;
  const r = i.limit || Ul;
  do {
    const y = Dd({
      ...i,
      limit: r,
      key: o || void 0
    }), R = await e(n, y), P = R[t];
    P && Array.isArray(P) && s.push(...P);
    const m = (p = R.pagination) == null ? void 0 : p.nextKey;
    if (o = m && m !== "" ? m : null, P && P.length === 0 && o === null)
      break;
  } while (o !== null);
  return s;
}
const Hl = ({ request: e }) => ({
  async getDelegations(n) {
    try {
      return await Tn(
        e,
        `/cosmos/staking/v1beta1/delegations/${n}`,
        "delegationResponses"
      );
    } catch (t) {
      throw new Error(`Failed to fetch delegations for ${n}`, {
        cause: t
      });
    }
  },
  async getRewards(n) {
    try {
      return (await e(
        `/cosmos/distribution/v1beta1/delegators/${n}/rewards`
      )).rewards || [];
    } catch (t) {
      if (t instanceof Error && t.message.includes("no delegation"))
        return [];
      throw new Error(`Failed to fetch delegation rewards for ${n}`, {
        cause: t
      });
    }
  },
  async getValidators() {
    try {
      return await Tn(
        e,
        "/cosmos/staking/v1beta1/validators",
        "validators"
      );
    } catch (n) {
      throw new Error("Failed to fetch validators", {
        cause: n
      });
    }
  },
  async getBalance(n, t = "ubbn") {
    var i;
    try {
      const s = await e(
        `/cosmos/bank/v1beta1/balances/${n}/by_denom`,
        { denom: t }
      );
      return BigInt(((i = s == null ? void 0 : s.balance) == null ? void 0 : i.amount) ?? 0);
    } catch (s) {
      throw new Error(`Failed to fetch balance for ${n}`, {
        cause: s
      });
    }
  },
  async getPool() {
    try {
      const { pool: n } = await e("/cosmos/staking/v1beta1/pool");
      return {
        notBondedTokens: Number.parseInt(n.notBondedTokens, 10),
        bondedTokens: Number.parseInt(n.bondedTokens, 10)
      };
    } catch (n) {
      throw new Error("Failed to fetch pool", {
        cause: n
      });
    }
  },
  async getIncentiveParams() {
    const n = await e("/babylon/incentive/params"), t = (n == null ? void 0 : n.params) ?? n, i = Number((t == null ? void 0 : t.btcStakingPortion) ?? 0), s = Number((t == null ? void 0 : t.fpPortion) ?? 0);
    return {
      btcStakingPortion: Number.isFinite(i) ? i : 0,
      fpPortion: Number.isFinite(s) ? s : 0
    };
  },
  async getCostakingParams() {
    const n = await e("/babylon/costaking/v1/params"), t = (n == null ? void 0 : n.params) ?? n, i = Number(
      (t == null ? void 0 : t.costakingPortion) ?? (t == null ? void 0 : t.costaking_portion) ?? 0
    ), s = Number(
      (t == null ? void 0 : t.validatorsPortion) ?? (t == null ? void 0 : t.validators_portion) ?? 0
    ), o = (t == null ? void 0 : t.scoreRatioBtcByBaby) ?? (t == null ? void 0 : t.score_ratio_btc_by_baby) ?? "50";
    return {
      costakingPortion: Number.isFinite(i) ? i : 0,
      validatorsPortion: Number.isFinite(s) ? s : 0,
      scoreRatioBtcByBaby: o
    };
  },
  async getCoStakerRewardsTracker(n) {
    var t;
    if (!n)
      return null;
    try {
      const i = await e(
        `/babylon/costaking/v1/costakers/${n}/rewards_tracker`
      );
      return {
        startPeriodCumulativeReward: (i == null ? void 0 : i.startPeriodCumulativeReward) ?? 0,
        activeSatoshis: (i == null ? void 0 : i.activeSatoshis) ?? "0",
        activeBaby: (i == null ? void 0 : i.activeBaby) ?? "0",
        totalScore: (i == null ? void 0 : i.totalScore) ?? "0"
      };
    } catch (i) {
      if ((t = i == null ? void 0 : i.message) != null && t.includes("404") || (i == null ? void 0 : i.status) === 404)
        return null;
      throw new Error(
        `Failed to fetch co-staker rewards tracker for ${n}`,
        {
          cause: i
        }
      );
    }
  },
  async getCurrentCoStakingRewards() {
    try {
      const n = await e("/babylon/costaking/v1/current_rewards");
      return {
        rewards: (n == null ? void 0 : n.rewards) ?? [],
        period: (n == null ? void 0 : n.period) ?? 0,
        totalScore: (n == null ? void 0 : n.totalScore) ?? "0"
      };
    } catch (n) {
      throw new Error("Failed to fetch current co-staking rewards", {
        cause: n
      });
    }
  },
  async getAnnualProvisions() {
    try {
      const n = await e("/cosmos/mint/v1beta1/annual_provisions"), t = (n == null ? void 0 : n.annualProvisions) ?? (n == null ? void 0 : n.annual_provisions) ?? n;
      return Number(t);
    } catch (n) {
      throw new Error("Failed to fetch annual provisions", {
        cause: n
      });
    }
  },
  async getSupply(n = "ubbn") {
    var t;
    try {
      const i = await e("/cosmos/bank/v1beta1/supply/by_denom", {
        denom: n
      }), s = ((t = i == null ? void 0 : i.amount) == null ? void 0 : t.amount) ?? 0;
      return BigInt(s);
    } catch (i) {
      throw new Error(`Failed to fetch supply for ${n}`, {
        cause: i
      });
    }
  },
  async getAnnualCoStakingRewardSupply() {
    try {
      const n = await this.getAnnualProvisions(), t = await this.getIncentiveParams(), { btcStakingPortion: i, fpPortion: s } = t, o = await this.getCostakingParams(), { costakingPortion: r } = o, p = 1 - i - s;
      return n * p * r;
    } catch (n) {
      throw new Error("Failed to calculate annual co-staking reward supply", {
        cause: n
      });
    }
  },
  async getCurrentEpoch() {
    try {
      const { currentEpoch: n, epochBoundary: t } = await e(
        "/babylon/epoching/v1/current_epoch"
      );
      return {
        epochBoundary: Number.parseInt(t, 10),
        currentEpoch: Number.parseInt(n, 10)
      };
    } catch (n) {
      throw new Error("Failed to fetch current epoch", {
        cause: n
      });
    }
  },
  async getSigningInfos() {
    try {
      return (await Tn(
        e,
        "/cosmos/slashing/v1beta1/signing_infos",
        "info",
        { limit: 200 }
      )).map((t) => ({
        address: t.address,
        tombstoned: !!t.tombstoned
      }));
    } catch (n) {
      throw new Error("Failed to fetch signing infos", { cause: n });
    }
  },
  async getLatestValidatorSet() {
    try {
      return await Tn(
        e,
        "/cosmos/base/tendermint/v1beta1/validatorsets/latest",
        "validators",
        { limit: 200 }
      );
    } catch (n) {
      throw new Error("Failed to fetch latest validator set", { cause: n });
    }
  }
}), Cn = "BTC_STAKER", Un = "COSTAKER", Ml = "btc_staker", $ = {
  MsgCreateBTCDelegation: "/babylon.btcstaking.v1.MsgCreateBTCDelegation",
  MsgBtcStakeExpand: "/babylon.btcstaking.v1.MsgBtcStakeExpand",
  MsgWithdrawRewardForBTCStaking: "/babylon.incentive.MsgWithdrawReward",
  MsgStakeBABY: "/babylon.epoching.v1.MsgWrappedDelegate",
  MsgUnstakeBABY: "/babylon.epoching.v1.MsgWrappedUndelegate",
  MsgWithdrawRewardForBABYStaking: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward"
};
function $e(e) {
  return (e == null ? void 0 : e.reduce(
    (t, i) => t + BigInt(i.amount),
    0n
  )) || 0n;
}
const Vl = ({ request: e }) => ({
  async getRewards(n) {
    var t, i, s, o;
    try {
      const r = await e(
        `/babylon/incentive/address/${n}/reward_gauge`
      );
      if (!(r != null && r.rewardGauges))
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      const p = (t = r.rewardGauges[Cn]) == null ? void 0 : t.coins, y = $e(
        (i = r.rewardGauges[Cn]) == null ? void 0 : i.withdrawnCoins
      ), P = $e(p) - y, m = (s = r.rewardGauges[Un]) == null ? void 0 : s.coins, T = $e(
        (o = r.rewardGauges[Un]) == null ? void 0 : o.withdrawnCoins
      ), j = $e(m) - T;
      return {
        btcStaker: P,
        coStaker: j
      };
    } catch (r) {
      if (r instanceof Error && r.message.includes("reward gauge not found"))
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      throw new Error(`Failed to fetch rewards for ${n}`, {
        cause: r
      });
    }
  },
  async getBTCTipHeight() {
    try {
      const { header: n } = await e("/babylon/btclightclient/v1/tip");
      return Number((n == null ? void 0 : n.height) ?? 0);
    } catch (n) {
      throw new Error("Failed to fetch BTC tip height", {
        cause: n
      });
    }
  }
}), Cc = ({ url: e }) => {
  const n = Cl(e);
  return {
    baby: Hl({ request: n }),
    btc: Vl({ request: n })
  };
}, Fl = ({
  staking: e,
  distribution: n,
  bank: t,
  tmClient: i
}) => ({
  async getDelegations(s) {
    try {
      return (await e.delegatorDelegations(s)).delegationResponses || [];
    } catch (o) {
      throw new Error(`Failed to fetch delegations for ${s}`, {
        cause: o
      });
    }
  },
  async getRewards(s) {
    try {
      return (await n.delegationTotalRewards(s)).rewards || [];
    } catch (o) {
      if (o instanceof Error && o.message.includes("no delegation"))
        return [];
      throw new Error(`Failed to fetch delegation rewards for ${s}`, {
        cause: o
      });
    }
  },
  async getValidators() {
    try {
      return (await e.validators("")).validators || [];
    } catch (s) {
      throw new Error("Failed to fetch validators", {
        cause: s
      });
    }
  },
  async getBalance(s, o = "ubbn") {
    try {
      const r = await t.balance(s, o);
      return BigInt((r == null ? void 0 : r.amount) ?? 0);
    } catch (r) {
      throw new Error(`Failed to fetch balance for ${s}`, {
        cause: r
      });
    }
  },
  async getPool() {
    try {
      const { pool: s } = await e.pool();
      return {
        notBondedTokens: Number.parseInt(s.notBondedTokens, 10),
        bondedTokens: Number.parseInt(s.bondedTokens, 10)
      };
    } catch (s) {
      throw new Error("Failed to fetch pool", {
        cause: s
      });
    }
  },
  async getBlockHeight() {
    try {
      return (await i.status()).syncInfo.latestBlockHeight;
    } catch (s) {
      throw new Error("Failed to fetch block height", {
        cause: s
      });
    }
  }
}), Ll = ({ incentive: e, btcLight: n }) => ({
  /**
   * Gets the available BTC staking rewards from the user's account, broken down by type.
   * Returns separate values for base BTC staking rewards and co-staking bonus rewards.
   * @param address - The Babylon address to query rewards for
   * @returns {Promise<BTCRewards>} - Rewards broken down by type (btcStaker, coStaker)
   */
  async getRewards(t) {
    var i, s, o, r;
    try {
      const p = Ln.fromPartial({
        address: t
      }), y = await e.RewardGauges(p);
      if (!y || !y.rewardGauges)
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      const R = (i = y.rewardGauges[Cn]) == null ? void 0 : i.coins, P = $e(
        (s = y.rewardGauges[Cn]) == null ? void 0 : s.withdrawnCoins
      ), T = $e(R) - P, O = (o = y.rewardGauges[Un]) == null ? void 0 : o.coins, j = $e(
        (r = y.rewardGauges[Un]) == null ? void 0 : r.withdrawnCoins
      ), l = $e(O) - j;
      return {
        btcStaker: T,
        coStaker: l
      };
    } catch (p) {
      if (p instanceof Error && p.message.includes("reward gauge not found"))
        return {
          btcStaker: 0n,
          coStaker: 0n
        };
      throw new Error(`Failed to fetch rewards for ${t}`, {
        cause: p
      });
    }
  },
  async getBTCTipHeight() {
    try {
      const t = Hn.fromPartial({}), { header: i } = await n.Tip(t);
      return Number((i == null ? void 0 : i.height) ?? 0);
    } catch (t) {
      throw new Error("Failed to fetch BTC tip height", {
        cause: t
      });
    }
  }
}), Uc = async ({ url: e }) => {
  const n = await Cd.connect(e), t = Ed.withExtensions(
    n,
    Fr,
    Lr,
    Gr
  ), i = Jd(t), s = new wd(i), o = new Ga(i), r = Fr(t).bank, p = Lr(t).staking, y = Gr(t).distribution;
  return {
    baby: Fl({ staking: p, distribution: y, bank: r, tmClient: n }),
    btc: Ll({ incentive: s, btcLight: o })
  };
};
var ya = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Zn = {}, ce = {}, De = {}, Ae = {}, Ta;
function Gl() {
  if (Ta) return Ae;
  Ta = 1, Object.defineProperty(Ae, "__esModule", { value: !0 }), Ae.utf8Write = Ae.utf8Read = Ae.utf8Length = void 0;
  function e(i) {
    let s = 0, o = 0;
    for (let r = 0; r < i.length; ++r)
      o = i.charCodeAt(r), o < 128 ? s += 1 : o < 2048 ? s += 2 : (o & 64512) === 55296 && (i.charCodeAt(r + 1) & 64512) === 56320 ? (++r, s += 4) : s += 3;
    return s;
  }
  Ae.utf8Length = e;
  function n(i, s, o) {
    if (o - s < 1)
      return "";
    const p = [];
    let y = [], R = 0, P;
    for (; s < o; )
      P = i[s++], P < 128 ? p[R++] = P : P > 191 && P < 224 ? p[R++] = (P & 31) << 6 | i[s++] & 63 : P > 239 && P < 365 ? (P = ((P & 7) << 18 | (i[s++] & 63) << 12 | (i[s++] & 63) << 6 | i[s++] & 63) - 65536, p[R++] = 55296 + (P >> 10), p[R++] = 56320 + (P & 1023)) : p[R++] = (P & 15) << 12 | (i[s++] & 63) << 6 | i[s++] & 63, R > 8191 && ((y || (y = [])).push(String.fromCharCode(...p)), R = 0);
    return y ? (R && y.push(String.fromCharCode(...p.slice(0, R))), y.join("")) : String.fromCharCode(...p.slice(0, R));
  }
  Ae.utf8Read = n;
  function t(i, s, o) {
    const r = o;
    let p, y;
    for (let R = 0; R < i.length; ++R)
      p = i.charCodeAt(R), p < 128 ? s[o++] = p : p < 2048 ? (s[o++] = p >> 6 | 192, s[o++] = p & 63 | 128) : (p & 64512) === 55296 && ((y = i.charCodeAt(R + 1)) & 64512) === 56320 ? (p = 65536 + ((p & 1023) << 10) + (y & 1023), ++R, s[o++] = p >> 18 | 240, s[o++] = p >> 12 & 63 | 128, s[o++] = p >> 6 & 63 | 128, s[o++] = p & 63 | 128) : (s[o++] = p >> 12 | 224, s[o++] = p >> 6 & 63 | 128, s[o++] = p & 63 | 128);
    return o - r;
  }
  return Ae.utf8Write = t, Ae;
}
var J = {}, wa;
function Wl() {
  if (wa) return J;
  wa = 1, Object.defineProperty(J, "__esModule", { value: !0 }), J.writeByte = J.writeFixed32 = J.int64Length = J.writeVarint64 = J.writeVarint32 = J.readInt32 = J.readUInt32 = J.zzDecode = J.zzEncode = J.varint32read = J.varint32write = J.uInt64ToString = J.int64ToString = J.int64FromString = J.varint64write = J.varint64read = void 0;
  function e() {
    let d = 0, h = 0;
    for (let v = 0; v < 28; v += 7) {
      let D = this.buf[this.pos++];
      if (d |= (D & 127) << v, (D & 128) == 0)
        return this.assertBounds(), [d, h];
    }
    let S = this.buf[this.pos++];
    if (d |= (S & 15) << 28, h = (S & 112) >> 4, (S & 128) == 0)
      return this.assertBounds(), [d, h];
    for (let v = 3; v <= 31; v += 7) {
      let D = this.buf[this.pos++];
      if (h |= (D & 127) << v, (D & 128) == 0)
        return this.assertBounds(), [d, h];
    }
    throw new Error("invalid varint");
  }
  J.varint64read = e;
  function n(d, h, S) {
    for (let K = 0; K < 28; K = K + 7) {
      const ne = d >>> K, Te = !(!(ne >>> 7) && h == 0), pe = (Te ? ne | 128 : ne) & 255;
      if (S.push(pe), !Te)
        return;
    }
    const v = d >>> 28 & 15 | (h & 7) << 4, D = h >> 3 != 0;
    if (S.push((D ? v | 128 : v) & 255), !!D) {
      for (let K = 3; K < 31; K = K + 7) {
        const ne = h >>> K, Te = !!(ne >>> 7), pe = (Te ? ne | 128 : ne) & 255;
        if (S.push(pe), !Te)
          return;
      }
      S.push(h >>> 31 & 1);
    }
  }
  J.varint64write = n;
  const t = 4294967296;
  function i(d) {
    const h = d[0] === "-";
    h && (d = d.slice(1));
    const S = 1e6;
    let v = 0, D = 0;
    function K(ne, Te) {
      const pe = Number(d.slice(ne, Te));
      D *= S, v = v * S + pe, v >= t && (D = D + (v / t | 0), v = v % t);
    }
    return K(-24, -18), K(-18, -12), K(-12, -6), K(-6), h ? y(v, D) : p(v, D);
  }
  J.int64FromString = i;
  function s(d, h) {
    let S = p(d, h);
    const v = S.hi & 2147483648;
    v && (S = y(S.lo, S.hi));
    const D = o(S.lo, S.hi);
    return v ? "-" + D : D;
  }
  J.int64ToString = s;
  function o(d, h) {
    if ({ lo: d, hi: h } = r(d, h), h <= 2097151)
      return String(t * h + d);
    const S = d & 16777215, v = (d >>> 24 | h << 8) & 16777215, D = h >> 16 & 65535;
    let K = S + v * 6777216 + D * 6710656, ne = v + D * 8147497, Te = D * 2;
    const pe = 1e7;
    return K >= pe && (ne += Math.floor(K / pe), K %= pe), ne >= pe && (Te += Math.floor(ne / pe), ne %= pe), Te.toString() + R(ne) + R(K);
  }
  J.uInt64ToString = o;
  function r(d, h) {
    return { lo: d >>> 0, hi: h >>> 0 };
  }
  function p(d, h) {
    return { lo: d | 0, hi: h | 0 };
  }
  function y(d, h) {
    return h = ~h, d ? d = ~d + 1 : h += 1, p(d, h);
  }
  const R = (d) => {
    const h = String(d);
    return "0000000".slice(h.length) + h;
  };
  function P(d, h) {
    if (d >= 0) {
      for (; d > 127; )
        h.push(d & 127 | 128), d = d >>> 7;
      h.push(d);
    } else {
      for (let S = 0; S < 9; S++)
        h.push(d & 127 | 128), d = d >> 7;
      h.push(1);
    }
  }
  J.varint32write = P;
  function m() {
    let d = this.buf[this.pos++], h = d & 127;
    if ((d & 128) == 0)
      return this.assertBounds(), h;
    if (d = this.buf[this.pos++], h |= (d & 127) << 7, (d & 128) == 0)
      return this.assertBounds(), h;
    if (d = this.buf[this.pos++], h |= (d & 127) << 14, (d & 128) == 0)
      return this.assertBounds(), h;
    if (d = this.buf[this.pos++], h |= (d & 127) << 21, (d & 128) == 0)
      return this.assertBounds(), h;
    d = this.buf[this.pos++], h |= (d & 15) << 28;
    for (let S = 5; (d & 128) !== 0 && S < 10; S++)
      d = this.buf[this.pos++];
    if ((d & 128) != 0)
      throw new Error("invalid varint");
    return this.assertBounds(), h >>> 0;
  }
  J.varint32read = m;
  function T(d, h) {
    let S = h >> 31;
    return h = ((h << 1 | d >>> 31) ^ S) >>> 0, d = (d << 1 ^ S) >>> 0, [d, h];
  }
  J.zzEncode = T;
  function O(d, h) {
    let S = -(d & 1);
    return d = ((d >>> 1 | h << 31) ^ S) >>> 0, h = (h >>> 1 ^ S) >>> 0, [d, h];
  }
  J.zzDecode = O;
  function j(d, h) {
    return (d[h] | d[h + 1] << 8 | d[h + 2] << 16) + d[h + 3] * 16777216;
  }
  J.readUInt32 = j;
  function ee(d, h) {
    return (d[h] | d[h + 1] << 8 | d[h + 2] << 16) + (d[h + 3] << 24);
  }
  J.readInt32 = ee;
  function l(d, h, S) {
    for (; d > 127; )
      h[S++] = d & 127 | 128, d >>>= 7;
    h[S] = d;
  }
  J.writeVarint32 = l;
  function c(d, h, S) {
    for (; d.hi; )
      h[S++] = d.lo & 127 | 128, d.lo = (d.lo >>> 7 | d.hi << 25) >>> 0, d.hi >>>= 7;
    for (; d.lo > 127; )
      h[S++] = d.lo & 127 | 128, d.lo = d.lo >>> 7;
    h[S++] = d.lo;
  }
  J.writeVarint64 = c;
  function f(d, h) {
    let S = d, v = (d >>> 28 | h << 4) >>> 0, D = h >>> 24;
    return D === 0 ? v === 0 ? S < 16384 ? S < 128 ? 1 : 2 : S < 2097152 ? 3 : 4 : v < 16384 ? v < 128 ? 5 : 6 : v < 2097152 ? 7 : 8 : D < 128 ? 9 : 10;
  }
  J.int64Length = f;
  function x(d, h, S) {
    h[S] = d & 255, h[S + 1] = d >>> 8 & 255, h[S + 2] = d >>> 16 & 255, h[S + 3] = d >>> 24;
  }
  J.writeFixed32 = x;
  function u(d, h, S) {
    h[S] = d & 255;
  }
  return J.writeByte = u, J;
}
var Pa;
function Mr() {
  if (Pa) return De;
  Pa = 1, Object.defineProperty(De, "__esModule", { value: !0 }), De.BinaryWriter = De.BinaryReader = De.WireType = void 0;
  const e = Gl(), n = Wl();
  var t;
  (function(P) {
    P[P.Varint = 0] = "Varint", P[P.Fixed64 = 1] = "Fixed64", P[P.Bytes = 2] = "Bytes", P[P.Fixed32 = 5] = "Fixed32";
  })(t || (De.WireType = t = {}));
  class i {
    assertBounds() {
      if (this.pos > this.len)
        throw new RangeError("premature EOF");
    }
    constructor(m) {
      this.buf = m ? new Uint8Array(m) : new Uint8Array(0), this.pos = 0, this.type = 0, this.len = this.buf.length;
    }
    tag() {
      const m = this.uint32(), T = m >>> 3, O = m & 7;
      if (T <= 0 || O < 0 || O > 5)
        throw new Error("illegal tag: field no " + T + " wire type " + O);
      return [T, O, m];
    }
    skip(m) {
      if (typeof m == "number") {
        if (this.pos + m > this.len)
          throw R(this, m);
        this.pos += m;
      } else
        do
          if (this.pos >= this.len)
            throw R(this);
        while (this.buf[this.pos++] & 128);
      return this;
    }
    skipType(m) {
      switch (m) {
        case t.Varint:
          this.skip();
          break;
        case t.Fixed64:
          this.skip(8);
          break;
        case t.Bytes:
          this.skip(this.uint32());
          break;
        case 3:
          for (; (m = this.uint32() & 7) !== 4; )
            this.skipType(m);
          break;
        case t.Fixed32:
          this.skip(4);
          break;
        /* istanbul ignore next */
        default:
          throw Error("invalid wire type " + m + " at offset " + this.pos);
      }
      return this;
    }
    uint32() {
      return n.varint32read.bind(this)();
    }
    int32() {
      return this.uint32() | 0;
    }
    sint32() {
      const m = this.uint32();
      return m % 2 === 1 ? (m + 1) / -2 : m / 2;
    }
    fixed32() {
      const m = (0, n.readUInt32)(this.buf, this.pos);
      return this.pos += 4, m;
    }
    sfixed32() {
      const m = (0, n.readInt32)(this.buf, this.pos);
      return this.pos += 4, m;
    }
    int64() {
      const [m, T] = n.varint64read.bind(this)();
      return BigInt((0, n.int64ToString)(m, T));
    }
    uint64() {
      const [m, T] = n.varint64read.bind(this)();
      return BigInt((0, n.uInt64ToString)(m, T));
    }
    sint64() {
      let [m, T] = n.varint64read.bind(this)();
      return [m, T] = (0, n.zzDecode)(m, T), BigInt((0, n.int64ToString)(m, T));
    }
    fixed64() {
      const m = this.sfixed32(), T = this.sfixed32();
      return BigInt((0, n.uInt64ToString)(m, T));
    }
    sfixed64() {
      const m = this.sfixed32(), T = this.sfixed32();
      return BigInt((0, n.int64ToString)(m, T));
    }
    float() {
      throw new Error("float not supported");
    }
    double() {
      throw new Error("double not supported");
    }
    bool() {
      const [m, T] = n.varint64read.bind(this)();
      return m !== 0 || T !== 0;
    }
    bytes() {
      const m = this.uint32(), T = this.pos;
      return this.pos += m, this.assertBounds(), this.buf.subarray(T, T + m);
    }
    string() {
      const m = this.bytes();
      return (0, e.utf8Read)(m, 0, m.length);
    }
  }
  De.BinaryReader = i;
  class s {
    constructor(m, T, O) {
      this.fn = m, this.len = T, this.val = O;
    }
    proceed(m, T) {
      this.fn && this.fn(this.val, m, T);
    }
  }
  class o {
    constructor(m) {
      this.head = m.head, this.tail = m.tail, this.len = m.len, this.next = m.states;
    }
  }
  class r {
    constructor() {
      this.len = 0, this.uint64 = r.prototype.int64, this.sfixed64 = r.prototype.fixed64, this.sfixed32 = r.prototype.fixed32, this.head = new s(null, 0, 0), this.tail = this.head, this.states = null;
    }
    static create() {
      return new r();
    }
    static alloc(m) {
      return typeof Uint8Array < "u" ? y((T) => new Uint8Array(T), Uint8Array.prototype.subarray)(m) : new Array(m);
    }
    _push(m, T, O) {
      return this.tail = this.tail.next = new s(m, T, O), this.len += T, this;
    }
    finish() {
      let m = this.head.next, T = 0;
      const O = r.alloc(this.len);
      for (; m; )
        m.proceed(O, T), T += m.len, m = m.next;
      return O;
    }
    fork() {
      return this.states = new o(this), this.head = this.tail = new s(null, 0, 0), this.len = 0, this;
    }
    reset() {
      return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new s(null, 0, 0), this.len = 0), this;
    }
    ldelim() {
      const m = this.head, T = this.tail, O = this.len;
      return this.reset().uint32(O), O && (this.tail.next = m.next, this.tail = T, this.len += O), this;
    }
    tag(m, T) {
      return this.uint32((m << 3 | T) >>> 0);
    }
    uint32(m) {
      return this.len += (this.tail = this.tail.next = new s(n.writeVarint32, (m = m >>> 0) < 128 ? 1 : m < 16384 ? 2 : m < 2097152 ? 3 : m < 268435456 ? 4 : 5, m)).len, this;
    }
    int32(m) {
      return m < 0 ? this._push(n.writeVarint64, 10, (0, n.int64FromString)(m.toString())) : this.uint32(m);
    }
    sint32(m) {
      return this.uint32((m << 1 ^ m >> 31) >>> 0);
    }
    int64(m) {
      const { lo: T, hi: O } = (0, n.int64FromString)(m.toString());
      return this._push(n.writeVarint64, (0, n.int64Length)(T, O), { lo: T, hi: O });
    }
    sint64(m) {
      let { lo: T, hi: O } = (0, n.int64FromString)(m.toString());
      return [T, O] = (0, n.zzEncode)(T, O), this._push(n.writeVarint64, (0, n.int64Length)(T, O), { lo: T, hi: O });
    }
    fixed64(m) {
      const { lo: T, hi: O } = (0, n.int64FromString)(m.toString());
      return this._push(n.writeFixed32, 4, T)._push(n.writeFixed32, 4, O);
    }
    bool(m) {
      return this._push(n.writeByte, 1, m ? 1 : 0);
    }
    fixed32(m) {
      return this._push(n.writeFixed32, 4, m >>> 0);
    }
    float(m) {
      throw new Error("float not supported" + m);
    }
    double(m) {
      throw new Error("double not supported" + m);
    }
    bytes(m) {
      const T = m.length >>> 0;
      return T ? this.uint32(T)._push(p, T, m) : this._push(n.writeByte, 1, 0);
    }
    string(m) {
      const T = (0, e.utf8Length)(m);
      return T ? this.uint32(T)._push(e.utf8Write, T, m) : this._push(n.writeByte, 1, 0);
    }
  }
  De.BinaryWriter = r;
  function p(P, m, T) {
    if (typeof Uint8Array < "u")
      m.set(P, T);
    else
      for (let O = 0; O < P.length; ++O)
        m[T + O] = P[O];
  }
  function y(P, m, T) {
    let ee = null, l = 8192;
    return function(f) {
      if (f < 1 || f > 4096)
        return P(f);
      l + f > 8192 && (ee = P(8192), l = 0);
      const x = m.call(ee, l, l += f);
      return l & 7 && (l = (l | 7) + 1), x;
    };
  }
  function R(P, m) {
    return RangeError("index out of range: " + P.pos + " + " + (m || 1) + " > " + P.len);
  }
  return De;
}
var L = {}, Da;
function Vr() {
  if (Da) return L;
  Da = 1, Object.defineProperty(L, "__esModule", { value: !0 }), L.fromJsonTimestamp = L.fromTimestamp = L.toTimestamp = L.isRpc = L.setPaginationParams = L.isObject = L.isSet = L.fromDuration = L.toDuration = L.omitDefault = L.base64FromBytes = L.bytesFromBase64 = void 0;
  var e = (() => {
    if (typeof e < "u")
      return e;
    if (typeof self < "u")
      return self;
    if (typeof window < "u")
      return window;
    if (typeof ya < "u")
      return ya;
    throw "Unable to locate global object";
  })();
  const n = e.atob || ((c) => e.Buffer.from(c, "base64").toString("binary"));
  function t(c) {
    const f = n(c), x = new Uint8Array(f.length);
    for (let u = 0; u < f.length; ++u)
      x[u] = f.charCodeAt(u);
    return x;
  }
  L.bytesFromBase64 = t;
  const i = e.btoa || ((c) => e.Buffer.from(c, "binary").toString("base64"));
  function s(c) {
    const f = [];
    return c.forEach((x) => {
      f.push(String.fromCharCode(x));
    }), i(f.join(""));
  }
  L.base64FromBytes = s;
  function o(c) {
    if (typeof c == "string")
      return c === "" ? void 0 : c;
    if (typeof c == "number")
      return c === 0 ? void 0 : c;
    if (typeof c == "boolean")
      return c === !1 ? void 0 : c;
    if (typeof c == "bigint")
      return c === BigInt(0) ? void 0 : c;
    throw new Error(`Got unsupported type ${typeof c}`);
  }
  L.omitDefault = o;
  function r(c) {
    return {
      seconds: BigInt(Math.floor(parseInt(c) / 1e9)),
      nanos: parseInt(c) % 1e9
    };
  }
  L.toDuration = r;
  function p(c) {
    return (parseInt(c.seconds.toString()) * 1e9 + c.nanos).toString();
  }
  L.fromDuration = p;
  function y(c) {
    return c != null;
  }
  L.isSet = y;
  function R(c) {
    return typeof c == "object" && c !== null;
  }
  L.isObject = R;
  const P = (c, f) => (f && (typeof (f == null ? void 0 : f.countTotal) < "u" && (c.params["pagination.count_total"] = f.countTotal), typeof (f == null ? void 0 : f.key) < "u" && (c.params["pagination.key"] = Buffer.from(f.key).toString("base64")), typeof (f == null ? void 0 : f.limit) < "u" && (c.params["pagination.limit"] = f.limit.toString()), typeof (f == null ? void 0 : f.offset) < "u" && (c.params["pagination.offset"] = f.offset.toString()), typeof (f == null ? void 0 : f.reverse) < "u" && (c.params["pagination.reverse"] = f.reverse)), c);
  L.setPaginationParams = P;
  function m(c) {
    return c != null && typeof c.request == "function";
  }
  L.isRpc = m;
  function T(c) {
    const f = l(c.getTime() / 1e3), x = c.getTime() % 1e3 * 1e6;
    return {
      seconds: f,
      nanos: x
    };
  }
  L.toTimestamp = T;
  function O(c) {
    let f = Number(c.seconds) * 1e3;
    return f += c.nanos / 1e6, new Date(f);
  }
  L.fromTimestamp = O;
  const j = (c) => ({
    seconds: y(c.seconds) ? BigInt(c.seconds.toString()) : BigInt(0),
    nanos: y(c.nanos) ? Number(c.nanos) : 0
  });
  function ee(c) {
    return c instanceof Date ? T(c) : typeof c == "string" ? T(new Date(c)) : j(c);
  }
  L.fromJsonTimestamp = ee;
  function l(c) {
    return BigInt(Math.trunc(c));
  }
  return L;
}
var Aa;
function Ad() {
  if (Aa) return ce;
  Aa = 1, Object.defineProperty(ce, "__esModule", { value: !0 }), ce.DecProto = ce.IntProto = ce.DecCoin = ce.Coin = ce.protobufPackage = void 0;
  const e = Mr(), n = Vr();
  ce.protobufPackage = "cosmos.base.v1beta1";
  function t() {
    return {
      denom: "",
      amount: ""
    };
  }
  ce.Coin = {
    typeUrl: "/cosmos.base.v1beta1.Coin",
    encode(r, p = e.BinaryWriter.create()) {
      return r.denom !== "" && p.uint32(10).string(r.denom), r.amount !== "" && p.uint32(18).string(r.amount), p;
    },
    decode(r, p) {
      const y = r instanceof e.BinaryReader ? r : new e.BinaryReader(r);
      let R = p === void 0 ? y.len : y.pos + p;
      const P = t();
      for (; y.pos < R; ) {
        const m = y.uint32();
        switch (m >>> 3) {
          case 1:
            P.denom = y.string();
            break;
          case 2:
            P.amount = y.string();
            break;
          default:
            y.skipType(m & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(r) {
      const p = t();
      return (0, n.isSet)(r.denom) && (p.denom = String(r.denom)), (0, n.isSet)(r.amount) && (p.amount = String(r.amount)), p;
    },
    toJSON(r) {
      const p = {};
      return r.denom !== void 0 && (p.denom = r.denom), r.amount !== void 0 && (p.amount = r.amount), p;
    },
    fromPartial(r) {
      const p = t();
      return p.denom = r.denom ?? "", p.amount = r.amount ?? "", p;
    }
  };
  function i() {
    return {
      denom: "",
      amount: ""
    };
  }
  ce.DecCoin = {
    typeUrl: "/cosmos.base.v1beta1.DecCoin",
    encode(r, p = e.BinaryWriter.create()) {
      return r.denom !== "" && p.uint32(10).string(r.denom), r.amount !== "" && p.uint32(18).string(r.amount), p;
    },
    decode(r, p) {
      const y = r instanceof e.BinaryReader ? r : new e.BinaryReader(r);
      let R = p === void 0 ? y.len : y.pos + p;
      const P = i();
      for (; y.pos < R; ) {
        const m = y.uint32();
        switch (m >>> 3) {
          case 1:
            P.denom = y.string();
            break;
          case 2:
            P.amount = y.string();
            break;
          default:
            y.skipType(m & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(r) {
      const p = i();
      return (0, n.isSet)(r.denom) && (p.denom = String(r.denom)), (0, n.isSet)(r.amount) && (p.amount = String(r.amount)), p;
    },
    toJSON(r) {
      const p = {};
      return r.denom !== void 0 && (p.denom = r.denom), r.amount !== void 0 && (p.amount = r.amount), p;
    },
    fromPartial(r) {
      const p = i();
      return p.denom = r.denom ?? "", p.amount = r.amount ?? "", p;
    }
  };
  function s() {
    return {
      int: ""
    };
  }
  ce.IntProto = {
    typeUrl: "/cosmos.base.v1beta1.IntProto",
    encode(r, p = e.BinaryWriter.create()) {
      return r.int !== "" && p.uint32(10).string(r.int), p;
    },
    decode(r, p) {
      const y = r instanceof e.BinaryReader ? r : new e.BinaryReader(r);
      let R = p === void 0 ? y.len : y.pos + p;
      const P = s();
      for (; y.pos < R; ) {
        const m = y.uint32();
        switch (m >>> 3) {
          case 1:
            P.int = y.string();
            break;
          default:
            y.skipType(m & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(r) {
      const p = s();
      return (0, n.isSet)(r.int) && (p.int = String(r.int)), p;
    },
    toJSON(r) {
      const p = {};
      return r.int !== void 0 && (p.int = r.int), p;
    },
    fromPartial(r) {
      const p = s();
      return p.int = r.int ?? "", p;
    }
  };
  function o() {
    return {
      dec: ""
    };
  }
  return ce.DecProto = {
    typeUrl: "/cosmos.base.v1beta1.DecProto",
    encode(r, p = e.BinaryWriter.create()) {
      return r.dec !== "" && p.uint32(10).string(r.dec), p;
    },
    decode(r, p) {
      const y = r instanceof e.BinaryReader ? r : new e.BinaryReader(r);
      let R = p === void 0 ? y.len : y.pos + p;
      const P = o();
      for (; y.pos < R; ) {
        const m = y.uint32();
        switch (m >>> 3) {
          case 1:
            P.dec = y.string();
            break;
          default:
            y.skipType(m & 7);
            break;
        }
      }
      return P;
    },
    fromJSON(r) {
      const p = o();
      return (0, n.isSet)(r.dec) && (p.dec = String(r.dec)), p;
    },
    toJSON(r) {
      const p = {};
      return r.dec !== void 0 && (p.dec = r.dec), p;
    },
    fromPartial(r) {
      const p = o();
      return p.dec = r.dec ?? "", p;
    }
  }, ce;
}
var zn = {}, Na;
function $l() {
  return Na || (Na = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.CommunityPoolSpendProposalWithDeposit = e.DelegationDelegatorReward = e.DelegatorStartingInfo = e.CommunityPoolSpendProposal = e.FeePool = e.ValidatorSlashEvents = e.ValidatorSlashEvent = e.ValidatorOutstandingRewards = e.ValidatorAccumulatedCommission = e.ValidatorCurrentRewards = e.ValidatorHistoricalRewards = e.Params = e.protobufPackage = void 0;
    const n = Ad(), t = Mr(), i = Vr();
    e.protobufPackage = "cosmos.distribution.v1beta1";
    function s() {
      return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: !1
      };
    }
    e.Params = {
      typeUrl: "/cosmos.distribution.v1beta1.Params",
      encode(l, c = t.BinaryWriter.create()) {
        return l.communityTax !== "" && c.uint32(10).string(l.communityTax), l.baseProposerReward !== "" && c.uint32(18).string(l.baseProposerReward), l.bonusProposerReward !== "" && c.uint32(26).string(l.bonusProposerReward), l.withdrawAddrEnabled === !0 && c.uint32(32).bool(l.withdrawAddrEnabled), c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = s();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.communityTax = f.string();
              break;
            case 2:
              u.baseProposerReward = f.string();
              break;
            case 3:
              u.bonusProposerReward = f.string();
              break;
            case 4:
              u.withdrawAddrEnabled = f.bool();
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = s();
        return (0, i.isSet)(l.communityTax) && (c.communityTax = String(l.communityTax)), (0, i.isSet)(l.baseProposerReward) && (c.baseProposerReward = String(l.baseProposerReward)), (0, i.isSet)(l.bonusProposerReward) && (c.bonusProposerReward = String(l.bonusProposerReward)), (0, i.isSet)(l.withdrawAddrEnabled) && (c.withdrawAddrEnabled = !!l.withdrawAddrEnabled), c;
      },
      toJSON(l) {
        const c = {};
        return l.communityTax !== void 0 && (c.communityTax = l.communityTax), l.baseProposerReward !== void 0 && (c.baseProposerReward = l.baseProposerReward), l.bonusProposerReward !== void 0 && (c.bonusProposerReward = l.bonusProposerReward), l.withdrawAddrEnabled !== void 0 && (c.withdrawAddrEnabled = l.withdrawAddrEnabled), c;
      },
      fromPartial(l) {
        const c = s();
        return c.communityTax = l.communityTax ?? "", c.baseProposerReward = l.baseProposerReward ?? "", c.bonusProposerReward = l.bonusProposerReward ?? "", c.withdrawAddrEnabled = l.withdrawAddrEnabled ?? !1, c;
      }
    };
    function o() {
      return {
        cumulativeRewardRatio: [],
        referenceCount: 0
      };
    }
    e.ValidatorHistoricalRewards = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorHistoricalRewards",
      encode(l, c = t.BinaryWriter.create()) {
        for (const f of l.cumulativeRewardRatio)
          n.DecCoin.encode(f, c.uint32(10).fork()).ldelim();
        return l.referenceCount !== 0 && c.uint32(16).uint32(l.referenceCount), c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = o();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.cumulativeRewardRatio.push(n.DecCoin.decode(f, f.uint32()));
              break;
            case 2:
              u.referenceCount = f.uint32();
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = o();
        return Array.isArray(l == null ? void 0 : l.cumulativeRewardRatio) && (c.cumulativeRewardRatio = l.cumulativeRewardRatio.map((f) => n.DecCoin.fromJSON(f))), (0, i.isSet)(l.referenceCount) && (c.referenceCount = Number(l.referenceCount)), c;
      },
      toJSON(l) {
        const c = {};
        return l.cumulativeRewardRatio ? c.cumulativeRewardRatio = l.cumulativeRewardRatio.map((f) => f ? n.DecCoin.toJSON(f) : void 0) : c.cumulativeRewardRatio = [], l.referenceCount !== void 0 && (c.referenceCount = Math.round(l.referenceCount)), c;
      },
      fromPartial(l) {
        var f;
        const c = o();
        return c.cumulativeRewardRatio = ((f = l.cumulativeRewardRatio) == null ? void 0 : f.map((x) => n.DecCoin.fromPartial(x))) || [], c.referenceCount = l.referenceCount ?? 0, c;
      }
    };
    function r() {
      return {
        rewards: [],
        period: BigInt(0)
      };
    }
    e.ValidatorCurrentRewards = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorCurrentRewards",
      encode(l, c = t.BinaryWriter.create()) {
        for (const f of l.rewards)
          n.DecCoin.encode(f, c.uint32(10).fork()).ldelim();
        return l.period !== BigInt(0) && c.uint32(16).uint64(l.period), c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = r();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.rewards.push(n.DecCoin.decode(f, f.uint32()));
              break;
            case 2:
              u.period = f.uint64();
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = r();
        return Array.isArray(l == null ? void 0 : l.rewards) && (c.rewards = l.rewards.map((f) => n.DecCoin.fromJSON(f))), (0, i.isSet)(l.period) && (c.period = BigInt(l.period.toString())), c;
      },
      toJSON(l) {
        const c = {};
        return l.rewards ? c.rewards = l.rewards.map((f) => f ? n.DecCoin.toJSON(f) : void 0) : c.rewards = [], l.period !== void 0 && (c.period = (l.period || BigInt(0)).toString()), c;
      },
      fromPartial(l) {
        var f;
        const c = r();
        return c.rewards = ((f = l.rewards) == null ? void 0 : f.map((x) => n.DecCoin.fromPartial(x))) || [], l.period !== void 0 && l.period !== null && (c.period = BigInt(l.period.toString())), c;
      }
    };
    function p() {
      return {
        commission: []
      };
    }
    e.ValidatorAccumulatedCommission = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorAccumulatedCommission",
      encode(l, c = t.BinaryWriter.create()) {
        for (const f of l.commission)
          n.DecCoin.encode(f, c.uint32(10).fork()).ldelim();
        return c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = p();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.commission.push(n.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = p();
        return Array.isArray(l == null ? void 0 : l.commission) && (c.commission = l.commission.map((f) => n.DecCoin.fromJSON(f))), c;
      },
      toJSON(l) {
        const c = {};
        return l.commission ? c.commission = l.commission.map((f) => f ? n.DecCoin.toJSON(f) : void 0) : c.commission = [], c;
      },
      fromPartial(l) {
        var f;
        const c = p();
        return c.commission = ((f = l.commission) == null ? void 0 : f.map((x) => n.DecCoin.fromPartial(x))) || [], c;
      }
    };
    function y() {
      return {
        rewards: []
      };
    }
    e.ValidatorOutstandingRewards = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorOutstandingRewards",
      encode(l, c = t.BinaryWriter.create()) {
        for (const f of l.rewards)
          n.DecCoin.encode(f, c.uint32(10).fork()).ldelim();
        return c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = y();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.rewards.push(n.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = y();
        return Array.isArray(l == null ? void 0 : l.rewards) && (c.rewards = l.rewards.map((f) => n.DecCoin.fromJSON(f))), c;
      },
      toJSON(l) {
        const c = {};
        return l.rewards ? c.rewards = l.rewards.map((f) => f ? n.DecCoin.toJSON(f) : void 0) : c.rewards = [], c;
      },
      fromPartial(l) {
        var f;
        const c = y();
        return c.rewards = ((f = l.rewards) == null ? void 0 : f.map((x) => n.DecCoin.fromPartial(x))) || [], c;
      }
    };
    function R() {
      return {
        validatorPeriod: BigInt(0),
        fraction: ""
      };
    }
    e.ValidatorSlashEvent = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvent",
      encode(l, c = t.BinaryWriter.create()) {
        return l.validatorPeriod !== BigInt(0) && c.uint32(8).uint64(l.validatorPeriod), l.fraction !== "" && c.uint32(18).string(l.fraction), c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = R();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.validatorPeriod = f.uint64();
              break;
            case 2:
              u.fraction = f.string();
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = R();
        return (0, i.isSet)(l.validatorPeriod) && (c.validatorPeriod = BigInt(l.validatorPeriod.toString())), (0, i.isSet)(l.fraction) && (c.fraction = String(l.fraction)), c;
      },
      toJSON(l) {
        const c = {};
        return l.validatorPeriod !== void 0 && (c.validatorPeriod = (l.validatorPeriod || BigInt(0)).toString()), l.fraction !== void 0 && (c.fraction = l.fraction), c;
      },
      fromPartial(l) {
        const c = R();
        return l.validatorPeriod !== void 0 && l.validatorPeriod !== null && (c.validatorPeriod = BigInt(l.validatorPeriod.toString())), c.fraction = l.fraction ?? "", c;
      }
    };
    function P() {
      return {
        validatorSlashEvents: []
      };
    }
    e.ValidatorSlashEvents = {
      typeUrl: "/cosmos.distribution.v1beta1.ValidatorSlashEvents",
      encode(l, c = t.BinaryWriter.create()) {
        for (const f of l.validatorSlashEvents)
          e.ValidatorSlashEvent.encode(f, c.uint32(10).fork()).ldelim();
        return c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = P();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.validatorSlashEvents.push(e.ValidatorSlashEvent.decode(f, f.uint32()));
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = P();
        return Array.isArray(l == null ? void 0 : l.validatorSlashEvents) && (c.validatorSlashEvents = l.validatorSlashEvents.map((f) => e.ValidatorSlashEvent.fromJSON(f))), c;
      },
      toJSON(l) {
        const c = {};
        return l.validatorSlashEvents ? c.validatorSlashEvents = l.validatorSlashEvents.map((f) => f ? e.ValidatorSlashEvent.toJSON(f) : void 0) : c.validatorSlashEvents = [], c;
      },
      fromPartial(l) {
        var f;
        const c = P();
        return c.validatorSlashEvents = ((f = l.validatorSlashEvents) == null ? void 0 : f.map((x) => e.ValidatorSlashEvent.fromPartial(x))) || [], c;
      }
    };
    function m() {
      return {
        communityPool: []
      };
    }
    e.FeePool = {
      typeUrl: "/cosmos.distribution.v1beta1.FeePool",
      encode(l, c = t.BinaryWriter.create()) {
        for (const f of l.communityPool)
          n.DecCoin.encode(f, c.uint32(10).fork()).ldelim();
        return c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = m();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.communityPool.push(n.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = m();
        return Array.isArray(l == null ? void 0 : l.communityPool) && (c.communityPool = l.communityPool.map((f) => n.DecCoin.fromJSON(f))), c;
      },
      toJSON(l) {
        const c = {};
        return l.communityPool ? c.communityPool = l.communityPool.map((f) => f ? n.DecCoin.toJSON(f) : void 0) : c.communityPool = [], c;
      },
      fromPartial(l) {
        var f;
        const c = m();
        return c.communityPool = ((f = l.communityPool) == null ? void 0 : f.map((x) => n.DecCoin.fromPartial(x))) || [], c;
      }
    };
    function T() {
      return {
        title: "",
        description: "",
        recipient: "",
        amount: []
      };
    }
    e.CommunityPoolSpendProposal = {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposal",
      encode(l, c = t.BinaryWriter.create()) {
        l.title !== "" && c.uint32(10).string(l.title), l.description !== "" && c.uint32(18).string(l.description), l.recipient !== "" && c.uint32(26).string(l.recipient);
        for (const f of l.amount)
          n.Coin.encode(f, c.uint32(34).fork()).ldelim();
        return c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = T();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.title = f.string();
              break;
            case 2:
              u.description = f.string();
              break;
            case 3:
              u.recipient = f.string();
              break;
            case 4:
              u.amount.push(n.Coin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = T();
        return (0, i.isSet)(l.title) && (c.title = String(l.title)), (0, i.isSet)(l.description) && (c.description = String(l.description)), (0, i.isSet)(l.recipient) && (c.recipient = String(l.recipient)), Array.isArray(l == null ? void 0 : l.amount) && (c.amount = l.amount.map((f) => n.Coin.fromJSON(f))), c;
      },
      toJSON(l) {
        const c = {};
        return l.title !== void 0 && (c.title = l.title), l.description !== void 0 && (c.description = l.description), l.recipient !== void 0 && (c.recipient = l.recipient), l.amount ? c.amount = l.amount.map((f) => f ? n.Coin.toJSON(f) : void 0) : c.amount = [], c;
      },
      fromPartial(l) {
        var f;
        const c = T();
        return c.title = l.title ?? "", c.description = l.description ?? "", c.recipient = l.recipient ?? "", c.amount = ((f = l.amount) == null ? void 0 : f.map((x) => n.Coin.fromPartial(x))) || [], c;
      }
    };
    function O() {
      return {
        previousPeriod: BigInt(0),
        stake: "",
        height: BigInt(0)
      };
    }
    e.DelegatorStartingInfo = {
      typeUrl: "/cosmos.distribution.v1beta1.DelegatorStartingInfo",
      encode(l, c = t.BinaryWriter.create()) {
        return l.previousPeriod !== BigInt(0) && c.uint32(8).uint64(l.previousPeriod), l.stake !== "" && c.uint32(18).string(l.stake), l.height !== BigInt(0) && c.uint32(24).uint64(l.height), c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = O();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.previousPeriod = f.uint64();
              break;
            case 2:
              u.stake = f.string();
              break;
            case 3:
              u.height = f.uint64();
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = O();
        return (0, i.isSet)(l.previousPeriod) && (c.previousPeriod = BigInt(l.previousPeriod.toString())), (0, i.isSet)(l.stake) && (c.stake = String(l.stake)), (0, i.isSet)(l.height) && (c.height = BigInt(l.height.toString())), c;
      },
      toJSON(l) {
        const c = {};
        return l.previousPeriod !== void 0 && (c.previousPeriod = (l.previousPeriod || BigInt(0)).toString()), l.stake !== void 0 && (c.stake = l.stake), l.height !== void 0 && (c.height = (l.height || BigInt(0)).toString()), c;
      },
      fromPartial(l) {
        const c = O();
        return l.previousPeriod !== void 0 && l.previousPeriod !== null && (c.previousPeriod = BigInt(l.previousPeriod.toString())), c.stake = l.stake ?? "", l.height !== void 0 && l.height !== null && (c.height = BigInt(l.height.toString())), c;
      }
    };
    function j() {
      return {
        validatorAddress: "",
        reward: []
      };
    }
    e.DelegationDelegatorReward = {
      typeUrl: "/cosmos.distribution.v1beta1.DelegationDelegatorReward",
      encode(l, c = t.BinaryWriter.create()) {
        l.validatorAddress !== "" && c.uint32(10).string(l.validatorAddress);
        for (const f of l.reward)
          n.DecCoin.encode(f, c.uint32(18).fork()).ldelim();
        return c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = j();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.validatorAddress = f.string();
              break;
            case 2:
              u.reward.push(n.DecCoin.decode(f, f.uint32()));
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = j();
        return (0, i.isSet)(l.validatorAddress) && (c.validatorAddress = String(l.validatorAddress)), Array.isArray(l == null ? void 0 : l.reward) && (c.reward = l.reward.map((f) => n.DecCoin.fromJSON(f))), c;
      },
      toJSON(l) {
        const c = {};
        return l.validatorAddress !== void 0 && (c.validatorAddress = l.validatorAddress), l.reward ? c.reward = l.reward.map((f) => f ? n.DecCoin.toJSON(f) : void 0) : c.reward = [], c;
      },
      fromPartial(l) {
        var f;
        const c = j();
        return c.validatorAddress = l.validatorAddress ?? "", c.reward = ((f = l.reward) == null ? void 0 : f.map((x) => n.DecCoin.fromPartial(x))) || [], c;
      }
    };
    function ee() {
      return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: ""
      };
    }
    e.CommunityPoolSpendProposalWithDeposit = {
      typeUrl: "/cosmos.distribution.v1beta1.CommunityPoolSpendProposalWithDeposit",
      encode(l, c = t.BinaryWriter.create()) {
        return l.title !== "" && c.uint32(10).string(l.title), l.description !== "" && c.uint32(18).string(l.description), l.recipient !== "" && c.uint32(26).string(l.recipient), l.amount !== "" && c.uint32(34).string(l.amount), l.deposit !== "" && c.uint32(42).string(l.deposit), c;
      },
      decode(l, c) {
        const f = l instanceof t.BinaryReader ? l : new t.BinaryReader(l);
        let x = c === void 0 ? f.len : f.pos + c;
        const u = ee();
        for (; f.pos < x; ) {
          const d = f.uint32();
          switch (d >>> 3) {
            case 1:
              u.title = f.string();
              break;
            case 2:
              u.description = f.string();
              break;
            case 3:
              u.recipient = f.string();
              break;
            case 4:
              u.amount = f.string();
              break;
            case 5:
              u.deposit = f.string();
              break;
            default:
              f.skipType(d & 7);
              break;
          }
        }
        return u;
      },
      fromJSON(l) {
        const c = ee();
        return (0, i.isSet)(l.title) && (c.title = String(l.title)), (0, i.isSet)(l.description) && (c.description = String(l.description)), (0, i.isSet)(l.recipient) && (c.recipient = String(l.recipient)), (0, i.isSet)(l.amount) && (c.amount = String(l.amount)), (0, i.isSet)(l.deposit) && (c.deposit = String(l.deposit)), c;
      },
      toJSON(l) {
        const c = {};
        return l.title !== void 0 && (c.title = l.title), l.description !== void 0 && (c.description = l.description), l.recipient !== void 0 && (c.recipient = l.recipient), l.amount !== void 0 && (c.amount = l.amount), l.deposit !== void 0 && (c.deposit = l.deposit), c;
      },
      fromPartial(l) {
        const c = ee();
        return c.title = l.title ?? "", c.description = l.description ?? "", c.recipient = l.recipient ?? "", c.amount = l.amount ?? "", c.deposit = l.deposit ?? "", c;
      }
    };
  }(zn)), zn;
}
var xa;
function Ql() {
  return xa || (xa = 1, function(e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MsgClientImpl = e.MsgDepositValidatorRewardsPoolResponse = e.MsgDepositValidatorRewardsPool = e.MsgCommunityPoolSpendResponse = e.MsgCommunityPoolSpend = e.MsgUpdateParamsResponse = e.MsgUpdateParams = e.MsgFundCommunityPoolResponse = e.MsgFundCommunityPool = e.MsgWithdrawValidatorCommissionResponse = e.MsgWithdrawValidatorCommission = e.MsgWithdrawDelegatorRewardResponse = e.MsgWithdrawDelegatorReward = e.MsgSetWithdrawAddressResponse = e.MsgSetWithdrawAddress = e.protobufPackage = void 0;
    const n = Ad(), t = $l(), i = Mr(), s = Vr();
    e.protobufPackage = "cosmos.distribution.v1beta1";
    function o() {
      return {
        delegatorAddress: "",
        withdrawAddress: ""
      };
    }
    e.MsgSetWithdrawAddress = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
      encode(u, d = i.BinaryWriter.create()) {
        return u.delegatorAddress !== "" && d.uint32(10).string(u.delegatorAddress), u.withdrawAddress !== "" && d.uint32(18).string(u.withdrawAddress), d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = o();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.delegatorAddress = h.string();
              break;
            case 2:
              v.withdrawAddress = h.string();
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = o();
        return (0, s.isSet)(u.delegatorAddress) && (d.delegatorAddress = String(u.delegatorAddress)), (0, s.isSet)(u.withdrawAddress) && (d.withdrawAddress = String(u.withdrawAddress)), d;
      },
      toJSON(u) {
        const d = {};
        return u.delegatorAddress !== void 0 && (d.delegatorAddress = u.delegatorAddress), u.withdrawAddress !== void 0 && (d.withdrawAddress = u.withdrawAddress), d;
      },
      fromPartial(u) {
        const d = o();
        return d.delegatorAddress = u.delegatorAddress ?? "", d.withdrawAddress = u.withdrawAddress ?? "", d;
      }
    };
    function r() {
      return {};
    }
    e.MsgSetWithdrawAddressResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgSetWithdrawAddressResponse",
      encode(u, d = i.BinaryWriter.create()) {
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = r();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        return r();
      },
      toJSON(u) {
        return {};
      },
      fromPartial(u) {
        return r();
      }
    };
    function p() {
      return {
        delegatorAddress: "",
        validatorAddress: ""
      };
    }
    e.MsgWithdrawDelegatorReward = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
      encode(u, d = i.BinaryWriter.create()) {
        return u.delegatorAddress !== "" && d.uint32(10).string(u.delegatorAddress), u.validatorAddress !== "" && d.uint32(18).string(u.validatorAddress), d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = p();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.delegatorAddress = h.string();
              break;
            case 2:
              v.validatorAddress = h.string();
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = p();
        return (0, s.isSet)(u.delegatorAddress) && (d.delegatorAddress = String(u.delegatorAddress)), (0, s.isSet)(u.validatorAddress) && (d.validatorAddress = String(u.validatorAddress)), d;
      },
      toJSON(u) {
        const d = {};
        return u.delegatorAddress !== void 0 && (d.delegatorAddress = u.delegatorAddress), u.validatorAddress !== void 0 && (d.validatorAddress = u.validatorAddress), d;
      },
      fromPartial(u) {
        const d = p();
        return d.delegatorAddress = u.delegatorAddress ?? "", d.validatorAddress = u.validatorAddress ?? "", d;
      }
    };
    function y() {
      return {
        amount: []
      };
    }
    e.MsgWithdrawDelegatorRewardResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse",
      encode(u, d = i.BinaryWriter.create()) {
        for (const h of u.amount)
          n.Coin.encode(h, d.uint32(10).fork()).ldelim();
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = y();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.amount.push(n.Coin.decode(h, h.uint32()));
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = y();
        return Array.isArray(u == null ? void 0 : u.amount) && (d.amount = u.amount.map((h) => n.Coin.fromJSON(h))), d;
      },
      toJSON(u) {
        const d = {};
        return u.amount ? d.amount = u.amount.map((h) => h ? n.Coin.toJSON(h) : void 0) : d.amount = [], d;
      },
      fromPartial(u) {
        var h;
        const d = y();
        return d.amount = ((h = u.amount) == null ? void 0 : h.map((S) => n.Coin.fromPartial(S))) || [], d;
      }
    };
    function R() {
      return {
        validatorAddress: ""
      };
    }
    e.MsgWithdrawValidatorCommission = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
      encode(u, d = i.BinaryWriter.create()) {
        return u.validatorAddress !== "" && d.uint32(10).string(u.validatorAddress), d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = R();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.validatorAddress = h.string();
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = R();
        return (0, s.isSet)(u.validatorAddress) && (d.validatorAddress = String(u.validatorAddress)), d;
      },
      toJSON(u) {
        const d = {};
        return u.validatorAddress !== void 0 && (d.validatorAddress = u.validatorAddress), d;
      },
      fromPartial(u) {
        const d = R();
        return d.validatorAddress = u.validatorAddress ?? "", d;
      }
    };
    function P() {
      return {
        amount: []
      };
    }
    e.MsgWithdrawValidatorCommissionResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommissionResponse",
      encode(u, d = i.BinaryWriter.create()) {
        for (const h of u.amount)
          n.Coin.encode(h, d.uint32(10).fork()).ldelim();
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = P();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.amount.push(n.Coin.decode(h, h.uint32()));
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = P();
        return Array.isArray(u == null ? void 0 : u.amount) && (d.amount = u.amount.map((h) => n.Coin.fromJSON(h))), d;
      },
      toJSON(u) {
        const d = {};
        return u.amount ? d.amount = u.amount.map((h) => h ? n.Coin.toJSON(h) : void 0) : d.amount = [], d;
      },
      fromPartial(u) {
        var h;
        const d = P();
        return d.amount = ((h = u.amount) == null ? void 0 : h.map((S) => n.Coin.fromPartial(S))) || [], d;
      }
    };
    function m() {
      return {
        amount: [],
        depositor: ""
      };
    }
    e.MsgFundCommunityPool = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
      encode(u, d = i.BinaryWriter.create()) {
        for (const h of u.amount)
          n.Coin.encode(h, d.uint32(10).fork()).ldelim();
        return u.depositor !== "" && d.uint32(18).string(u.depositor), d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = m();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.amount.push(n.Coin.decode(h, h.uint32()));
              break;
            case 2:
              v.depositor = h.string();
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = m();
        return Array.isArray(u == null ? void 0 : u.amount) && (d.amount = u.amount.map((h) => n.Coin.fromJSON(h))), (0, s.isSet)(u.depositor) && (d.depositor = String(u.depositor)), d;
      },
      toJSON(u) {
        const d = {};
        return u.amount ? d.amount = u.amount.map((h) => h ? n.Coin.toJSON(h) : void 0) : d.amount = [], u.depositor !== void 0 && (d.depositor = u.depositor), d;
      },
      fromPartial(u) {
        var h;
        const d = m();
        return d.amount = ((h = u.amount) == null ? void 0 : h.map((S) => n.Coin.fromPartial(S))) || [], d.depositor = u.depositor ?? "", d;
      }
    };
    function T() {
      return {};
    }
    e.MsgFundCommunityPoolResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgFundCommunityPoolResponse",
      encode(u, d = i.BinaryWriter.create()) {
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = T();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        return T();
      },
      toJSON(u) {
        return {};
      },
      fromPartial(u) {
        return T();
      }
    };
    function O() {
      return {
        authority: "",
        params: t.Params.fromPartial({})
      };
    }
    e.MsgUpdateParams = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParams",
      encode(u, d = i.BinaryWriter.create()) {
        return u.authority !== "" && d.uint32(10).string(u.authority), u.params !== void 0 && t.Params.encode(u.params, d.uint32(18).fork()).ldelim(), d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = O();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.authority = h.string();
              break;
            case 2:
              v.params = t.Params.decode(h, h.uint32());
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = O();
        return (0, s.isSet)(u.authority) && (d.authority = String(u.authority)), (0, s.isSet)(u.params) && (d.params = t.Params.fromJSON(u.params)), d;
      },
      toJSON(u) {
        const d = {};
        return u.authority !== void 0 && (d.authority = u.authority), u.params !== void 0 && (d.params = u.params ? t.Params.toJSON(u.params) : void 0), d;
      },
      fromPartial(u) {
        const d = O();
        return d.authority = u.authority ?? "", u.params !== void 0 && u.params !== null && (d.params = t.Params.fromPartial(u.params)), d;
      }
    };
    function j() {
      return {};
    }
    e.MsgUpdateParamsResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgUpdateParamsResponse",
      encode(u, d = i.BinaryWriter.create()) {
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = j();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        return j();
      },
      toJSON(u) {
        return {};
      },
      fromPartial(u) {
        return j();
      }
    };
    function ee() {
      return {
        authority: "",
        recipient: "",
        amount: []
      };
    }
    e.MsgCommunityPoolSpend = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpend",
      encode(u, d = i.BinaryWriter.create()) {
        u.authority !== "" && d.uint32(10).string(u.authority), u.recipient !== "" && d.uint32(18).string(u.recipient);
        for (const h of u.amount)
          n.Coin.encode(h, d.uint32(26).fork()).ldelim();
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = ee();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.authority = h.string();
              break;
            case 2:
              v.recipient = h.string();
              break;
            case 3:
              v.amount.push(n.Coin.decode(h, h.uint32()));
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = ee();
        return (0, s.isSet)(u.authority) && (d.authority = String(u.authority)), (0, s.isSet)(u.recipient) && (d.recipient = String(u.recipient)), Array.isArray(u == null ? void 0 : u.amount) && (d.amount = u.amount.map((h) => n.Coin.fromJSON(h))), d;
      },
      toJSON(u) {
        const d = {};
        return u.authority !== void 0 && (d.authority = u.authority), u.recipient !== void 0 && (d.recipient = u.recipient), u.amount ? d.amount = u.amount.map((h) => h ? n.Coin.toJSON(h) : void 0) : d.amount = [], d;
      },
      fromPartial(u) {
        var h;
        const d = ee();
        return d.authority = u.authority ?? "", d.recipient = u.recipient ?? "", d.amount = ((h = u.amount) == null ? void 0 : h.map((S) => n.Coin.fromPartial(S))) || [], d;
      }
    };
    function l() {
      return {};
    }
    e.MsgCommunityPoolSpendResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgCommunityPoolSpendResponse",
      encode(u, d = i.BinaryWriter.create()) {
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = l();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        return l();
      },
      toJSON(u) {
        return {};
      },
      fromPartial(u) {
        return l();
      }
    };
    function c() {
      return {
        depositor: "",
        validatorAddress: "",
        amount: []
      };
    }
    e.MsgDepositValidatorRewardsPool = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgDepositValidatorRewardsPool",
      encode(u, d = i.BinaryWriter.create()) {
        u.depositor !== "" && d.uint32(10).string(u.depositor), u.validatorAddress !== "" && d.uint32(18).string(u.validatorAddress);
        for (const h of u.amount)
          n.Coin.encode(h, d.uint32(26).fork()).ldelim();
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = c();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            case 1:
              v.depositor = h.string();
              break;
            case 2:
              v.validatorAddress = h.string();
              break;
            case 3:
              v.amount.push(n.Coin.decode(h, h.uint32()));
              break;
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        const d = c();
        return (0, s.isSet)(u.depositor) && (d.depositor = String(u.depositor)), (0, s.isSet)(u.validatorAddress) && (d.validatorAddress = String(u.validatorAddress)), Array.isArray(u == null ? void 0 : u.amount) && (d.amount = u.amount.map((h) => n.Coin.fromJSON(h))), d;
      },
      toJSON(u) {
        const d = {};
        return u.depositor !== void 0 && (d.depositor = u.depositor), u.validatorAddress !== void 0 && (d.validatorAddress = u.validatorAddress), u.amount ? d.amount = u.amount.map((h) => h ? n.Coin.toJSON(h) : void 0) : d.amount = [], d;
      },
      fromPartial(u) {
        var h;
        const d = c();
        return d.depositor = u.depositor ?? "", d.validatorAddress = u.validatorAddress ?? "", d.amount = ((h = u.amount) == null ? void 0 : h.map((S) => n.Coin.fromPartial(S))) || [], d;
      }
    };
    function f() {
      return {};
    }
    e.MsgDepositValidatorRewardsPoolResponse = {
      typeUrl: "/cosmos.distribution.v1beta1.MsgDepositValidatorRewardsPoolResponse",
      encode(u, d = i.BinaryWriter.create()) {
        return d;
      },
      decode(u, d) {
        const h = u instanceof i.BinaryReader ? u : new i.BinaryReader(u);
        let S = d === void 0 ? h.len : h.pos + d;
        const v = f();
        for (; h.pos < S; ) {
          const D = h.uint32();
          switch (D >>> 3) {
            default:
              h.skipType(D & 7);
              break;
          }
        }
        return v;
      },
      fromJSON(u) {
        return f();
      },
      toJSON(u) {
        return {};
      },
      fromPartial(u) {
        return f();
      }
    };
    class x {
      constructor(d) {
        this.rpc = d, this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this), this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this), this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this), this.FundCommunityPool = this.FundCommunityPool.bind(this), this.UpdateParams = this.UpdateParams.bind(this), this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this), this.DepositValidatorRewardsPool = this.DepositValidatorRewardsPool.bind(this);
      }
      SetWithdrawAddress(d) {
        const h = e.MsgSetWithdrawAddress.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", h).then((v) => e.MsgSetWithdrawAddressResponse.decode(new i.BinaryReader(v)));
      }
      WithdrawDelegatorReward(d) {
        const h = e.MsgWithdrawDelegatorReward.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", h).then((v) => e.MsgWithdrawDelegatorRewardResponse.decode(new i.BinaryReader(v)));
      }
      WithdrawValidatorCommission(d) {
        const h = e.MsgWithdrawValidatorCommission.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", h).then((v) => e.MsgWithdrawValidatorCommissionResponse.decode(new i.BinaryReader(v)));
      }
      FundCommunityPool(d) {
        const h = e.MsgFundCommunityPool.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", h).then((v) => e.MsgFundCommunityPoolResponse.decode(new i.BinaryReader(v)));
      }
      UpdateParams(d) {
        const h = e.MsgUpdateParams.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", h).then((v) => e.MsgUpdateParamsResponse.decode(new i.BinaryReader(v)));
      }
      CommunityPoolSpend(d) {
        const h = e.MsgCommunityPoolSpend.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", h).then((v) => e.MsgCommunityPoolSpendResponse.decode(new i.BinaryReader(v)));
      }
      DepositValidatorRewardsPool(d) {
        const h = e.MsgDepositValidatorRewardsPool.encode(d).finish();
        return this.rpc.request("cosmos.distribution.v1beta1.Msg", "DepositValidatorRewardsPool", h).then((v) => e.MsgDepositValidatorRewardsPoolResponse.decode(new i.BinaryReader(v)));
      }
    }
    e.MsgClientImpl = x;
  }(Zn)), Zn;
}
var Nd = Ql();
const ql = ({
  delegatorAddress: e,
  validatorAddress: n,
  amount: t
}) => {
  const i = An.fromPartial({
    msg: {
      delegatorAddress: e,
      validatorAddress: n,
      amount: {
        denom: "ubbn",
        amount: t.toString()
      }
    }
  });
  return {
    typeUrl: $.MsgStakeBABY,
    value: i
  };
}, Xl = ({
  delegatorAddress: e,
  validatorAddress: n,
  amount: t
}) => {
  const i = Nn.fromPartial({
    msg: {
      delegatorAddress: e,
      validatorAddress: n,
      amount: {
        denom: "ubbn",
        amount: t.toString()
      }
    }
  });
  return {
    typeUrl: $.MsgUnstakeBABY,
    value: i
  };
}, Kl = (e) => {
  const n = Nd.MsgWithdrawDelegatorReward.fromPartial(e);
  return {
    typeUrl: $.MsgWithdrawRewardForBABYStaking,
    value: n
  };
}, Zl = {
  createStakeMsg: ql,
  createUnstakeMsg: Xl,
  createClaimRewardMsg: Kl
}, zl = ({ address: e }) => {
  const n = xn.fromPartial({
    type: Ml,
    address: e
  });
  return {
    typeUrl: $.MsgWithdrawRewardForBTCStaking,
    value: n
  };
}, Yl = (e) => {
  const n = Dn.fromPartial(e);
  return {
    typeUrl: $.MsgBtcStakeExpand,
    value: n
  };
}, jl = {
  createClaimRewardMsg: zl,
  createExpandMsg: Yl
}, Hc = {
  baby: Zl,
  btc: jl
}, ec = {
  [$.MsgCreateBTCDelegation]: {
    aminoType: $.MsgCreateBTCDelegation,
    toAmino: (e) => {
      var t;
      const n = e.pop;
      if (!n)
        throw new Error("Proof of possession is undefined");
      return {
        staker_addr: e.stakerAddr,
        btc_pk: Buffer.from(e.btcPk).toString("base64"),
        pop: {
          btc_sig_type: n.btcSigType,
          btc_sig: Buffer.from(n.btcSig).toString("base64")
        },
        fp_btc_pk_list: e.fpBtcPkList.map(
          (i) => Buffer.from(i).toString("base64")
        ),
        staking_time: e.stakingTime,
        staking_value: e.stakingValue.toString(),
        staking_tx: Buffer.from(e.stakingTx).toString("base64"),
        slashing_tx: Buffer.from(e.slashingTx).toString("base64"),
        delegator_slashing_sig: Buffer.from(e.delegatorSlashingSig).toString(
          "base64"
        ),
        unbonding_time: e.unbondingTime,
        unbonding_tx: Buffer.from(e.unbondingTx).toString("base64"),
        unbonding_value: e.unbondingValue.toString(),
        unbonding_slashing_tx: Buffer.from(e.unbondingSlashingTx).toString(
          "base64"
        ),
        delegator_unbonding_slashing_sig: Buffer.from(
          e.delegatorUnbondingSlashingSig
        ).toString("base64"),
        ...(t = e.stakingTxInclusionProof) != null && t.key ? {
          staking_tx_inclusion_proof: {
            key: {
              index: e.stakingTxInclusionProof.key.index,
              hash: Buffer.from(
                e.stakingTxInclusionProof.key.hash
              ).toString("base64")
            },
            proof: Buffer.from(e.stakingTxInclusionProof.proof).toString(
              "base64"
            )
          }
        } : {}
      };
    },
    fromAmino: (e) => {
      var t;
      const n = (t = e.staking_tx_inclusion_proof) == null ? void 0 : t.key.hash;
      return {
        stakerAddr: e.staker_addr,
        btcPk: Buffer.from(e.btc_pk, "base64"),
        pop: {
          btcSigType: e.pop.btc_sig_type,
          btcSig: Buffer.from(e.pop.btc_sig, "base64")
        },
        fpBtcPkList: e.fp_btc_pk_list.map(
          (i) => Buffer.from(i, "base64")
        ),
        stakingTime: e.staking_time,
        stakingValue: Number.parseInt(e.staking_value, 10),
        stakingTx: Buffer.from(e.staking_tx, "base64"),
        stakingTxInclusionProof: n ? {
          key: {
            index: e.staking_tx_inclusion_proof.key.index,
            hash: Buffer.from(
              e.staking_tx_inclusion_proof.key.hash,
              "base64"
            )
          },
          proof: Buffer.from(
            e.staking_tx_inclusion_proof.proof,
            "base64"
          )
        } : void 0,
        slashingTx: Buffer.from(e.slashing_tx, "base64"),
        delegatorSlashingSig: Buffer.from(
          e.delegator_slashing_sig,
          "base64"
        ),
        unbondingTime: e.unbonding_time,
        unbondingTx: Buffer.from(e.unbonding_tx, "base64"),
        unbondingValue: Number.parseInt(e.unbonding_value, 10),
        unbondingSlashingTx: Buffer.from(e.unbonding_slashing_tx, "base64"),
        delegatorUnbondingSlashingSig: Buffer.from(
          e.delegator_unbonding_slashing_sig,
          "base64"
        )
      };
    }
  }
}, nc = {
  [$.MsgBtcStakeExpand]: {
    aminoType: $.MsgBtcStakeExpand,
    toAmino: (e) => {
      const n = e.pop;
      if (!n)
        throw new Error("Proof of possession is undefined");
      return {
        staker_addr: e.stakerAddr,
        btc_pk: Buffer.from(e.btcPk).toString("base64"),
        pop: {
          btc_sig_type: n.btcSigType,
          btc_sig: Buffer.from(n.btcSig).toString("base64")
        },
        fp_btc_pk_list: e.fpBtcPkList.map(
          (t) => Buffer.from(t).toString("base64")
        ),
        staking_time: e.stakingTime,
        staking_value: e.stakingValue.toString(),
        staking_tx: Buffer.from(e.stakingTx).toString("base64"),
        slashing_tx: Buffer.from(e.slashingTx).toString("base64"),
        delegator_slashing_sig: Buffer.from(e.delegatorSlashingSig).toString(
          "base64"
        ),
        unbonding_time: e.unbondingTime,
        unbonding_tx: Buffer.from(e.unbondingTx).toString("base64"),
        unbonding_value: e.unbondingValue.toString(),
        unbonding_slashing_tx: Buffer.from(e.unbondingSlashingTx).toString(
          "base64"
        ),
        delegator_unbonding_slashing_sig: Buffer.from(
          e.delegatorUnbondingSlashingSig
        ).toString("base64"),
        previous_staking_tx_hash: e.previousStakingTxHash,
        funding_tx: Buffer.from(e.fundingTx).toString("base64")
      };
    },
    fromAmino: (e) => ({
      stakerAddr: e.staker_addr,
      btcPk: Buffer.from(e.btc_pk, "base64"),
      pop: {
        btcSigType: e.pop.btc_sig_type,
        btcSig: Buffer.from(e.pop.btc_sig, "base64")
      },
      fpBtcPkList: e.fp_btc_pk_list.map(
        (n) => Buffer.from(n, "base64")
      ),
      stakingTime: e.staking_time,
      stakingValue: Number.parseInt(e.staking_value, 10),
      stakingTx: Buffer.from(e.staking_tx, "base64"),
      slashingTx: Buffer.from(e.slashing_tx, "base64"),
      delegatorSlashingSig: Buffer.from(
        e.delegator_slashing_sig,
        "base64"
      ),
      unbondingTime: e.unbonding_time,
      unbondingTx: Buffer.from(e.unbonding_tx, "base64"),
      unbondingValue: Number.parseInt(e.unbonding_value, 10),
      unbondingSlashingTx: Buffer.from(e.unbonding_slashing_tx, "base64"),
      delegatorUnbondingSlashingSig: Buffer.from(
        e.delegator_unbonding_slashing_sig,
        "base64"
      ),
      previousStakingTxHash: e.previous_staking_tx_hash,
      fundingTx: Buffer.from(e.funding_tx, "base64")
    })
  }
}, tc = {
  [$.MsgWithdrawRewardForBTCStaking]: {
    aminoType: $.MsgWithdrawRewardForBTCStaking,
    toAmino: (e) => ({
      type: e.type,
      address: e.address
    }),
    fromAmino: (e) => ({
      type: e.type,
      address: e.address
    })
  }
}, rc = {
  [$.MsgStakeBABY]: {
    aminoType: $.MsgStakeBABY,
    toAmino: (e) => {
      var n, t, i;
      return {
        msg: {
          delegator_address: (n = e.msg) == null ? void 0 : n.delegatorAddress,
          validator_address: (t = e.msg) == null ? void 0 : t.validatorAddress,
          amount: (i = e.msg) == null ? void 0 : i.amount
        }
      };
    },
    fromAmino: (e) => ({
      msg: {
        delegatorAddress: e.msg.delegator_address,
        validatorAddress: e.msg.validator_address,
        amount: e.msg.amount
      }
    })
  }
}, ic = {
  [$.MsgUnstakeBABY]: {
    aminoType: $.MsgUnstakeBABY,
    toAmino: (e) => {
      var n, t, i;
      return {
        msg: {
          delegator_address: (n = e.msg) == null ? void 0 : n.delegatorAddress,
          validator_address: (t = e.msg) == null ? void 0 : t.validatorAddress,
          amount: (i = e.msg) == null ? void 0 : i.amount
        }
      };
    },
    fromAmino: (e) => ({
      msg: {
        delegatorAddress: e.msg.delegator_address,
        validatorAddress: e.msg.validator_address,
        amount: e.msg.amount
      }
    })
  }
}, oc = {
  [$.MsgWithdrawRewardForBABYStaking]: {
    aminoType: $.MsgWithdrawRewardForBABYStaking,
    toAmino: (e) => ({
      delegator_address: e.delegatorAddress,
      validator_address: e.validatorAddress
    }),
    fromAmino: (e) => ({
      delegatorAddress: e.delegator_address,
      validatorAddress: e.validator_address
    })
  }
}, sc = {
  ...ec,
  ...nc,
  ...tc,
  ...rc,
  ...ic,
  ...oc
}, ac = () => new Id({
  ...sc
}), xd = 1e6;
function dc(e) {
  return BigInt(e * xd);
}
function lc(e) {
  return Number(e) / xd;
}
function Bd(e) {
  return (Number.parseFloat(e) / 1e18).toString();
}
function cc(e) {
  var n;
  return (n = e.rewards) == null ? void 0 : n.map((t) => {
    var i;
    return {
      ...t,
      reward: (i = t.reward) == null ? void 0 : i.map((s) => ({
        ...s,
        amount: Bd(s.amount)
      }))
    };
  });
}
const uc = [
  // BTC Staking - Creating a BTC delegation
  {
    typeUrl: $.MsgCreateBTCDelegation,
    messageType: Vn
  },
  // BTC Staking - Expanding a BTC delegation
  {
    typeUrl: $.MsgBtcStakeExpand,
    messageType: Dn
  },
  // Incentives - Withdrawing BABY rewards from BTC Staking
  {
    typeUrl: $.MsgWithdrawRewardForBTCStaking,
    messageType: xn
  },
  // Epoching - Staking / Unstaking BABY
  {
    typeUrl: $.MsgStakeBABY,
    messageType: An
  },
  {
    typeUrl: $.MsgUnstakeBABY,
    messageType: Nn
  },
  // Cosmos Distribution - Withdrawing rewards from BABY Staking
  {
    typeUrl: $.MsgWithdrawRewardForBABYStaking,
    messageType: Nd.MsgWithdrawDelegatorReward
  }
], hc = (e) => ({
  encode: e.encode.bind(e),
  decode: e.decode.bind(e),
  fromPartial: (n) => e.fromPartial(n ?? {})
}), fc = () => {
  const e = new Ud();
  return uc.forEach((n) => {
    const t = hc(n.messageType);
    e.register(n.typeUrl, t);
  }), e;
}, Mc = {
  ubbnToBaby: lc,
  babyToUbbn: dc,
  createAminoTypes: ac,
  createRegistry: fc,
  normalizeRewardResponse: cc,
  normalizeCosmjsAmount: Bd,
  // Pagination utilities
  fetchAllPages: Tn,
  buildPaginationParams: Dd
};
export {
  _c as btccheckpoint,
  bc as btclightclient,
  vc as btclightclientquery,
  Pc as btcstaking,
  wc as btcstakingpop,
  Ac as btcstakingtx,
  Tc as cosmosstaking,
  xc as cosmosstakingtx,
  Cc as createLCDClient,
  Uc as createRPCClient,
  Rc as epochingquery,
  Ec as epochingtx,
  yc as googleProtoAny,
  Jc as incentivequery,
  Ic as incentivetx,
  Hc as txs,
  Mc as utils
};
//# sourceMappingURL=index.js.map
